import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import pLimit from 'p-limit';
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd"; //"react-beautiful-dnd";
import { ReactComponent as RequiredIcon } from "./required.svg";
import { XMarkIcon, EyeIcon } from "@heroicons/react/24/outline";
import NotRequiredIcon from "./notrequired";
import produce from "immer";

import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/24/outline";
import { Switch } from "@headlessui/react";
import { Auth } from "aws-amplify";
import {
  setCurrentSurvey,
  setNewQuestion,
  setSelectedSectionAndPage,
  updateTabStates,
  setQuestions,
} from "../../../store/actions";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import {
  addQuestionFromAPI,
  getQuestionsFromAPI,
} from "../../../services/questionService";
import {
  updateSurveyFromAPI
} from "../../../services/surveyService";
import SurveyPreview from "./surveyPreview";

export default function Design() {
  const themeMode = useSelector((state) => state.themeMode);
  // const currentSurvey = useSelector((state) => state.currentSurvey);
  // const selectedSectionAndPage = useSelector(
  //     (state) => state.selectedSectionAndPage
  // );
  // const newQuestion = useSelector((state) => state.newQuestion);
  const questions = useSelector((state) => state.questions);
  const organizations = useSelector((state) => state.organizations);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  const currentSurvey = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.currentSurvey;
  const selectedSectionAndPage = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.selectedSectionAndPage;
  const newQuestion = topMenuTabs.tabs.find(
    (tab) => tab.id === topMenuTabs.activeTab
  ).states.newQuestion;
  // const questions = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.questions;
  // const organizations = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.organizations;
  const dispatch = useDispatch();

  let [token, setToken] = useState("");
  const [editingSurvey, setEditingSurvey] = useState(null);
  const [inputValue, setInputValue] = useState(""); // Metni tutmak için state
  const scrollRef = useRef(null);
  const questionTypesMenuRef = useRef(null);
  const asIsToBeMenuRef = useRef(null);
  const textQuestionTypesMenuRef = useRef(null);
  const panelRefs = useRef({});
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [deleteAllowMenuOpen, setDeleteAllowMenuOpen] = useState(false);
  const [deleteInfoMenuShow, setDeleteInfoMenuShow] = useState(false);
  const [questionAddInfoMenuShow, setQuestionAddInfoMenuShow] = useState(false);
  const [infoText, setInfoText] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedParam, setSelectedParam] = useState({
    param: "",
    pageIndex: null,
    qIndex: null,
    index: null,
    questionType: null,
  });
  const [sections, setSections] = useState([]);

  const textTypeOptions = [
    { value: "text", label: "Text" },
    { value: "email", label: "Email" },
    { value: "date", label: "Date" },
    { value: "number", label: "Number" },
    { value: "tel", label: "Tel" },
  ];

  const [selectedTextType, setSelectedTextType] = useState(textTypeOptions[0]); // Default option
  const [query, setQuery] = useState("");
  const [selectedValues, setSelectedValues] = useState({
    showNoneItem: false,
    showOtherItem: false,
    showAllItem: false,
  });

  const textQuestionTypes = [
    {
      value: "text",
    },
    {
      value: "email",
    },
    {
      value: "date",
    },
    {
      value: "number",
    },
    {
      value: "tel",
    },
  ];

  const questionTypes = [
    {
      value: 1,
      name: "Multiple Choice",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      ),
    },
    {
      value: 2,
      name: "Star Rating",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
          />
        </svg>
      ),
    },
    {
      value: 3,
      name: "Checkbox",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m4.5 12.75 6 6 9-13.5"
          />
        </svg>
      ),
    },
    {
      value: 4,
      name: "Dropdown",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m4.5 15.75 7.5-7.5 7.5 7.5"
          />
        </svg>
      ),
    },
    {
      value: 5,
      name: "Multi-Select Dropdown",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
          />
        </svg>
      ),
    },
    {
      value: 6,
      name: "Yes-No",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      ),
    },
    {
      value: 7,
      name: "Ranking",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.25 18 9 11.25l4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22m0 0-5.94-2.281m5.94 2.28-2.28 5.941"
          />
        </svg>
      ),
    },
    {
      value: 8,
      name: "Single Line",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
          />
        </svg>
      ),
    },
    {
      value: 9,
      name: "Long Text",
      img: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-5"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
          />
        </svg>
      ),
    },
      {
            value: 10,
            name: "Nested Question",
            img: (
               <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-5">
  <path strokeLinecap="round" strokeLinejoin="round" d="M8.242 5.992h12m-12 6.003H20.24m-12 5.999h12M4.117 7.495v-3.75H2.99m1.125 3.75H2.99m1.125 0H5.24m-1.92 2.577a1.125 1.125 0 1 1 1.591 1.59l-1.83 1.83h2.16M2.99 15.745h1.125a1.125 1.125 0 0 1 0 2.25H3.74m0-.002h.375a1.125 1.125 0 0 1 0 2.25H2.99" />
</svg>

            ),
        },
  ];

  const [selectedQuestionType, setSelectedQuestionType] = useState(
    questionTypes[0]
  ); // Default option
  const [showQuestionTypes, setShowQuestionTypes] = useState(false);
  const [showAsIsToBeOptions, setShowAsIsToBeOptions] = useState(false);
  const [showTextQuestionTypes, setShowTextQuestionTypes] = useState(false);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const [selectedFunction, setSelectedFunction] = useState("");
  const [selectedFunctionParams, setSelectedFunctionParams] = useState("");

  const filteredTextTypeOptions =
    query === ""
      ? textTypeOptions
      : textTypeOptions.filter((textType) => {
        return textType.label.toLowerCase().includes(query.toLowerCase());
      });

  async function checkAuth() {
    // window.location.reload();
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      await cognitoUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          const { idToken, refreshToken, accessToken } = session;
          getToken(idToken.jwtToken);
        }
      );
    } catch (e) {
      // console.log('Unable to refresh Token', e);
    }
  }

  async function getToken(token) {

      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    
  }

  useEffect(() => {
      const fetchToken = async () => {
        try {
          const currentSession = await Auth.currentSession();
          setToken(currentSession.idToken.jwtToken);
        } catch (err) {
          // console.error("Token alınamadı:", err);
        }
      };
      fetchToken();
    

    // Tıklama olayını dinle
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Component unmount olduğunda event listener'ı kaldır
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      await getQuestions();
    };
    const saveData = async (param) => {
      await saveChanges(param);
    };
    if (token.length > 0) {
      if (selectedFunction === "getQuestions") {
        fetchData()
        // getQuestions();
      } else if (selectedFunction === "saveChanges") {
        saveData(selectedFunctionParams)
      }
      setSelectedFunction("");
    }
  }, [token]);



  useEffect(() => {
    if (questions) {
      setFilteredQuestions(questions);
    }
  }, [questions]);

  const undoChanges = () => {
    setEditingSurvey(structuredClone(currentSurvey));
    arrangeSections();
  };

  const scrollToBottom = () => {
    // scrollRef.current?.scrollIntoView({ behavior: "smooth" });
    setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight + 1000,
        behavior: "smooth", // Smooth scroll effect
      });
    }, 1);
  };
  const scrollToPanelDynamic = (pageIndex, questionIndex) => {
  const el = panelRefs.current[`paneldynamic-${pageIndex}-${questionIndex}`];
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "end" });
  }
};

  // console.log(filteredOptions);
  const arrangeSections = (survey) => {
    // setSections([]);
    let newSections = [];
    const _currentSurvey = structuredClone(currentSurvey);
    _currentSurvey?.content?.pages
      ?.filter((x) => x.name !== "intro")
      .forEach((section, index) => {
        let _newSection = {
          name: section.title,
          pages: [],
        };
        section.elements[0].elements?.forEach((element, index) => {
          let isPanelDynamic = false
          if (element.type === "html") {
            let _newPage = {
              name: element.name,
              questions: [],
            };
            _newSection.pages.push(_newPage);
          } else if (element.type === "panel") {
            let _newQuestion = {};
            if (
              element.elements[0].type === "radiogroup" ||
              element.elements[0].type === "dropdown"
            ) {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                weight: element.elements[0].weight
                  ? element.elements[0].weight
                  : 1.0,
                editing_weight: element.elements[0].weight
                  ? element.elements[0].weight
                  : 1.0,
                asIsToBe: element.elements[0].asIsToBe
                  ? element.elements[0].asIsToBe
                  : false,
                editing_asIsToBe: element.elements[0].asIsToBe
                  ? element.elements[0].asIsToBe
                  : false,
                elements: structuredClone(element.elements[0].choices),
                editing_elements: structuredClone(element.elements[0].choices),
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                isEditing: false,
                is_exist: false,
              };
            }
            if (element.elements[0].type === "tagbox") {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                elements: structuredClone(element.elements[0].choices),
                editing_elements: structuredClone(element.elements[0].choices),
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                isEditing: false,
                is_exist: false,
              };
            }
            if (element.elements[0].type === "rating") {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                weight: element.elements[0].weight
                  ? element.elements[0].weight
                  : 1.0,
                editing_weight: element.elements[0].weight
                  ? element.elements[0].weight
                  : 1.0,
                 asIsToBe: element.elements[0].asIsToBe
                  ? element.elements[0].asIsToBe
                  : false,
                editing_asIsToBe: element.elements[0].asIsToBe
                  ? element.elements[0].asIsToBe
                  : false,  
                rateCount: element.elements[0].rateCount,
                editing_rateCount: element.elements[0].rateCount,
                rateMax: element.elements[0].rateMax,
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                rateType: "stars",
                isEditing: false,
                is_exist: false,
              };
            }
            if (element.elements[0].type === "boolean") {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                renderAs: element.elements[0].renderAs,
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                isEditing: false,
                is_exist: false,
              };
            }
            if (element.elements[0].type === "checkbox") {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                elements: structuredClone(element.elements[0].choices),
                editing_elements: structuredClone(element.elements[0].choices),
                colCount: element.elements[0].colCount,
                showOtherItem: element.elements[0].showOtherItem,
                editing_showOtherItem: element.elements[0].showOtherItem,
                showNoneItem: element.elements[0].showNoneItem,
                editing_showNoneItem: element.elements[0].showNoneItem,
                showSelectAllItem: element.elements[0].showSelectAllItem,
                editing_showSelectAllItem:
                  element.elements[0].showSelectAllItem,
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                isEditing: false,
                is_exist: false,
              };
            }
            if (element.elements[0].type === "ranking") {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                elements: structuredClone(element.elements[0].choices),
                editing_elements: structuredClone(element.elements[0].choices),
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                isEditing: false,
                is_exist: false,
              };
            }
            if (element.elements[0].type === "comment") {
              _newQuestion = {
                name: element.elements[0].title,
                editing_name: element.elements[0].title,
                type: element.elements[0].type,
                editing_type: element.elements[0].type,
                rows: element.elements[0].rows,
                allowResize: element.elements[0].allowResize,
                maxLength: element.elements[0].maxLength,
                isRequired: element.elements[0].isRequired
                  ? element.elements[0].isRequired
                  : false,
                isEditing: false,
                is_exist: false,
              };
            }
            if (element.elements[0].type === "text") {
              if (element.elements[0].inputType) {
                let inputType = element.elements[0].inputType;
                if ( inputType === "text"){
                   _newQuestion = {
                    name: element.elements[0].title,
                    editing_name: element.elements[0].title,
                    type: element.elements[0].type,
                    editing_type: element.elements[0].type,
                    maxLength: element.elements[0].maxLength,
                    isRequired: element.elements[0].isRequired
                      ? element.elements[0].isRequired
                      : false,
                    isEditing: false,
                    is_exist: false,
                    inputType: inputType,
                    editing_inputType: inputType,
                  };
                }
                else if (inputType === "email") {
                  _newQuestion = {
                    name: element.elements[0].title,
                    editing_name: element.elements[0].title,
                    type: element.elements[0].type,
                    editing_type: element.elements[0].type,
                    maxLength: element.elements[0].maxLength,
                    isRequired: element.elements[0].isRequired
                      ? element.elements[0].isRequired
                      : false,
                    isEditing: false,
                    is_exist: false,
                    inputType: inputType,
                    editing_inputType: inputType,
                  };
                } else if (inputType === "tel") {
                  _newQuestion = {
                    name: element.elements[0].title,
                    editing_name: element.elements[0].title,
                    type: element.elements[0].type,
                    editing_type: element.elements[0].type,
                    maxLength: element.elements[0].maxLength,
                    isRequired: element.elements[0].isRequired
                      ? element.elements[0].isRequired
                      : false,
                    validators: element.elements[0].validators,
                    isEditing: false,
                    is_exist: false,
                    inputType: inputType,
                    editing_inputType: inputType,
                  };
                } else if (inputType === "date") {
                  _newQuestion = {
                    name: element.elements[0].title,
                    editing_name: element.elements[0].title,
                    type: element.elements[0].type,
                    editing_type: element.elements[0].type,
                    maxLength: element.elements[0].maxLength,
                    isRequired: element.elements[0].isRequired
                      ? element.elements[0].isRequired
                      : false,
                    validators: element.elements[0].validators,
                    isEditing: false,
                    is_exist: false,
                    inputType: inputType,
                    editing_inputType: inputType,
                  };
                } else if (inputType === "number") {
                  _newQuestion = {
                    name: element.elements[0].title,
                    editing_name: element.elements[0].title,
                    type: element.elements[0].type,
                    editing_type: element.elements[0].type,
                    min: element.elements[0].min,
                    max: element.elements[0].max,
                    isRequired: element.elements[0].isRequired
                      ? element.elements[0].isRequired
                      : false,
                    validators: element.elements[0].validators,
                    isEditing: false,
                    is_exist: false,
                    inputType: inputType,
                    editing_inputType: inputType,
                  };
                }
              } else {
                _newQuestion = {
                  name: element.elements[0].title,
                  editing_name: element.elements[0].title,
                  type: element.elements[0].type,
                  editing_type: element.elements[0].type,
                  maxLength: element.elements[0].maxLength,
                  isRequired: element.elements[0].isRequired
                    ? element.elements[0].isRequired
                    : false,
                  isEditing: false,
                  is_exist: false,
                  inputType: "text",
                  editing_inputType: "text",
                };
              }
            }
            if (!isPanelDynamic) {
              _newSection.pages[_newSection.pages.length - 1].questions.push(
                _newQuestion
              );
            }
          } else if (element.type === "paneldynamic") {
            let _newQuestion = {};
            const _panelQuestion = {
              name: element.name,
              editing_name: element.name,
              type: "paneldynamic",
              editing_type: "paneldynamic",
              isEditing: false,
              templateElements: element.templateElements.map(processTemplateElement)
            
            }
            _newSection.pages[_newSection.pages.length - 1].questions.push(
              _panelQuestion
            );
          }
        });
        newSections.push(_newSection);
      });
    setSections(newSections);
  };
function processTemplateElement(templateEl) {
  if (templateEl.type === "paneldynamic") {
    return {
      name: templateEl.title,
      editing_name: templateEl.title,
      type: "paneldynamic",
      editing_type: "paneldynamic",
      isEditing: false,
      templateElements: templateEl.templateElements.map(inner => processTemplateElement(inner))
    };
  }
  if (
      templateEl.type === "radiogroup" ||
      templateEl.type === "dropdown"
    ) {
      return {
        name: templateEl.title,
        editing_name: templateEl.title,
        type: templateEl.type,
        editing_type: templateEl.type,
        weight: templateEl.weight
          ? templateEl.weight
          : 1.0,
        editing_weight: templateEl.weight
          ? templateEl.weight
          : 1.0,
        asIsToBe: templateEl.asIsToBe
          ? templateEl.asIsToBe
          : false,
        editing_asIsToBe: templateEl.asIsToBe
          ? templateEl.asIsToBe
          : false,
        elements: structuredClone(templateEl.choices),
        editing_elements: structuredClone(templateEl.choices),
        isRequired: templateEl.isRequired
          ? templateEl.isRequired
          : false,
        isEditing: false,
        is_exist: false,
      };
    }
    if (templateEl.type === "tagbox") {
      return {
        name: templateEl.title,
        editing_name: templateEl.title,
        type: templateEl.type,
        editing_type: templateEl.type,
        elements: structuredClone(templateEl.choices),
        editing_elements: structuredClone(templateEl.choices),
        isRequired: templateEl.isRequired
          ? templateEl.isRequired
          : false,
        isEditing: false,
        is_exist: false,
      };
    }
    if (templateEl.type === "rating") {
      return {
        name: templateEl.title,
        editing_name: templateEl.title,
        type: templateEl.type,
        editing_type: templateEl.type,
        weight: templateEl.weight
          ? templateEl.weight
          : 1.0,
        editing_weight: templateEl.weight
          ? templateEl.weight
          : 1.0,
        rateCount: templateEl.rateCount,
        editing_rateCount: templateEl.rateCount,
        rateMax: templateEl.rateMax,
        isRequired: templateEl.isRequired
          ? templateEl.isRequired
          : false,
        rateType: "stars",
        isEditing: false,
        is_exist: false,
            asIsToBe: templateEl.asIsToBe
          ? templateEl.asIsToBe
          : false,
        editing_asIsToBe: templateEl.asIsToBe
          ? templateEl.asIsToBe
          : false,
      };
    }
    if (templateEl.type === "boolean") {
      return {
        name: templateEl.title,
        editing_name: templateEl.title,
        type: templateEl.type,
        editing_type: templateEl.type,
        renderAs: templateEl.renderAs,
        isRequired: templateEl.isRequired
          ? templateEl.isRequired
          : false,
        isEditing: false,
        is_exist: false,
      };
    }
    if (templateEl.type === "checkbox") {
      return {
        name: templateEl.title,
        editing_name: templateEl.title,
        type: templateEl.type,
        editing_type: templateEl.type,
        elements: templateEl.choices ? JSON.parse(JSON.stringify(templateEl.choices)): [],
        editing_elements:  templateEl.choices ? JSON.parse(JSON.stringify(templateEl.choices)): [],
        colCount: templateEl.colCount,
        showOtherItem: templateEl.showOtherItem,
        editing_showOtherItem: templateEl.showOtherItem,
        showNoneItem: templateEl.showNoneItem,
        editing_showNoneItem: templateEl.showNoneItem,
        showSelectAllItem: templateEl.showSelectAllItem,
        editing_showSelectAllItem:
          templateEl.showSelectAllItem,
        isRequired: templateEl.isRequired
          ? templateEl.isRequired
          : false,
        isEditing: false,
        is_exist: false,
      };
    }
    if (templateEl.type === "ranking") {
      return {
        name: templateEl.title,
        editing_name: templateEl.title,
        type: templateEl.type,
        editing_type: templateEl.type,
        elements: structuredClone(templateEl.choices || templateEl.elements),
        editing_elements: structuredClone(templateEl.choices || templateEl.elements),
        isRequired: templateEl.isRequired
          ? templateEl.isRequired
          : false,
        isEditing: false,
        is_exist: false,
      };
    }
    if (templateEl.type === "comment") {
      return {
        name: templateEl.title,
        editing_name: templateEl.title,
        type: templateEl.type,
        editing_type: templateEl.type,
        rows: templateEl.rows,
        allowResize: templateEl.allowResize,
        maxLength: templateEl.maxLength,
        isRequired: templateEl.isRequired
          ? templateEl.isRequired
          : false,
        isEditing: false,
        is_exist: false,
      };
    }
    if (templateEl.type === "text") {
      if (templateEl.inputType) {
        let inputType = templateEl.inputType;
        if (inputType === "email") {
          return {
            name: templateEl.title,
            editing_name: templateEl.title,
            type: templateEl.type,
            editing_type: templateEl.type,
            maxLength: templateEl.maxLength,
            isRequired: templateEl.isRequired
              ? templateEl.isRequired
              : false,
            isEditing: false,
            is_exist: false,
            inputType: inputType,
            editing_inputType: inputType,
          };
        } else if (inputType === "tel") {
          return {
            name: templateEl.title,
            editing_name: templateEl.title,
            type: templateEl.type,
            editing_type: templateEl.type,
            maxLength: templateEl.maxLength,
            isRequired: templateEl.isRequired
              ? templateEl.isRequired
              : false,
            validators: templateEl.validators,
            isEditing: false,
            is_exist: false,
            inputType: inputType,
            editing_inputType: inputType,
          };
        } else if (inputType === "date") {
          return {
            name: templateEl.title,
            editing_name: templateEl.title,
            type: templateEl.type,
            editing_type: templateEl.type,
            maxLength: templateEl.maxLength,
            isRequired: templateEl.isRequired
              ? templateEl.isRequired
              : false,
            validators: templateEl.validators,
            isEditing: false,
            is_exist: false,
            inputType: inputType,
            editing_inputType: inputType,
          };
        } else if (inputType === "number") {
          return {
            name: templateEl.title,
            editing_name: templateEl.title,
            type: templateEl.type,
            editing_type: templateEl.type,
            min: templateEl.min,
            max: templateEl.max,
            isRequired: templateEl.isRequired
              ? templateEl.isRequired
              : false,
            validators: templateEl.validators,
            isEditing: false,
            is_exist: false,
            inputType: inputType,
            editing_inputType: inputType,
          };
        }
      } else {
        return {
          name: templateEl.title,
          editing_name: templateEl.title,
          type: templateEl.type,
          editing_type: templateEl.type,
          maxLength: templateEl.maxLength,
          isRequired: templateEl.isRequired
            ? templateEl.isRequired
            : false,
          isEditing: false,
          is_exist: false,
          inputType: "text",
          editing_inputType: "text",
        };
      }
    }
}


  useEffect(() => {
    if (currentSurvey) {
      const _currentSurvey = structuredClone(currentSurvey);
      if (isFirstRender || _currentSurvey.willUpdate) {
        _currentSurvey["willUpdate"] = false;
        arrangeSections();
        setIsFirstRender(false);
      }

      setEditingSurvey(_currentSurvey);
    }
  }, [currentSurvey]);


  useEffect(() => {
    if (selectedSectionAndPage.sectionName !== "") {
      arrangeSections();
    }
  }, [selectedSectionAndPage]);

  const fixQuestionTypeName = (type) => {
    switch (type) {
      case "radiogroup":
        return "Multiple Choice";
      case "dropdown":
        return "Dropdown";
      case "checkbox":
        return "Checkbox";
      case "text":
        return "Single Line";
      case "comment":
        return "Long Text";
      case "rating":
        return "Star Rating";
      case "boolean":
        return "Yes-No";
      case "tagbox":
        return "Multi-Select Dropdown";
      case "ranking":
        return "Ranking";
      case "paneldynamic":
        return "Nested Question";
            case "Multiple Choice":
        return "radiogroup";
      case "Dropdown":
        return "dropdown";
      case "Checkbox":
        return "checkbox";
      case "Single Line":
        return "text";
      case "Long Text":
        return "comment";
      case "Star Rating":
        return "rating";
      case "Yes-No":
        return "boolean";
      case "Multi-Select Dropdown":
        return "tagbox";
      case "Ranking":
        return "ranking";
      case "Nested Question":
        return "paneldynamic";
      default:
        return "";
    }
  };

  const handleChange = (e) => {
    // const regex = /^\d+(\.\d{1,2})?$/; // Sayı formatı: X, X.X veya X.XX
    // if (regex.test(e.target.value) || e.target.value === "") {
    //     setValue(e.target.value);
    // }
  };

  const questionIsExist = (questionName) => {
    let isExist = false;
    let count = 0;
    for (const section of sections) {
      for (const page of section.pages) {
        for (const question of page.questions) {
          if (question.type === "paneldynamic") {
            for (const temp of question.templateElements) {
              if (temp.name === questionName) {
                isExist = true;
                ++count;
                if (count > 1) {
                  break;
                }
              }
            }
          }
          else if (question.name === questionName) {
            isExist = true;
            ++count;
            if (count > 1) {
              break;
            }
          }
        }
      }
    }
    return isExist;
  };

  // const onDragEnd = (result) => {
  //   const { source, destination } = result;
  //   if (!destination || !source) {
  //     return; // Eğer source veya destination yoksa, fonksiyon sonlandırılmalı
  //   }
  //   let _editingSurvey = structuredClone(editingSurvey);
  //   let _sections = structuredClone(sections);
  //   let qIndex = 0;
  //   let destIndex = destination?.index;
  //   let sourcPageIndex = source?.droppableId?.split("-")[1];
  //   let destPageIndex = destination?.droppableId?.split("-")[1];

  //   if (selectedSectionAndPage.pageName === "All") {
  //     const htmlIndexes = _editingSurvey.content.pages
  //       .find(
  //         (s) =>
  //           s.name.toLowerCase() ===
  //           selectedSectionAndPage.sectionName.toLowerCase()
  //       )
  //       .elements[0].elements.map((item, index) =>
  //         item.type === "html" ? index : null
  //       )
  //       .filter((index) => index !== null);
  //     qIndex = htmlIndexes[sourcPageIndex] + source.index + 1;
  //     destIndex = htmlIndexes[destPageIndex] + destination.index + 1;
  //   } else {
  //     qIndex =
  //       _editingSurvey.content.pages
  //         .find(
  //           (s) =>
  //             s.name.toLowerCase() ===
  //             selectedSectionAndPage.sectionName.toLowerCase()
  //         )
  //         .elements[0].elements.findIndex(
  //           (e) =>
  //             e.type === "html" && e.name === selectedSectionAndPage.pageName
  //         ) +
  //       source.index +
  //       1;
  //     destIndex =
  //       _editingSurvey.content.pages
  //         .find(
  //           (s) =>
  //             s.name.toLowerCase() ===
  //             selectedSectionAndPage.sectionName.toLowerCase()
  //         )
  //         .elements[0].elements.findIndex(
  //           (e) =>
  //             e.type === "html" && e.name === selectedSectionAndPage.pageName
  //         ) +
  //       destIndex +
  //       1;
  //     sourcPageIndex = _sections[
  //       selectedSectionAndPage.sectionIndex
  //     ].pages.findIndex((p) => p.name === selectedSectionAndPage.pageName);
  //     destPageIndex = sourcPageIndex;
  //   }

  //   const [movedItem] = _editingSurvey.content.pages.find((s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName.toLowerCase()).elements[0].elements.splice(qIndex, 1);
  //   _editingSurvey.content.pages.find((s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName.toLowerCase()).elements[0].elements.splice(destIndex, 0, movedItem);
  //   setEditingSurvey(_editingSurvey)

  //   const [sectionMovedItem] = _sections[
  //     selectedSectionAndPage.sectionIndex
  //   ].pages[sourcPageIndex].questions.splice(source.index, 1);
  //   _sections[selectedSectionAndPage.sectionIndex].pages[
  //     destPageIndex
  //   ].questions.splice(destination.index, 0, sectionMovedItem);
  //   setSections(_sections);

  //   saveChanges(_editingSurvey);
  // };
const onDragEnd = (result) => {
  const { source, destination } = result;
  if (!destination) return;
  let destIndex = destination?.index;
  let sourceIndex = source.index
  const sourceId = source.droppableId;
  const destId = destination.droppableId;
  let _editingSurvey = structuredClone(editingSurvey);
  let _sections = structuredClone(sections);
  let qIndex = 0
  if (
    sourceId.startsWith("paneldynamic-inner") &&
    destId.startsWith("paneldynamic-inner")
  ) {

    let [,, sourcePageIndex, panelQuestionIndex,panelLvl2QuestionIndex] = sourceId.split("-").map(Number);
    let [,, destPageIndex, destPanelQIndex,destPanelLvl2QuestionIndex] = destId.split("-").map(Number);
  const section = _sections[selectedSectionAndPage.sectionIndex];
  const page = section.pages[sourcePageIndex];
  const targetPanel = page.questions[panelQuestionIndex].templateElements[panelLvl2QuestionIndex];

  const surveySection = _editingSurvey.content.pages.find(
    (s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName.toLowerCase()
  );
  const surveyPanel = surveySection.elements[0].elements[panelQuestionIndex + 1].templateElements[panelLvl2QuestionIndex]; 
  // (+1 gerekli olabilir, eğer panel öncesinde html element varsa)

  const [moved] = targetPanel.templateElements.splice(source.index, 1);
  targetPanel.templateElements.splice(destination.index, 0, moved);

  const [movedSurvey] = surveyPanel.templateElements.splice(source.index, 1);
  surveyPanel.templateElements.splice(destination.index, 0, movedSurvey);


  setSections([..._sections]);
  setEditingSurvey({ ..._editingSurvey });
  saveChanges(_editingSurvey);
  return;
  }
else if (
  sourceId.startsWith("paneldynamic") &&
  destId.startsWith("paneldynamic")
) {
  // Farklı paneldynamic'ler arası taşımayı engelle
  if (sourceId !== destId) return;

  const [type, sourcePageIndex, panelQuestionIndex] = sourceId.split("-").map(Number);
  const [destType, destPageIndex, destPanelQIndex] = destId.split("-").map(Number);

  // ilgili panel objelerini bul
  const section = _sections[selectedSectionAndPage.sectionIndex];
  const page = section.pages[sourcePageIndex];
  const targetPanel = page.questions[panelQuestionIndex];

  const surveySection = _editingSurvey.content.pages.find(
    (s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName.toLowerCase()
  );
  const surveyPanel = surveySection.elements[0].elements[panelQuestionIndex + 1]; 


  // move işlemi - sadece local indexlerle
  const [moved] = targetPanel.templateElements.splice(source.index, 1);
  targetPanel.templateElements.splice(destination.index, 0, moved);

  const [movedSurvey] = surveyPanel.templateElements.splice(source.index, 1);
  surveyPanel.templateElements.splice(destination.index, 0, movedSurvey);

  setSections([..._sections]);
  setEditingSurvey({ ..._editingSurvey });
  saveChanges(_editingSurvey);
  return;
}

else{
    let sourcPageIndex = source?.droppableId?.split("-")[1];
    let destPageIndex = destination?.droppableId?.split("-")[1];

    if (selectedSectionAndPage.pageName === "All") {
      const htmlIndexes = _editingSurvey.content.pages
        .find(
          (s) =>
            s.name.toLowerCase() ===
            selectedSectionAndPage.sectionName.toLowerCase()
        )
        .elements[0].elements.map((item, index) =>
          item.type === "html" ? index : null
        )
        .filter((index) => index !== null);
      qIndex = htmlIndexes[sourcPageIndex] + source.index + 1;
      destIndex = htmlIndexes[destPageIndex] + destination.index + 1;
    } else {
      qIndex = _editingSurvey.content.pages.find((s) =>s.name.toLowerCase() ===selectedSectionAndPage.sectionName.toLowerCase()).elements[0].elements.findIndex((e) =>e.type === "html" && e.name === selectedSectionAndPage.pageName
          ) +
        source.index +
        1;
      destIndex =
        _editingSurvey.content.pages
          .find(
            (s) =>
              s.name.toLowerCase() ===
              selectedSectionAndPage.sectionName.toLowerCase()
          )
          .elements[0].elements.findIndex(
            (e) =>
              e.type === "html" && e.name === selectedSectionAndPage.pageName
          ) +
        destIndex +
        1;
      sourcPageIndex = _sections[
        selectedSectionAndPage.sectionIndex
      ].pages.findIndex((p) => p.name === selectedSectionAndPage.pageName);
      destPageIndex = sourcPageIndex;
    }

    const [movedItem] = _editingSurvey.content.pages.find((s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName.toLowerCase()).elements[0].elements.splice(qIndex, 1);
    _editingSurvey.content.pages.find((s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName.toLowerCase()).elements[0].elements.splice(destIndex, 0, movedItem);
    setEditingSurvey(_editingSurvey)

    const [sectionMovedItem] = _sections[
      selectedSectionAndPage.sectionIndex
    ].pages[sourcPageIndex].questions.splice(source.index, 1);
    _sections[selectedSectionAndPage.sectionIndex].pages[
      destPageIndex
    ].questions.splice(destination.index, 0, sectionMovedItem);
    setSections(_sections);

    saveChanges(_editingSurvey);
}
};

const updateQuestionType = (pageIndex, questionIndex, type) => {
  // sections'i güncelle
  setSections(prevSections =>
    produce(prevSections, draft => {
      const section = draft[selectedSectionAndPage.sectionIndex];
      const page =
        selectedSectionAndPage.pageName === "All"
          ? section.pages[pageIndex]
          : section.pages.find(p => p.name === selectedSectionAndPage.pageName);

      const question = page.questions[questionIndex];
      question.editing_type = type;

      switch (type) {
        case "checkbox":
          question.editing_showSelectAllItem = false;
          question.editing_showNoneItem = false;
          question.editing_showOtherItem = false;
          break;
        case "rating":
          question.editing_rateCount = 5;
          question.rateMax = 5;
          question.rateType = "stars";
          break;
        case "text":
          question.editing_inputType = "text";
          break;
        case "paneldynamic":
          question.templateElements = [];
          break;
      }
    })
  );

  // editingSurvey'i sadece ilgili alanı güncelle
  setEditingSurvey(prevSurvey =>
    produce(prevSurvey, draft => {
      const page = draft.content.pages.find(
        s => s.name === selectedSectionAndPage.sectionName
      );
      const { surveyContentQIndex } = getNewQIndexes(
        selectedSectionAndPage.sectionName,
        selectedSectionAndPage.pageName,
        draft,
        sections,
        pageIndex,
        questionIndex
      );

      const question = page.elements[0].elements[surveyContentQIndex];

      switch (type) {
        case "checkbox":
          question.elements[0].showSelectAllItem = false;
          question.elements[0].showNoneItem = false;
          question.elements[0].showOtherItem = false;
          break;
        case "rating":
          question.elements[0].rateCount = 5;
          question.elements[0].rateMax = 5;
          question.elements[0].rateType = "stars";
          question.elements[0].displayMode = "buttons";
          break;
        case "text":
          question.elements[0].type = "text";
          question.elements[0].inputType = "text";
          break;
        case "paneldynamic":
          question.templateElements = [];
          question.name = question.elements[0].title;
          break;
        case "radiogroup":
          question.elements[0].weight = 1;
          question.elements[0].asIsToBe = false;
          break;
      }
    })
  );
};
  const updatePanelQuestionType = (pageIndex, questionIndex, panelQuestionIndex, type) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    if (type === "checkbox") {
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[
        surveyContentQIndex
      ].templateElements[panelQuestionIndex].showSelectAllItem = false;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[
        surveyContentQIndex
      ].templateElements[panelQuestionIndex].showNoneItem = false;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[
        surveyContentQIndex
      ].templateElements[panelQuestionIndex].showOtherItem = false;
    } else if (type === "rating") {
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].rateCount = 5;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].rateMax = 5;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].rateType =
        "stars";
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].displayMode =
        "buttons";
    }else  if (type === "radiogroup") {
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].weight = 1;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].asIsToBe = false;
     
    }else  if (type === "paneldynamic") {
       const page = _editingSurvey.content.pages.find(
        (s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName.toLowerCase()
      );

      if (!page?.elements?.[0]?.elements?.[surveyContentQIndex]?.templateElements?.[panelQuestionIndex]) {
      } else {
        const targetPanel = page.elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex];

        // Eğer templateElements yoksa oluştur

          targetPanel.templateElements = [];
          targetPanel.type = "paneldynamic"
          targetPanel.name = ""


        // Yeni seviye-2 paneli ekle
   
      }

 
    } 
    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].templateElements[panelQuestionIndex].editing_type = type;
      if (type === "checkbox") {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].editing_showSelectAllItem = false;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].editing_showNoneItem = false;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].editing_showOtherItem = false;
      } else if (type === "rating") {
        
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].editing_rateCount = 5;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].rateMax = 5;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].rateType = "stars";
      } else if (type === "text") {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].editing_inputType = "text";
      }else if (type === "paneldynamic") {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements= [];

      } 
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].templateElements[panelQuestionIndex].editing_type = type;
      if (type === "checkbox") {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].editing_showSelectAllItem = false;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].editing_showNoneItem = false;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].editing_showOtherItem = false;
      } else if (type === "rating") {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].editing_rateCount = 5;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].rateMax = 5;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].rateType = "stars";
      } else if (type === "text") {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].editing_inputType = "text";
      }else if (type === "paneldynamic") {
         _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements= [];

      }
    }
    setSections(_sections);
    setEditingSurvey(_editingSurvey);

  };
   const updateLevel2PanelQuestionType = (pageIndex, questionIndex, panelQuestionIndex,nestedIndexLvl2, type) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    if (type === "checkbox") {
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[
        surveyContentQIndex
      ].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].showSelectAllItem = false;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[
        surveyContentQIndex
      ].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].showNoneItem = false;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[
        surveyContentQIndex
      ].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].showOtherItem = false;
    } else if (type === "rating") {
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].rateCount = 5;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].rateMax = 5;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].rateType =
        "stars";
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].displayMode =
        "buttons";
    }else  if (type === "radiogroup") {
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].weight = 1;
      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].asIsToBe = false;
     
    }
    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_type = type;
      if (type === "checkbox") {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_showSelectAllItem = false;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_showNoneItem = false;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_showOtherItem = false;
      } else if (type === "rating") {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_rateCount = 5;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].rateMax = 5;
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].rateType = "stars";
      } else if (type === "text") {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_inputType = "text";
      } 
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_type = type;
      if (type === "checkbox") {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_showSelectAllItem = false;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_showNoneItem = false;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_showOtherItem = false;
      } else if (type === "rating") {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_rateCount = 5;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].rateMax = 5;
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].rateType = "stars";
      } else if (type === "text") {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_inputType = "text";
      }
    }
    setSections(_sections);
    setEditingSurvey(_editingSurvey);

  };
  const updateTextQuestionType = (pageIndex, questionIndex, type) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_inputType = type;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_inputType = type;
    }

    _editingSurvey.content.pages.find(
      (s) =>
        s.name.toLowerCase() ===
        selectedSectionAndPage.sectionName.toLowerCase()
    ).elements[0].elements[surveyContentQIndex].elements[0].editing_inputType =
      type;

    setSections(_sections);
    // setEditingSurvey(_editingSurvey)
  };
  const updatePanelTextQuestionType = (pageIndex, questionIndex,panelQuestionIndex, type,nestedIndexLvl2=null) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    if(nestedIndexLvl2===null){
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[panelQuestionIndex].editing_inputType = type;
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].editing_inputType = type;
      }

      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].inputType =
        type;
    }else{
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_inputType = type;
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_inputType = type;
      }

      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].inputType = type;
    }
  

    setSections(_sections);
    // setEditingSurvey(_editingSurvey)
  };
  const updateQuestionIsRequired = (question, pageIndex, questionIndex) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    const _newIsReq = !question.isRequired;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].isRequired = _newIsReq;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].isRequired = _newIsReq;
    }

    _editingSurvey.content.pages.find(
      (s) =>
        s.name.toLowerCase() ===
        selectedSectionAndPage.sectionName.toLowerCase()
    ).elements[0].elements[surveyContentQIndex].elements[0].isRequired =
      _newIsReq;

    setSections(_sections);
    setEditingSurvey(_editingSurvey)

    if (!question.isEditing) {
      saveChanges(_editingSurvey);
    }
  };
  const updatePanelQuestionIsRequired = (question, pageIndex, questionIndex, questionIndexInPanel,nestedIndexLvl2=null) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    if(nestedIndexLvl2===null){
        const _newIsReq = !question.isRequired;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].templateElements[questionIndexInPanel].isRequired = _newIsReq;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].templateElements[questionIndexInPanel].isRequired = _newIsReq;
    }

    _editingSurvey.content.pages.find(
      (s) =>
        s.name.toLowerCase() ===
        selectedSectionAndPage.sectionName.toLowerCase()
    ).elements[0].elements[surveyContentQIndex].templateElements[questionIndexInPanel].isRequired =
      _newIsReq;
    }else{
      const _newIsReq = !question.templateElements[nestedIndexLvl2].isRequired;

      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[questionIndexInPanel].templateElements[nestedIndexLvl2].isRequired = _newIsReq;
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[questionIndexInPanel].templateElements[nestedIndexLvl2].isRequired = _newIsReq;
      }

      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[questionIndexInPanel].templateElements[nestedIndexLvl2].isRequired =
        _newIsReq;
    }

    setSections(_sections);
    setEditingSurvey(_editingSurvey)

    if (!question.isEditing) {
      saveChanges(_editingSurvey);
    }
  };
  const updateQuestionIsEditing = (question, pageIndex, questionIndex) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    const _newIsEditing = !question.isEditing;

    if (selectedSectionAndPage.pageName === "All") {
       let targetQuestion = _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ]
      targetQuestion.isEditing = _newIsEditing;
      if (question?.type === "paneldynamic" && targetQuestion?.templateElements){
        targetQuestion.templateElements.forEach(template => {
          template.isEditing = true;

          // Eğer template içinde tekrar templateElements varsa onları da gezip isEditing yapabilirsin
          if (template.templateElements) {
            template.templateElements.forEach(innerTemplate => {
              innerTemplate.isEditing = true;
            });
          }
        });
      }
    } else {
      let targetQuestion = _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex]
      targetQuestion.isEditing = _newIsEditing;
      if (question?.type === "paneldynamic" && targetQuestion?.templateElements){
        targetQuestion.templateElements.forEach(template => {
          template.isEditing = true;

          // Eğer template içinde tekrar templateElements varsa onları da gezip isEditing yapabilirsin
          if (template.templateElements) {
            template.templateElements.forEach(innerTemplate => {
              innerTemplate.isEditing = true;
            });
          }
        });
      }
    }
    setSections(_sections);
  };

  async function undoQuestionChanges(question, pageIndex, questionIndex) {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    const _newIsEditing = !question.isEditing;

    if (selectedSectionAndPage.pageName === "All") {
       let targetQuestion = _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[sectionQIndex];
      if (question.type === "paneldynamic") {
       

        // Paneldynamic sorunun kendisi için
        targetQuestion.isEditing = _newIsEditing;
        targetQuestion.editing_type =
          // Paneldynamic içindeki templateElements’i gez
          targetQuestion.templateElements.forEach((te, idx) => {
            te.isEditing = _newIsEditing; // örnek: isEditing alanını set et
            te.editing_weight = te.weight
            te.editing_asIsToBe = te.asIsToBe;
            te.editing_name = te.name
            te.editing_type = te.type
            te.editing_elements = te.elements
          });
      }

     targetQuestion.isEditing = _newIsEditing;
     targetQuestion.editing_name =
       targetQuestion.name;
     targetQuestion.editing_type =
       targetQuestion.type;
     targetQuestion["editing_weight"] =
       targetQuestion.weight;
      if (
       targetQuestion.editing_elements !== undefined
      ) {
       targetQuestion.editing_elements = targetQuestion.elements
          
        ;
       targetQuestion.newOption = "";
      }
      if (
        targetQuestion.editing_rateCount !== undefined
      ) {
        targetQuestion.editing_rateCount = targetQuestion.rateCount;
      }
      if (
        targetQuestion.type === "checkbox"
      ) {
        targetQuestion.editing_showSelectAllItem = targetQuestion.showSelectAllItem;
       targetQuestion.editing_showNoneItem =targetQuestion.showNoneItem;
        targetQuestion.editing_showOtherItem = targetQuestion.showOtherItem;
      } else if (
        targetQuestion.type === "text"
      ) {
        targetQuestion.editing_inputType =targetQuestion.inputType;
      }
    } else {
      let targetQuestion = _sections[selectedSectionAndPage.sectionIndex].pages.find((p) => p.name === selectedSectionAndPage.pageName).questions[sectionQIndex]

      if (question.type === "paneldynamic") {
        targetQuestion.isEditing = _newIsEditing;
        targetQuestion.editing_type = targetQuestion.type
        // Paneldynamic içindeki templateElements’i gez
        targetQuestion.templateElements.forEach((te, idx) => {
          te.isEditing = _newIsEditing; // örnek: isEditing alanını set et
          te.editing_weight = te.weight
          te.editing_asIsToBe = te.asIsToBe;
          te.editing_name = te.name
          te.editing_type = te.type
          te.editing_elements = te.elements
        });
      }
      targetQuestion.isEditing = _newIsEditing;
      targetQuestion.editing_name = targetQuestion.name;
      targetQuestion.editing_type = targetQuestion.type;
      targetQuestion["editing_weight"] = targetQuestion.weight;
      if (
        targetQuestion.editing_elements !== undefined
      ) {
        targetQuestion.editing_elements = targetQuestion.elements
        targetQuestion.newOption = "";
      }
      if (
        targetQuestion.editing_rateCount !== undefined
      ) {
        targetQuestion.editing_rateCount = targetQuestion.rateCount;
      }
      if (
        targetQuestion.type === "checkbox"
      ) {
        targetQuestion.editing_showSelectAllItem =targetQuestion.showSelectAllItem;
        targetQuestion.editing_showNoneItem =targetQuestion.showNoneItem;
        targetQuestion.editing_showOtherItem =targetQuestion.showOtherItem;
      } else if (
        targetQuestion.type === "text"
      ) {
        targetQuestion.editing_inputType =targetQuestion.inputType;
      }
    }
    setSections(_sections);
    // arrangeSections();
  }



  const saveQuestionChanges = (question, pageIndex, questionIndex,panelQuestionIndex=0) => {
    
    let _sections = structuredClone(sections);
    let _editingSurvey = structuredClone(editingSurvey);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    const page = _editingSurvey.content.pages.find(
  (s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName.toLowerCase()
);
const surveyElement = page.elements[0].elements[surveyContentQIndex] ;
    const _newIsEditing = !question.isEditing;
    if (question.editing_type === "radiogroup" || question.editing_type === "dropdown") {

      surveyElement.elements[0].title = question.editing_name;
      if (question.editing_elements !== undefined) {
        question.editing_elements.forEach((item) => {
          if (item.weight) {
            item.weight = parseFloat(item.weight);
          }
        });
        surveyElement.elements[0].choices = JSON.parse(JSON.stringify(question.editing_elements));
      }
     surveyElement.elements[0].type =
        question.editing_type;
        surveyElement.elements[0]["weight"] =
        parseFloat(question.editing_weight);
      surveyElement.elements[0]["asIsToBe"] = question.editing_asIsToBe;
    }
    if (question.editing_type === "checkbox" ) {
        surveyElement.elements[0].title = question.editing_name;
        surveyElement.elements[0].type = question.editing_type;
      surveyElement.elements[0].showSelectAllItem = question.editing_showSelectAllItem;
      surveyElement.elements[0].showNoneItem =
        question.editing_showNoneItem;
     surveyElement.elements[0].showOtherItem =
        question.editing_showOtherItem;
       surveyElement.elements[0]["asIsToBe"] = false;
      surveyElement.elements[0].choices = JSON.parse(JSON.stringify(question.editing_elements));
    } else if (question.editing_type === "rating") {
          surveyElement.elements[0].type =
        question.editing_type;
       surveyElement.elements[0].title = question.editing_name;
     surveyElement.elements[0].rateCount =
        question.editing_rateCount;
     surveyElement.elements[0].rateMax =
        question.editing_rateCount;
     surveyElement.elements[0].rateType =
        question.rateType;
     surveyElement.elements[0].displayMode =
        "buttons";
        surveyElement.elements[0]["asIsToBe"] = question.editing_asIsToBe;
    } else if (question.editing_type === "text" ) {
            surveyElement.elements[0].title = question.editing_name;
     surveyElement.elements[0].inputType =
        question.editing_inputType;
         surveyElement.elements[0].type =
        question.editing_type;
    }else  if (question.editing_type === "ranking"  ) {
      surveyElement.elements[0].title = question.editing_name;
      if (question.editing_elements !== undefined) {
   
        surveyElement.elements[0].choices = JSON.parse(JSON.stringify(question.editing_elements));
      }
     surveyElement.elements[0].type =
        question.editing_type;

    } else  if (question.editing_type === "boolean" ) {
      surveyElement.elements[0].title = question.editing_name;
     surveyElement.elements[0].type =
        question.editing_type;

    } else if (question.editing_type === "paneldynamic") {
  surveyElement.name = question.editing_name;
  surveyElement.type = question.editing_type;

  // 1) Panel elemanlarının ham (raw) halini al
  const rawTemplate = savePanelQuestionChanges(question);

  // 2) editing_* alanlarına göre işlenmiş final template oluştur
  const finalTemplate = deepUpdateTemplateElements(rawTemplate);

  // 3) SurveyElement’e final template’i yaz
  surveyElement.templateElements = finalTemplate;

  // 4) Hedef question’ı bul
  let targetQ;
  if (selectedSectionAndPage.pageName === "All") {
    targetQ =
      _sections[selectedSectionAndPage.sectionIndex]
        .pages[pageIndex]
        .questions[sectionQIndex];
  } else {
    const page = _sections[selectedSectionAndPage.sectionIndex].pages
      .find(p => p.name === selectedSectionAndPage.pageName);

    targetQ = page.questions[sectionQIndex];
  }

  // 5) Hedef question’a final template’i direkt uygula
  targetQ.isEditing = _newIsEditing;
  targetQ.name = targetQ.editing_name;
  targetQ.type = targetQ.editing_type;
  targetQ.templateElements = finalTemplate;
}



    if( question.type !== "paneldynamic" ||  question.editing_type !== "paneldynamic")
    { 
      if (selectedSectionAndPage.pageName === "All") {
        let question =  _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ]
        question.isEditing = _newIsEditing;
        question.name =
          question.editing_name;
        question.type =
          question.editing_type;
        question["weight"] = parseFloat(
          _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
            .questions[sectionQIndex].editing_weight
        );
        if(question.asIsToBe != undefined){
          question.asIsToBe =
          question.editing_asIsToBe;
        }
        if (
          question.elements !== undefined
        ) {
          question.elements = JSON.parse(
            JSON.stringify(
             question.editing_elements
            )
          );
        }
        if (
          question.editing_rateCount !== undefined
        ) {
          question.rateCount =
            question.editing_rateCount;
          question.rateMax =
            question.editing_rateCount;
        }
        if (
          question.editing_type === "checkbox"
        ) {
          question.showSelectAllItem =
            question.editing_showSelectAllItem;
          question.showNoneItem =
            question.editing_showNoneItem;
          question.showOtherItem =
            question.editing_showOtherItem;
        } else if (
          question.editing_type === "text"
        ) {
          question.inputType =
            question.editing_inputType;
        }
      } else {
        let question = _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex]
        question.isEditing = _newIsEditing;
        question.name = question.editing_name;
        question.type = question.editing_type;
        question["weight"] = parseFloat(
          question.editing_weight
        );
          if(question.asIsToBe != undefined){
          question.asIsToBe =
          question.editing_asIsToBe;
        }
        if (
          question.elements !== undefined
        ) {
          question.elements = JSON.parse(
            JSON.stringify(
              question.editing_elements
            )
          );
        }
        if (
          question.editing_rateCount !== undefined
        ) {
          question.rateCount =question.editing_rateCount;
          question.rateMax = question.editing_rateCount;
        }
        if (
        question.editing_type === "checkbox"
        ) {
          question.showSelectAllItem = question.editing_showSelectAllItem;
          question.showNoneItem =question.editing_showNoneItem;
          question.showOtherItem =question.editing_showOtherItem;
        } else if (
          question.editing_type === "text"
        ) {
          question.inputType =question.editing_inputType;
        }
      }
    }
    setSections(_sections);
    setEditingSurvey(_editingSurvey);
    // if (question?.isEditing) {
    saveChanges(_editingSurvey);
    // }
  };
// utils/surveyUtils.js
function deepUpdateTemplateElements(elements) {
  if (!Array.isArray(elements)) return [];

  return elements.map(el => {
    let updated = el; 
    let cloned = false;

    const ensureClone = () => {
      if (!cloned) {
        updated = { ...el };
        cloned = true;
      }
    };

    // editing_name
    if (el.editing_name !== undefined) {
      ensureClone();
      updated.title = el.editing_name;
    }

    // editing_type
    if (el.editing_type !== undefined) {
      ensureClone();
      updated.type = el.editing_type;
    }

    // asIsToBe
    if (el.editing_asIsToBe !== undefined) {
      ensureClone();
      updated.asIsToBe = el.editing_asIsToBe;
    }

    // weight
    if (el.editing_weight !== undefined) {
      ensureClone();
      updated.weight = Number(el.editing_weight) || 0;
    }

    // editing_elements (choices or inner items)
    if (Array.isArray(el.editing_elements)) {
      ensureClone();
      updated.elements = el.editing_elements.map(i => ({ ...i }));
    }

    // checkbox
    if (el.editing_type === "checkbox") {
      ensureClone();
      updated.showSelectAllItem = !!el.editing_showSelectAllItem;
      updated.showNoneItem = !!el.editing_showNoneItem;
      updated.showOtherItem = !!el.editing_showOtherItem;
    }

    // text
    if (el.editing_type === "text" && el.editing_inputType !== undefined) {
      ensureClone();
      updated.inputType = el.editing_inputType;
    }

    // rating
    if (el.editing_rateCount !== undefined) {
      const rate = Number(el.editing_rateCount);
      if (!isNaN(rate)) {
        ensureClone();
        updated.rateCount = rate;
        updated.rateMax = rate;
      }
    }

    // recursive nested panel elements
    if (Array.isArray(el.templateElements)) {
      const newChildren = deepUpdateTemplateElements(el.templateElements);

      // sadece değişiklik varsa clone et
      if (newChildren !== el.templateElements) {
        ensureClone();
        updated.templateElements = newChildren;
      }
    }

    return updated;
  });
}



 const savePanelQuestionChanges =(question,)=>{
      return question.templateElements.map((el, idx) => {
        const updated = JSON.parse(JSON.stringify(el));
        if (el.editing_type === "radiogroup") {
          updated.title = el.editing_name;
            question.templateElements.forEach((item) => {
              if (item.weight) {
                item.weight = parseFloat(item.weight);
              }
            });
            updated.choices = JSON.parse(JSON.stringify(el.editing_elements));
       
          updated.type =el.editing_type;
          updated["weight"] =parseFloat(el.editing_weight);
         updated["asIsToBe"] = el.editing_asIsToBe;
        }
        else if (el.editing_type === "checkbox") {
          updated.showSelectAllItem = el.editing_showSelectAllItem;
          updated.showNoneItem = el.editing_showNoneItem;
          updated.showOtherItem = el.editing_showOtherItem;
          updated.choices = el.editing_elements
           updated["asIsToBe"] = el.editing_asIsToBe;
        } else if (el.editing_type === "rating") {
          updated.rateCount =
            el.editing_rateCount;
          updated.rateMax =
            el.editing_rateCount;
          updated.rateType =
            el.rateType;
          updated.displayMode ="buttons";
           updated["asIsToBe"] = el.editing_asIsToBe;
        } else if (el.editing_type === "text") {
          updated.inputType =el.editing_inputType;
        }else if (el.editing_type === "ranking") {
            updated.title = updated.editing_name;
            updated.choices = el.editing_elements

            updated.type =updated.editing_type;
      }
        else if (el.editing_type === "paneldynamic") {
          updated.type = el.editing_type
          updated.name =el.editing_name
      updated.templateElements = savePanelQuestionChanges(el);
    } 

    
        updated.type =el.editing_type
        updated.weight = el.editing_weight;
        updated.title = el.editing_name
        return updated;
      });
      
     
 }
  const handleWeightChange = (pageIndex, questionIndex, value) => {
    value = value.replace(",", ".");
    value = value.replace(/[^0-9.]/g, "");
    value = value.replace(/(\..*?)\./g, "$1");

    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ]["editing_weight"] = value;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex]["editing_weight"] = value;
    }

    setSections(_sections);
  };
  const handlePanelQuestionWeightChange = (pageIndex, questionIndex, questionIndexInPanel, value,nestedIndexLvl2=null) => {
    value = value.replace(",", ".");
    value = value.replace(/[^0-9.]/g, "");
    value = value.replace(/(\..*?)\./g, "$1");

    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    if(nestedIndexLvl2===null){
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[questionIndexInPanel]["editing_weight"] = value;
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[questionIndexInPanel]["editing_weight"] = value;
      }
    }else{
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[questionIndexInPanel].templateElements[nestedIndexLvl2]["editing_weight"] = value;
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[questionIndexInPanel].templateElements[nestedIndexLvl2]["editing_weight"] = value;
      }
    }
  
    setSections(_sections);
  };
  const handleAsIsToBeChange = (pageIndex, questionIndex, value) => {

    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ]["editing_asIsToBe"] = value === "true";
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex]["editing_asIsToBe"] = value  === "true";
    }
    setShowAsIsToBeOptions(false)
    setSections(_sections);
    
  };
  const handlePanelQuestionAsIsToBeChange = (pageIndex, questionIndex, questionIndexInPanel, value,nestedIndexLvl2=null) => {

    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    if(nestedIndexLvl2===null){
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[questionIndexInPanel]["editing_asIsToBe"] = value ==="true";
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[questionIndexInPanel]["editing_asIsToBe"] = value ==="true";
      }
    }else{
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[questionIndexInPanel].templateElements[nestedIndexLvl2]["editing_asIsToBe"] = value ==="true";
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[questionIndexInPanel].templateElements[nestedIndexLvl2]["editing_asIsToBe"] = value ==="true";
      }
    }
   
    setShowAsIsToBeOptions(false)
    setSections(_sections);
   
  };
const handleQuestionNameChange = (pageIndex, questionIndex, value, type) => {
  // 1) Gereksiz dev clone KALDIRILDI
  const newSections = structuredClone(sections);

  // 2) Target element bulma – tek sefer
  const targetElement =
    newSections[selectedSectionAndPage.sectionIndex]
      .pages[pageIndex]
      .questions[questionIndex];

  // 3) Sadece gerekli alanı update et
  targetElement.editing_name = value;

  // if (type !== "paneldynamic") {
  //   targetElement.is_exist = questionIsExist(value);
  // }

  // 4) UI state setPages yapmıyoruz → saveQuestionChanges yapacak
  setSections(newSections);

  // 5) Filtreleme
  if (value.length > 0 && type !== "paneldynamic") {
    const v = value.toLowerCase(); // micro-optimize

    const filtered = [];
    const seen = new Set();

    for (const q of questions) {
      if (q.question.toLowerCase().includes(v)) {
        const key = `${q.question}-${q.type}`;
        if (!seen.has(key)) {
          seen.add(key);
          filtered.push(q);
        }
      }
    }

    setFilteredQuestions(filtered);
  } else {
    setFilteredQuestions(questions);
  }
};


  const editQuestionFromQBank = (pageIndex, questionIndex, question) => {
    let isExist = questionIsExist(question.question);

    question["choices"] = question.options.map((option, index) => {
      return {
        value: index + 1,
        text: option,
      };
    });

    setSections((prev) => {
      const newSections = structuredClone(prev);
      const updatedQuestions = newSections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions;
      updatedQuestions[questionIndex].editing_name = question.question;
      updatedQuestions[questionIndex].editing_elements = question.choices;
      updatedQuestions[questionIndex].editing_type = question.type;
      updatedQuestions[questionIndex].is_exist = isExist;

      return newSections;
    });

    setFilteredQuestions([]);
  };

  const handleOptionWeightChange = (
    pageIndex,
    questionIndex,
    choiceIndex,
    value
  ) => {
    value = value.replace(",", ".");
    value = value.replace(/[^0-9.]/g, "");
    value = value.replace(/(\..*?)\./g, "$1");

    if (parseFloat(value) > 5) {
      value = "5";
    }

    // if (regex.test(value)) {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_elements[choiceIndex].weight = value;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_elements[choiceIndex].weight = value;
    }

    setSections(_sections);
    // }
  };
  const handlePanelQuestionOptionWeightChange = (
    pageIndex,
    questionIndex,
    questionIndexInPanel,
    choiceIndex,
    value,
    nestedIndexLvl2
  ) => {
    value = value.replace(",", ".");
    value = value.replace(/[^0-9.]/g, "");
    value = value.replace(/(\..*?)\./g, "$1");

    if (parseFloat(value) > 5) {
      value = "5";
    }

    // if (regex.test(value)) {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    if(nestedIndexLvl2===null){
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[questionIndexInPanel].editing_elements[choiceIndex].weight = value;
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[questionIndexInPanel].editing_elements[choiceIndex].weight = value;
      }
    }else{
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[questionIndexInPanel].templateElements[nestedIndexLvl2].editing_elements[choiceIndex].weight = value;
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[questionIndexInPanel].templateElements[nestedIndexLvl2].editing_elements[choiceIndex].weight = value;
      }
    }
   

    setSections(_sections);
    // }
  };
  const handleChoiceTextChange = (
    pageIndex,
    questionIndex,
    choiceIndex,
    value,
    type
  ) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );
    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {

      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_elements[choiceIndex].text = value;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_elements[choiceIndex].text = value;
    }

    // if (type === "checkbox" || type === "ranking") {
    //     _editingSurvey.content.pages.find(s => s.name === selectedSectionAndPage.sectionName).elements[0].elements[surveyContentQIndex].elements[0].choices[choiceIndex] = value;
    // }
    // else {
    //     _editingSurvey.content.pages.find(s => s.name === selectedSectionAndPage.sectionName).elements[0].elements[surveyContentQIndex].elements[0].choices[choiceIndex].text = value;
    // }
    setSections(_sections);
  };
  // helper: deep clone (structuredClone if available)
  const deepClone = (obj) => {
    if (typeof structuredClone === "function") return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
  };
  function findPanelContainerAndPanels(_editingSurvey, sectionName) {
    const page = _editingSurvey?.content?.pages?.find(
      (p) => p?.name?.toLowerCase() === sectionName?.toLowerCase()
    );
    const container = page.elements.find((el) => Array.isArray(el?.elements)) || null;
    const pageElements = container ? container.elements : page.elements || [];

    const panels = pageElements.filter((el) => el?.type === "panel" || el?.type === "paneldynamic");

    return { page, container, pageElements, panels };
  }

  function ensureTemplateArray(panel) {
    // case 1: panel has templateElements directly
    if (Array.isArray(panel.templateElements)) return panel.templateElements;

    // case 2: panel has template object
    if (panel.template && Array.isArray(panel.template.elements)) return panel.template.elements;

    // case 3: panel is a wrapper and first inner element contains templateElements
    if (Array.isArray(panel.elements) && panel.elements[0]) {
      const inner = panel.elements[0];
      if (Array.isArray(inner.templateElements)) return inner.templateElements;
      if (inner.template && Array.isArray(inner.template.elements)) return inner.template.elements;

      // if none exists yet, create on the inner element (most compatible)
      inner.templateElements = [];
      return inner.templateElements;
    }


    panel.templateElements = [];
    return panel.templateElements;
  }


  const handlePanelQuestionChange = (pageIndex, panelQuestionIndex, templateQuestionIndex, key, value,nestedIndexLvl2 = null) => {
    // clones




    const _sections = structuredClone(sections);

    const currentSectionIndex = selectedSectionAndPage.sectionIndex;


    const sectionPage = _sections[currentSectionIndex].pages[pageIndex];
    if (!sectionPage) {
      return;
    }
    const sectionPanel = sectionPage.questions[panelQuestionIndex];
    if (!sectionPanel) {
      return;
    }
    if (selectedSectionAndPage.pageName === "All") {
      let question =  _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          panelQuestionIndex
        ].templateElements[templateQuestionIndex]
      if(nestedIndexLvl2 === null){
       question.editing_name = value;
        }else{
      question.templateElements[nestedIndexLvl2].editing_name = value;
         
        }
      
      
    } else {
         let targetElement = _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[panelQuestionIndex].templateElements[templateQuestionIndex]
      if(nestedIndexLvl2 === null){
     
        targetElement.editing_name = value;
       
      }else{
        targetElement.templateElements[nestedIndexLvl2].editing_name = value;
       
      }
    }

    setSections(_sections);
  };


  const addPanelChoice = (pageIndex, panelQuestionIndex, templateQuestionIndex,nestedIndexLvl2=null) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = JSON.parse(JSON.stringify(sections));

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      panelQuestionIndex
    );
    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    if (selectedSectionAndPage.pageName === "All") {
      if(nestedIndexLvl2 === null){
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[templateQuestionIndex].editing_elements.push({
          value:
            _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
              .questions[sectionQIndex].templateElements[templateQuestionIndex].editing_elements.length + 1,
          text: _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
            .questions[sectionQIndex].templateElements[templateQuestionIndex].newOption,
          // weight: (5 / 7) * (_sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[sectionQIndex].editing_elements.length + 1)
        });
      }else{
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[templateQuestionIndex].templateElements[nestedIndexLvl2].editing_elements.push({
          value:
            _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
              .questions[sectionQIndex].templateElements[templateQuestionIndex].templateElements[nestedIndexLvl2].editing_elements.length + 1,
          text: _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
            .questions[sectionQIndex].templateElements[templateQuestionIndex].templateElements[nestedIndexLvl2].newOption,
          // weight: (5 / 7) * (_sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[sectionQIndex].editing_elements.length + 1)
        });
      }
    } else {
      if(nestedIndexLvl2 ===null){
        _sections[selectedSectionAndPage.sectionIndex].pages
          .find((p) => p.name === selectedSectionAndPage.pageName)
          .questions[sectionQIndex].templateElements[templateQuestionIndex].editing_elements.push({
            value:
              _sections[selectedSectionAndPage.sectionIndex].pages.find(
                (p) => p.name === selectedSectionAndPage.pageName
              ).questions[sectionQIndex].templateElements[templateQuestionIndex].editing_elements.length + 1,
            text: _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
              .questions[sectionQIndex].templateElements[templateQuestionIndex].newOption,
            // weight: 1.0
          });
      }else{
        _sections[selectedSectionAndPage.sectionIndex].pages
        .find((p) => p.name === selectedSectionAndPage.pageName)
        .questions[sectionQIndex].templateElements[templateQuestionIndex].templateElements[nestedIndexLvl2].editing_elements.push({
          value:
            _sections[selectedSectionAndPage.sectionIndex].pages.find(
              (p) => p.name === selectedSectionAndPage.pageName
            ).questions[sectionQIndex].templateElements[templateQuestionIndex].templateElements[nestedIndexLvl2].editing_elements.length + 1,
          text: _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
            .questions[sectionQIndex].templateElements[templateQuestionIndex].templateElements[nestedIndexLvl2].newOption,
          // weight: 1.0
        });
      }
      
    }
    if(nestedIndexLvl2 === null){
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
      sectionQIndex
    ].templateElements[templateQuestionIndex].newOption = "";
    }else{
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
      sectionQIndex
    ].templateElements[templateQuestionIndex].templateElements[nestedIndexLvl2].newOption = "";
    }
    
    setSections(_sections);
  };


  const removePanelChoice = (pageIndex, panelQuestionIndex, templateQuestionIndex, choiceIndex,nestedIndexLvl2=null) => {
    const _sections = structuredClone(sections);
    const _editingSurvey = deepClone(editingSurvey);
    const currentSectionIndex = selectedSectionAndPage.sectionIndex;
    const currentSectionName = selectedSectionAndPage.sectionName;

    const sectionPage = _sections[currentSectionIndex].pages[pageIndex];
    const sectionPanel = sectionPage.questions[panelQuestionIndex];
    if(nestedIndexLvl2===null){
      if (sectionPanel?.templateElements?.[templateQuestionIndex]?.editing_elements) {
        sectionPanel.templateElements[templateQuestionIndex].editing_elements.splice(choiceIndex, 1);
      }

      const found = findPanelContainerAndPanels(_editingSurvey, currentSectionName);
      if (found) {
        const panelItem = found.panels[panelQuestionIndex];
        if (panelItem) {
          const templateArr = ensureTemplateArray(panelItem);
          if (templateArr?.[templateQuestionIndex]?.choices) {
            templateArr[templateQuestionIndex].choices.splice(choiceIndex, 1);
          }
        }
      }
    }else{
       if (sectionPanel?.templateElements?.[templateQuestionIndex]?.templateElements?.[nestedIndexLvl2]?.editing_elements) {
        sectionPanel.templateElements[templateQuestionIndex].templateElements[nestedIndexLvl2].editing_elements.splice(choiceIndex, 1);
      }

      const found = findPanelContainerAndPanels(_editingSurvey, currentSectionName);
      if (found) {
        const panelItem = found.panels[panelQuestionIndex];
        if (panelItem) {
          const templateArr = ensureTemplateArray(panelItem);
          if (templateArr?.[templateQuestionIndex]?.choices) {
            templateArr[templateQuestionIndex].templateElements[nestedIndexLvl2].choices.splice(choiceIndex, 1);
          }
        }
      }
    }
    setSections(_sections);
  };

  const removePanelQuestion = (pageIndex, panelQuestionIndex, templateQuestionIndex,nestedIndexLvl2=null) => {
    const _sections = structuredClone(sections);
    const _editingSurvey = deepClone(editingSurvey);
    const currentSectionIndex = selectedSectionAndPage.sectionIndex;
    const currentSectionName = selectedSectionAndPage.sectionName;

    const sectionPage = _sections[currentSectionIndex].pages[pageIndex];
    const sectionPanel = sectionPage.questions[panelQuestionIndex];
    if(nestedIndexLvl2===null){
      if (sectionPanel?.templateElements) {
        sectionPanel.templateElements.splice(templateQuestionIndex, 1);
      }

      const found = findPanelContainerAndPanels(_editingSurvey, currentSectionName);
      if (found) {
        const panelItem = found.panels[panelQuestionIndex];
        if (panelItem) {
          const templateArr = ensureTemplateArray(panelItem);
          if (Array.isArray(templateArr)) {
            templateArr.splice(templateQuestionIndex, 1);
          }
        }
      }
    }else{
      if (sectionPanel?.templateElements) {
        sectionPanel.templateElements[templateQuestionIndex].templateElements.splice(nestedIndexLvl2, 1);
      }

      const found = findPanelContainerAndPanels(_editingSurvey, currentSectionName);
      if (found) {
        const panelItem = found.panels[panelQuestionIndex];
        if (panelItem) {
          const templateArr = ensureTemplateArray(panelItem);
          if (Array.isArray(templateArr)) {
            templateArr[templateQuestionIndex].templateElements.splice(nestedIndexLvl2, 1);
          }
        }
      }
    }
    setSections(_sections);
    setEditingSurvey(_editingSurvey)

    saveChanges(_editingSurvey);
  };
  const handlePanelChoiceChange = (
    pageIndex,             // panelin bulunduğu page index
    panelQuestionIndex,    // panel dynamic içindeki panel index
    templateQuestionIndex, // panel templateElements içindeki soru index
    choiceIndex,           // değiştirmek istediğin choice index
    newValue,            // yeni değer
    nestedIndexLvl2=null
  ) => {
    
    const _sections = structuredClone(sections);
    const _editingSurvey = structuredClone(editingSurvey);
        const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      panelQuestionIndex
    );
    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    if(nestedIndexLvl2===null){

      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[templateQuestionIndex].editing_elements[choiceIndex].text = newValue;
      } else {
        const question = _sections[selectedSectionAndPage.sectionIndex].pages.find((p) => p.name === selectedSectionAndPage.pageName).questions[sectionQIndex];

        const templateQuestion = question.templateElements[templateQuestionIndex];

        if (!templateQuestion.editing_elements) {
          templateQuestion.editing_elements = [];
        }

        templateQuestion.editing_elements[choiceIndex].text = newValue;

      }
    }else{
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[templateQuestionIndex].templateElements[nestedIndexLvl2].editing_elements[choiceIndex].text = newValue;
      } else {
          const question = _sections[selectedSectionAndPage.sectionIndex].pages.find((p) => p.name === selectedSectionAndPage.pageName).questions[sectionQIndex];

          const templateQuestion = question.templateElements[templateQuestionIndex].templateElements[nestedIndexLvl2];

          if (!templateQuestion.editing_elements) {
            templateQuestion.editing_elements = [];
          }

          templateQuestion.editing_elements[choiceIndex].text = newValue;

      }
    }
    setSections(_sections);
  };



  const handleNewOptionChange = (pageIndex, questionIndex, newVal) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
      sectionQIndex
    ].newOption = newVal;
    setSections(_sections);
  };

  const handleAddOption = (pageIndex, questionIndex, type) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      const q = _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[sectionQIndex];
      if (!q.editing_elements) q.editing_elements = [];
      q.editing_elements.push({
        value: q.editing_elements.length + 1,
        text: q.newOption,
      });
    } else {
      const q = _sections[selectedSectionAndPage.sectionIndex].pages
        .find((p) => p.name === selectedSectionAndPage.pageName)
        ?.questions[sectionQIndex];
      if (q) {
        if (!q.editing_elements) q.editing_elements = [];
        q.editing_elements.push({
          value: q.editing_elements.length + 1,
          text: _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
            .questions[sectionQIndex].newOption,
        });
      }
    }

    _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
      sectionQIndex
    ].newOption = "";
    setSections(_sections);
    setInputValue("");
  };
  const increaseRate = (pageIndex, questionIndex) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_rateCount += 1;
      // _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[sectionQIndex].rateMax += 1;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_rateCount += 1;
      // _sections[selectedSectionAndPage.sectionIndex].pages.find(p => p.name === selectedSectionAndPage.pageName).questions[sectionQIndex].rateMax += 1;
    }
    let targetSurvey = _editingSurvey.content.pages.find((s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName.toLowerCase()).elements[0].elements[surveyContentQIndex].elements[0]
  targetSurvey.rateCount += 1;
    targetSurvey.rateMax += 1;

    setSections(_sections);
    setEditingSurvey(_editingSurvey);
  };
  const increasePanelQuestionRate = (pageIndex, questionIndex,panelQuestionIndex,nestedIndexLvl2=null) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    if(nestedIndexLvl2 === null){
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[panelQuestionIndex].editing_rateCount += 1;
        // _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[sectionQIndex].rateMax += 1;
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].editing_rateCount += 1;
        // _sections[selectedSectionAndPage.sectionIndex].pages.find(p => p.name === selectedSectionAndPage.pageName).questions[sectionQIndex].rateMax += 1;
      }
      let targetSurveyElement = _editingSurvey.content.pages.find((s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName.toLowerCase()).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex]
      targetSurveyElement.rateCount += 1;
      targetSurveyElement.rateMax += 1;
    }else{
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_rateCount += 1;
        // _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[sectionQIndex].rateMax += 1;
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_rateCount += 1;
        // _sections[selectedSectionAndPage.sectionIndex].pages.find(p => p.name === selectedSectionAndPage.pageName).questions[sectionQIndex].rateMax += 1;
      }
      let targetSurveyElement = _editingSurvey.content.pages.find((s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName.toLowerCase()).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2]
      targetSurveyElement.rateCount += 1;
      targetSurveyElement.rateMax += 1;
    }


    setSections(_sections);
    setEditingSurvey(_editingSurvey);
  };
  // Rate azaltma (minimum 1'e sabitleme)
  const decreaseRate = (pageIndex, questionIndex) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_rateCount -= 1;
      // _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[sectionQIndex].rateMax -= 1;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[sectionQIndex].editing_rateCount -= 1;
      // _sections[selectedSectionAndPage.sectionIndex].pages.find(p => p.name === selectedSectionAndPage.pageName).questions[sectionQIndex].rateMax -= 1;
    }
    let targetSurveyElement = _editingSurvey.content.pages.find(
      (s) =>
        s.name.toLowerCase() ===
        selectedSectionAndPage.sectionName.toLowerCase()
    ).elements[0].elements[surveyContentQIndex].elements[0]
    targetSurveyElement.rateCount -= 1;
    targetSurveyElement.rateMax -= 1;

    setSections(_sections);
    setEditingSurvey(_editingSurvey)
  };
  const decreasePanelQuestionRate = (pageIndex, questionIndex,panelQuestionIndex,nestedIndexLvl2) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    if(nestedIndexLvl2 === null){
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[panelQuestionIndex].editing_rateCount -= 1;
        // _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[sectionQIndex].rateMax -= 1;
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].editing_rateCount -= 1;
        // _sections[selectedSectionAndPage.sectionIndex].pages.find(p => p.name === selectedSectionAndPage.pageName).questions[sectionQIndex].rateMax -= 1;
      }
      let targetSurveyElement =  _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex]
      targetSurveyElement.rateCount -= 1;
      targetSurveyElement.rateMax -= 1;
    }else{
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          sectionQIndex
        ].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_rateCount -= 1;
        // _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[sectionQIndex].rateMax -= 1;
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].editing_rateCount -= 1;
        // _sections[selectedSectionAndPage.sectionIndex].pages.find(p => p.name === selectedSectionAndPage.pageName).questions[sectionQIndex].rateMax -= 1;
      }
      let targetSurveyElement =  _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2]
      targetSurveyElement.rateCount -= 1;
      targetSurveyElement.rateMax -= 1;
    }

    setSections(_sections);
    setEditingSurvey(_editingSurvey)
  };
  const handleCheckBoxOptions = (pageIndex, questionIndex, value, param) => {
    let _sections = structuredClone(sections);
    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        questionIndex
      ]["editing_" + param] = value;
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages.find(
        (p) => p.name === selectedSectionAndPage.pageName
      ).questions[questionIndex]["editing_" + param] = value;
    }

    setSections(_sections);
  };
  const handlePanelCheckBoxOptions = (pageIndex, questionIndex,panelQuestionIndex, value, param,nestedIndexLvl2) => {
    let _sections = structuredClone(sections);
    if(nestedIndexLvl2 === null){
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          questionIndex
        ].templateElements[panelQuestionIndex]["editing_" + param] = value;
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[questionIndex].templateElements[panelQuestionIndex]["editing_" + param] = value;
      }
    }else{
      if (selectedSectionAndPage.pageName === "All") {
        _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
          questionIndex
        ].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2]["editing_" + param] = value;
      } else {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[questionIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2]["editing_" + param] = value;
      }
    }
    setSections(_sections);
  };

  const handlePanelNewOptionChange = (pageIndex,     panelQuestionIndex,    // panel dynamic içindeki panel index
    templateQuestionIndex, // panel templateElements içindeki soru index
    choiceIndex,           // değiştirmek istediğin choice index
    newValue ,nestedIndexLvl2 = null              ) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      panelQuestionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    if(nestedIndexLvl2 === null){
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
      sectionQIndex
    ].templateElements[templateQuestionIndex].newOption = newValue;
    }else{
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
      sectionQIndex
    ].templateElements[templateQuestionIndex].templateElements[nestedIndexLvl2].newOption = newValue;
    }
    setSections(_sections);
  };
  const handleDeleteQuestion = (pageIndex, questionIndex) => {
    setDeleteAllowMenuOpen(false);
    setDeleteInfoMenuShow(true);
    let _sections = structuredClone(sections);
    let _editingSurvey = structuredClone(editingSurvey);

    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[
        pageIndex
      ].questions.splice(sectionQIndex, 1);
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages
        .find((p) => p.name === selectedSectionAndPage.pageName)
        .questions.splice(sectionQIndex, 1);
    }

    _editingSurvey.content.pages
      .find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      )
      .elements[0].elements.splice(surveyContentQIndex, 1);
    setSections(_sections);
    setEditingSurvey(_editingSurvey)

    saveChanges(_editingSurvey);
  };

  const handleDeleteOption = (pageIndex, questionIndex, optionIndex, type) => {
    setDeleteAllowMenuOpen(false);
    setDeleteInfoMenuShow(true);
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    if (selectedSectionAndPage.pageName === "All") {
      _sections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions[
        sectionQIndex
      ].editing_elements.splice(optionIndex, 1);
    } else {
      _sections[selectedSectionAndPage.sectionIndex].pages
        .find((p) => p.name === selectedSectionAndPage.pageName)
        .questions[sectionQIndex].editing_elements.splice(optionIndex, 1);
    }

    setSections(_sections);
  };

  const changeBooleanType = (pageIndex, questionIndex, type) => {
    setSections((prev) => {
      const newSections = structuredClone(prev);
      const updatedQuestions = newSections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions;
      updatedQuestions[questionIndex].renderAs = type;

      return newSections;
    });
  };

  const changeCommentTypeOptions = (
    pageIndex,
    questionIndex,
    option,
    param
  ) => {
    setSections((prev) => {
      const newSections = structuredClone(prev);
      const updatedQuestions = newSections[selectedSectionAndPage.sectionIndex].pages[pageIndex].questions;
      if (param === "rows") {
        updatedQuestions[questionIndex].rows = option;
      } else if (param === "allowResize") {
        updatedQuestions[questionIndex].allowResize =
          option === "no" ? false : true;
      } else if (param === "maxLength") {
        updatedQuestions[questionIndex].maxLength = option;
      }

      return newSections;
    });
  };

  const changeTextTypeOptions = (pageIndex, questionIndex, option, param) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    // setSections((prev) => {
    //     const newSections = [...prev];
    //     const updatedQuestions = [
    //         ...newSections[selectedSectionAndPage.sectionIndex].pages[pageIndex]
    //             .questions,
    //     ];
    //     if (param === "inputType") {
    //         updatedQuestions[questionIndex].inputType = option.value;
    //     }
    //     if (option.value === "number") {
    //         updatedQuestions[questionIndex].min =
    //             updatedQuestions[questionIndex].min ?? 0;
    //         updatedQuestions[questionIndex].max =
    //             updatedQuestions[questionIndex].max ?? 10;
    //     } else {
    //         if ("min" in updatedQuestions[questionIndex]) {
    //             delete updatedQuestions[questionIndex].min;
    //         }
    //         if ("max" in updatedQuestions[questionIndex]) {
    //             delete updatedQuestions[questionIndex].max;
    //         }
    //     }
    //     newSections[selectedSectionAndPage.sectionIndex].pages[
    //         pageIndex
    //     ].questions = updatedQuestions;

    //     return newSections;
    // });

    if (selectedSectionAndPage.pageName === "All") {
      if (param === "min") {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].min = option;
      } else if (param === "max") {
        _sections[selectedSectionAndPage.sectionIndex].pages[
          pageIndex
        ].questions[sectionQIndex].max = option;
      }
    } else {
      if (param === "min") {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].min = option;
      } else if (param === "max") {
        _sections[selectedSectionAndPage.sectionIndex].pages.find(
          (p) => p.name === selectedSectionAndPage.pageName
        ).questions[sectionQIndex].max = option;
      }
    }

    _editingSurvey.content.pages.find(
      (s) =>
        s.name.toLowerCase() ===
        selectedSectionAndPage.sectionName.toLowerCase()
    ).elements[0].elements[surveyContentQIndex].elements[0][param] = option;

    setSections(_sections);
    setEditingSurvey(_editingSurvey);
  };
  const changePanelTextTypeOptions = (pageIndex, questionIndex,panelQuestionIndex, option, param,nestedIndexLvl2=null) => {
    let _editingSurvey = structuredClone(editingSurvey);
    let _sections = structuredClone(sections);
    const newQIndexes = getNewQIndexes(
      selectedSectionAndPage.sectionName,
      selectedSectionAndPage.pageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );

    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    if(nestedIndexLvl2===null){
      if (selectedSectionAndPage.pageName === "All") {
        if (param === "min") {
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].templateElements[panelQuestionIndex].min = option;
        } else if (param === "max") {
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].templateElements[panelQuestionIndex].max = option;
        }
      }else {
        if (param === "min") {
          _sections[selectedSectionAndPage.sectionIndex].pages.find(
            (p) => p.name === selectedSectionAndPage.pageName
          ).questions[sectionQIndex].templateElements[panelQuestionIndex].min = option;
        } else if (param === "max") {
          _sections[selectedSectionAndPage.sectionIndex].pages.find(
            (p) => p.name === selectedSectionAndPage.pageName
          ).questions[sectionQIndex].templateElements[panelQuestionIndex].max = option;
        }
      }

      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex][param] = option;
    }else{
      if (selectedSectionAndPage.pageName === "All") {
        if (param === "min") {
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].min = option;
        } else if (param === "max") {
          _sections[selectedSectionAndPage.sectionIndex].pages[
            pageIndex
          ].questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].max = option;
        }
      }else {
        if (param === "min") {
          _sections[selectedSectionAndPage.sectionIndex].pages.find(
            (p) => p.name === selectedSectionAndPage.pageName
          ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].min = option;
        } else if (param === "max") {
          _sections[selectedSectionAndPage.sectionIndex].pages.find(
            (p) => p.name === selectedSectionAndPage.pageName
          ).questions[sectionQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2].max = option;
        }
      }

      _editingSurvey.content.pages.find(
        (s) =>
          s.name.toLowerCase() ===
          selectedSectionAndPage.sectionName.toLowerCase()
      ).elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex].templateElements[nestedIndexLvl2][param] = option;
    }



    setSections(_sections);
    setEditingSurvey(_editingSurvey);
  };
  useEffect(() => {
    if (newQuestion.type !== undefined) {
      addNewQuestion(0, 0, newQuestion);
      // dispatch(setNewQuestion({}));
      dispatch(updateTabStates(topMenuTabs.activeTab, "newQuestion", {}));
    }
  }, [newQuestion]);

  function getNewQIndexes(
    currentSectionName,
    currentPageName,
    _editingSurvey,
    _sections,
    pageIndex,
    questionIndex
  ) {
    let sectionQIndex = 0;
    let surveyContentQIndex = 0;

    if (currentPageName === "All") {
      if (newQuestion.from === "qbank" || newQuestion.from === "inputpanel") {
        sectionQIndex = _sections.find((s) => s.name === currentSectionName)
          ?.pages[
          _sections.find((s) => s.name === currentSectionName)?.pages.length - 1
        ].questions.length;
        surveyContentQIndex = _editingSurvey.content?.pages.find(
          (s) => s.name === currentSectionName
        ).elements[0].elements.length;
      } else {
        sectionQIndex = questionIndex;
        const htmlIndexes = _editingSurvey.content?.pages
          .find((s) => s.name === currentSectionName)
          .elements[0].elements.map((item, index) =>
            item.type === "html" ? index : null
          )
          .filter((index) => index !== null);
        surveyContentQIndex = htmlIndexes[pageIndex] + questionIndex + 1;
      }
    } else {
      if (newQuestion.from === "qbank" || newQuestion.from === "inputpanel") {
        sectionQIndex = _sections
          .find((s) => s.name === currentSectionName)
          ?.pages.find((p) => p.name === currentPageName).questions.length;
        const htmlIndexes = _editingSurvey.content?.pages
          .find((s) => s.name === currentSectionName)
          .elements[0].elements.map((item, index) =>
            item.type === "html" ? index : null
          )
          .filter((index) => index !== null);
        const htmlIndex = _editingSurvey.content?.pages
          .find((s) => s.name === currentSectionName)
          .elements[0].elements.findIndex(
            (item) => item.type === "html" && item.name === currentPageName
          );
        if (htmlIndexes.indexOf(htmlIndex) === htmlIndexes.length - 1) {
          surveyContentQIndex = _editingSurvey.content?.pages.find(
            (s) => s.name === currentSectionName
          ).elements[0].elements.length;
        } else {
          surveyContentQIndex = htmlIndexes[htmlIndexes.indexOf(htmlIndex) + 1];
        }
      } else {
        sectionQIndex = questionIndex;
        const htmlIndex = _editingSurvey.content?.pages
          .find((s) => s.name === currentSectionName)
          .elements[0].elements.findIndex(
            (item) => item.type === "html" && item.name === currentPageName
          );
        surveyContentQIndex = htmlIndex + questionIndex + 1;
      }
    }

    return {
      sectionQIndex: sectionQIndex,
      surveyContentQIndex: surveyContentQIndex,
    };
  }

  async function addNewQuestion(pageIndex, questionIndex, newQuestion) {
    let _sections = structuredClone(sections);
    let _editingSurvey = structuredClone(editingSurvey);
    let currentSectionName = selectedSectionAndPage.sectionName;
    let currentPageName = selectedSectionAndPage.pageName;
    let currentSectionIndex = selectedSectionAndPage.sectionIndex;
    let isPanelDynamic = false
    if (_sections.length === 0) {
      _sections.push({
        name: "New Section",
        pages: [
          {
            name: "New Page",
            questions: [],
          },
        ],
      });
      _editingSurvey.content.pages.push({
        name: "New Section",
        title: "New Section",
        elements: [
          {
            type: "panel",
            name: "New Section",
            elements: [
              {
                type: "html",
                name: "New Page",
                html: "<h5>New Page</h5>",
              },
            ],
          },
        ],
      });

      // dispatch(setCurrentSurvey(_editingSurvey));


      currentSectionName = "New Section";
      currentPageName = "New Page";
      currentSectionIndex = 0;
    } else if (_sections[currentSectionIndex]?.pages?.length === 0) {
      _sections[currentSectionIndex].pages.push({
        name: "New Page",
        questions: [],
      });
      _editingSurvey.content.pages
        .find((s) => s.name === currentSectionName)
        .elements[0].elements.push({
          type: "html",
          name: "New Page",
          html: "<h5>New Page</h5>",
        });

      // dispatch(setCurrentSurvey(_editingSurvey));

      currentPageName = "New Page";
    } else if (questionIsExist(newQuestion.question)) {
      setQuestionAddInfoMenuShow(true);
      return;
    }

    const newQIndexes = getNewQIndexes(
      currentSectionName,
      currentPageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );
    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;

    const generatedQuestionName = `q_${Date.now()}_${Math.random()
      .toString(36)
      .slice(2, 10)}`;

    let _sectionNewQuestion = {};
    let _editingSurveyNewQuestion = {};
    if (newQuestion.type === "radiogroup" || newQuestion.type === "dropdown") {
      _sectionNewQuestion = {
        name:
          newQuestion.from === "qbank" ? newQuestion.question : generatedQuestionName,
        editing_name:
          newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        weight: 1.0,
        editing_weight: 1.0,
        asIsToBe: false,
        editing_asIsToBe: false,
        elements: newQuestion.from === "qbank" ? newQuestion.options : [],
        editing_elements:
          newQuestion.from === "qbank" ? newQuestion.options : [],
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        name:
          newQuestion.from === "qbank" ? newQuestion.question : generatedQuestionName,
        type: newQuestion.type,
        weight: 1.0,
        asIsToBe: false,
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        choices: newQuestion.from === "qbank" ? newQuestion.options : [],
      };
    } else if (newQuestion.type === "paneldynamic") {
      isPanelDynamic = true
      _sectionNewQuestion = {
        name:
          newQuestion.from === "qbank" ? newQuestion.question : generatedQuestionName,
        editing_name:
          newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,

        templateElements:  [],
        editing_template_elements: [],

        isEditing: newQuestion.from === "qbank" ? false : true,

      };
      _editingSurveyNewQuestion = {
        name:
          newQuestion.from === "qbank" ? newQuestion.question : generatedQuestionName,
        type: newQuestion.type,
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        templateElements: [],
      };
    }
    else if (newQuestion.type === "tagbox") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        elements: newQuestion.from === "qbank" ? newQuestion.options : [],
        editing_elements:
          newQuestion.from === "qbank" ? newQuestion.options : [],
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: newQuestion.type,
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        choices: newQuestion.from === "qbank" ? newQuestion.options : [],
      };
    } else if (newQuestion.type === "checkbox") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        elements: newQuestion.from === "qbank" ? newQuestion.options : [],
        editing_elements:
          newQuestion.from === "qbank" ? newQuestion.options : [],
        colCount: 1,
        showNoneItem: true,
        editing_showNoneItem: true,
        showOtherItem: true,
        editing_showOtherItem: true,
        showSelectAllItem: true,
        editing_showSelectAllItem: true,
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: "checkbox",
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        choices: newQuestion.from === "qbank" ? newQuestion.options : [],
        showNoneItem: true,
        showOtherItem: true,
        showSelectAllItem: true,
      };
    } else if (newQuestion.type === "rating") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        weight: 1.0,
        editing_weight: 1.0,
        rateCount: 5,
        editing_rateCount: 5,
        rateMax: 5,
        rateType: "stars",
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: "rating",
        weight: 1.0,
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        rateCount: 5,
        rateMax: 5,
        rateType: "stars",
        displayMode: "buttons",
      };
    } else if (newQuestion.type === "boolean") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        renderAs: "switch",
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: "boolean",
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        valueTrue: "Yes",
        valueFalse: "No",
      };
    } else if (newQuestion.type === "comment") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        rows: 3,
        allowResize: true,
        maxLength: 0,
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: "comment",
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        rows: 2,
        autoGrow: true,
        allowResize: true,
      };
    } else if (newQuestion.type === "text") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        inputType: "text",
        editing_inputType: "text",
        maxLength: 100,
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: "text",
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        min: 0,
        max: 100,
        inputType: "text",
      };
    } else if (newQuestion.type === "ranking") {
      _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        elements: newQuestion.from === "qbank" ? newQuestion.options : [],
        editing_elements:
          newQuestion.from === "qbank" ? newQuestion.options : [],
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
      _editingSurveyNewQuestion = {
        type: "ranking",
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        choices: newQuestion.from === "qbank" ? newQuestion.options : [],
      };
    }

    // Ensure every newly added question has a stable non-empty name (SurveyJS identifier).
    // QBank already sets a value; Input Panel previously left it empty which breaks matching later.
    if (newQuestion.from !== "qbank") {
      if (!_sectionNewQuestion.name) {
        _sectionNewQuestion.name = generatedQuestionName;
      }
      if (!_editingSurveyNewQuestion.name) {
        _editingSurveyNewQuestion.name = generatedQuestionName;
      }
    }

    if (currentPageName === "All") {
      if (newQuestion.from === "qbank" || newQuestion.from === "inputpanel") {
        _sections[currentSectionIndex].pages[
          _sections[currentSectionIndex].pages.length - 1
        ].questions.push(_sectionNewQuestion);
      } else {
        _sections[currentSectionIndex].pages[pageIndex].questions.splice(sectionQIndex,0,_sectionNewQuestion);
      }
    } else {
      if (newQuestion.from === "qbank" || newQuestion.from === "inputpanel") {
        _sections[currentSectionIndex].pages
          .find((p) => p.name === currentPageName)
          .questions.push(_sectionNewQuestion);
      } else {
        _sections[currentSectionIndex].pages
          .find((p) => p.name === currentPageName)
          .questions.splice(sectionQIndex, 0, _sectionNewQuestion);
      }
    }
          dispatch(
        updateTabStates(topMenuTabs.activeTab, "currentSurvey", _editingSurvey)
      );

    if (isPanelDynamic) {
      _editingSurvey.content.pages
        .find((s) => s.name === currentSectionName)
        .elements[0].elements.splice(surveyContentQIndex, 0, {
          type: "paneldynamic",
          name: "",
          templateElements: [],
        });
    }
    else {
      _editingSurvey.content.pages
        .find((s) => s.name === currentSectionName)
        .elements[0].elements.splice(surveyContentQIndex, 0, {
          type: "panel",
          name: "",
          elements: [_editingSurveyNewQuestion],
        });
    }
    setSections(_sections);
    setEditingSurvey(_editingSurvey)
    if (newQuestion.from === "qbank" || newQuestion.from === "inputpanel") {
      scrollToBottom();

        // saveChanges(_editingSurvey);
    }
    if (newQuestion.from === "qbank") {
      saveChanges(_editingSurvey);
    }
  }
  const addNewQuestionToPanelDynamic = (question, pageIndex, questionIndex,panelQuestionIndex, newQuestion ,panelLevel2QuestionIndex) => {
    let _sections = structuredClone(sections);
    let _editingSurvey = structuredClone(editingSurvey);
    let currentSectionName = selectedSectionAndPage.sectionName;
    let currentPageName = selectedSectionAndPage.pageName;
    let currentSectionIndex = selectedSectionAndPage.sectionIndex;
    if (_sections.length === 0) {
      _sections.push({
        name: "New Section",
        pages: [
          {
            name: "New Page",
            questions: [],
          },
        ],
      });
      _editingSurvey.content.pages.push({
        name: "New Section",
        title: "New Section",
        elements: [
          {
            type: "panel",
            name: "New Section",
            elements: [
              {
                type: "html",
                name: "New Page",
                html: "<h5>New Page</h5>",
              },
            ],
          },
        ],
      });
  
      // dispatch(setCurrentSurvey(_editingSurvey));
  
  
      currentSectionName = "New Section";
      currentPageName = "New Page";
      currentSectionIndex = 0;
    } else if (_sections[currentSectionIndex].pages.length === 0) {
      _sections[currentSectionIndex].pages.push({
        name: "New Page",
        questions: [],
        });
        _editingSurvey.content.pages
          .find((s) => s.name === currentSectionName)
          .elements[0].elements.push({
            type: "html",
            name: "New Page",
            html: "<h5>New Page</h5>",
          });
  
        // dispatch(setCurrentSurvey(_editingSurvey));

   
    }
    //  else if (questionIsExist(newQuestion.question)) {
    //     setQuestionAddInfoMenuShow(true);
    //     return;
    // }
    const newQIndexes = getNewQIndexes(
      currentSectionName,
      currentPageName,
      _editingSurvey,
      _sections,
      pageIndex,
      questionIndex
    );
    const sectionQIndex = newQIndexes.sectionQIndex;
    const surveyContentQIndex = newQIndexes.surveyContentQIndex;
    const _sectionNewQuestion = {
        name: newQuestion.from === "qbank" ? newQuestion.question : "",
        editing_name: newQuestion.from === "qbank" ? newQuestion.question : "",
        type: newQuestion.type,
        editing_type: newQuestion.type,
        weight: 1.0,
        editing_weight: 1.0,
        asIsToBe: false,
        editing_asIsToBe: false,
        elements: newQuestion.from === "qbank" ? newQuestion.options : [],
        editing_elements:
          newQuestion.from === "qbank" ? newQuestion.options : [],
        isRequired: false,
        isEditing: newQuestion.from === "qbank" ? false : true,
        is_exist: false,
      };
    const _editingSurveyNewQuestion = {
        type: newQuestion.type,
        weight: 1.0,
        asIsToBe: false,
        title: newQuestion.from === "qbank" ? newQuestion.question : "",
        isRequired: false,
        choices: newQuestion.from === "qbank" ? newQuestion.options : [],
    };

    if (currentPageName === "All" ) {
      if(newQuestion.from !=="insideFromPanelQuestion"){
          _sections[currentSectionIndex].pages[
          _sections[currentSectionIndex].pages.length - 1
        ].questions[questionIndex].templateElements.push(_sectionNewQuestion);
      }else{
           _sections[currentSectionIndex].pages[
          _sections[currentSectionIndex].pages.length - 1
        ].questions[questionIndex].templateElements[panelQuestionIndex].templateElements?.push(_sectionNewQuestion);
      }
         

        


    } else {
        if(newQuestion.from !=="insideFromPanelQuestion"){
     sections[currentSectionIndex].pages
          .find((p) => p.name === currentPageName)
          .questions[questionIndex].templateElements.push(_sectionNewQuestion);
        }else{
          sections[currentSectionIndex].pages
          .find((p) => p.name === currentPageName)
          .questions[questionIndex].templateElements[panelQuestionIndex].templateElements.push(_sectionNewQuestion);
        }
       
    }
    if (newQuestion.from !== "insideFromPanelQuestion"){
      const section = _editingSurvey.content.pages.find(
        (s) => s.name === currentSectionName
      );
      const panel = section.elements[0].elements[surveyContentQIndex];
      if (!panel.templateElements) {
        panel.templateElements = [];
      }

      // Sonra push et
  
      panel.templateElements.push(_editingSurveyNewQuestion);
    }else{
      const section = _editingSurvey.content.pages.find(
        (s) => s.name === currentSectionName
      );
      const panel = section.elements[0].elements[surveyContentQIndex].templateElements[panelQuestionIndex];
      if (!panel.templateElements) {
        panel.templateElements = [];
      }

      // Sonra push et
  
      panel.templateElements.push(_editingSurveyNewQuestion);
    }
    dispatch(
      updateTabStates(topMenuTabs.activeTab, "currentSurvey", _editingSurvey)
    );

    setSections(_sections);
    setEditingSurvey(_editingSurvey);
    scrollToPanelDynamic(pageIndex,questionIndex);
 
    // saveChanges(_editingSurvey)
  };




  async function getQuestions() {
    await getQuestionsFromAPI(token)
      .then((questions) => {
        dispatch(setQuestions(questions));
      })
      .catch((error) => {
        if (error.message === "Request failed with status code 401" || error.response.status === 401) {
          setSelectedFunction("getQuestions");
          checkAuth();
        }
      });
  }
function collectElements(el) {
 
  if (el.type !== "paneldynamic") {
    return [el.elements?.[0]];
  }

  // paneldynamic içindeyse recursive olarak derine in
  let collected = [];
  for (const child of el.templateElements || []) {
    if (child.type !== "paneldynamic"){
      collected.push(child)
    }else{
    collected.push(...collectElements(child)); // derine in
    }
  }
  return collected;
}


async function saveChanges(_editingSurvey) {

  // 1️⃣ Limitli paralel API çağrıları için
  const limit = pLimit(10);

  // 2️⃣ Mevcut soruları al ve Map oluştur
  const latestQuestions = await getQuestionsFromAPI(token);
  const questionMap = new Map();
  for (const q of latestQuestions) {
    const key = `${q.question.trim()}|${q.type}|${(q.options || []).slice().sort().join()}`;
    questionMap.set(key, q.ID);
  }

  // 3️⃣ Tüm elementleri tek bir array olarak toplamak (nested paneldynamic dahil)
  const allElements = [];
  for (const page of _editingSurvey.content.pages) {
    for (const element of page.elements[0].elements || []) {
      if (element.type !== "html") {
        allElements.push(...collectElements(element));
      }
    }
  }

  // 4️⃣ API çağrılarını limitli paralel şekilde yap
  const addQuestionPromises = allElements.map(el =>
    limit(async () => {
      if (!el?.title) return;

      const key = `${el.title.trim()}|${el.type}|${(el.choices||[]).map(x=>x.text).sort().join()}`;
      const existingId = questionMap.get(key);

      if (existingId) {
        el.name = `${existingId}_${Math.random().toString(36).substring(2, 8)}`;
      } else {
        const obj = {
          options: el.choices?.map(x => x.text) || [],
          question: el.title.trim(),
          type: el.type,
          organization_id: organizations.find(x => x.organization_name === currentSurvey.organization).ID
        };
        try {
          const res = await addQuestionFromAPI(token, obj);
          el.name = `${res.question_id}_${Math.random().toString(36).substring(2, 8)}`;
        } catch (err) {
          console.error("Add question error", err);
        }
      }
    })
  );

  await Promise.all(addQuestionPromises);

  // 5️⃣ Survey’i API üzerinden güncelle
  const obj = { content: _editingSurvey.content };
  try {
    const result = await updateSurveyFromAPI(token, obj, _editingSurvey.ID);
    dispatch(updateTabStates(topMenuTabs.activeTab, "currentSurvey", _editingSurvey));
  } catch (error) {
    if (error.message === "Request failed with status code 401" || error.response?.status === 401) {
      setSelectedFunction("saveChangesFast");
      setSelectedFunctionParams(_editingSurvey);
      checkAuth();
    } else {
      console.error("Update survey error", error);
    }
  }
}


  const handleClickOutside = (event) => {
    // Eğer tıklama menü dışında gerçekleştiyse, menüyü kapat
    if (
      questionTypesMenuRef.current &&
      !questionTypesMenuRef.current.contains(event.target)
    ) {
      setShowQuestionTypes(false);
    }
    if (
      textQuestionTypesMenuRef.current &&
      !textQuestionTypesMenuRef.current.contains(event.target)
    ) {
      setShowTextQuestionTypes(false);
    }
    if (
      asIsToBeMenuRef.current &&
      !asIsToBeMenuRef.current.contains(event.target)
    ) {
      setShowAsIsToBeOptions(false);
    }
  };
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);
  const [activeQuestionAsIsToBeIndex, setActiveQuestionAsIsToBeIndex] = useState(null);
  useEffect(() => {
    if (!deleteInfoMenuShow) return;
    const timer = setTimeout(() => {
      setDeleteInfoMenuShow(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, [deleteInfoMenuShow]);

  // Helper – her nestedEl'e ilk kez render olduğunda bir UID ata
  const assignUID = (item) => {
    if (!item.__uid) {
      item.__uid = Math.random().toString(36).slice(2, 10); // küçük ama stable uid
    }
    return item.__uid;
  };


  return (
    <div className={`flex w-full`}>
      <div
        className={`flex flex-grow  flex flex-col items-center justify-center p-6   
                    ${themeMode === "dark" ? "bg-[#1a1a28]" : "bg-[#ffffff]"}
                    ${currentSurvey.status !== "Draft"
            ? "cursor:auto pointer-events-none opacity-50"
            : ""
          }
                `}
      >
        <div className={`flex flex-row items-end justify-between w-full pb-6`}>
          <div
            className={`flex items-center text-lg font-semibold ${themeMode === "dark" ? "text-white" : "text-black"
              }`}
          >
            {selectedSectionAndPage.sectionName
              ? "Section: " + selectedSectionAndPage.sectionName
              : ""}
          </div>
          <div>
            {/* Açma Butonu */}
            <button
              onClick={() => setIsPreviewOpen(true)}
              id="designSurveyPreview"
              className=" bottom-5 right-5 p-2 bg-blue-600 text-white rounded-full shadow-lg"
            >
              <EyeIcon className="w-4 h-4" />
            </button>

            {/* Modal */}
            {isPreviewOpen && (
              <div className="fixed inset-0  z-[99999] bg-black bg-opacity-50 flex justify-center items-center">
                <div className="bg-white p-6 relative  w-screen h-screen overflow-y-auto">
                  {/* Kapatma Butonu */}
                  <button
                    onClick={() => setIsPreviewOpen(false)}
                    className="absolute top-[0] right-3 text-gray-600 hover:text-black mb-4"
                  >
                    <XMarkIcon className="w-6 h-6" />
                  </button>

                  {/* İçerik */}
                  <SurveyPreview surveyData={currentSurvey.content} />
                </div>
              </div>
            )}
          </div>
        </div>
        <DragDropContext
          onDragEnd={(e) => onDragEnd(e)}
          key={"section-key"}
          className="cursor:auto pointer-events-none opacity-50"
        >
          {selectedSectionAndPage.sectionName &&
            sections
              .find(
                (s) =>
                  s.name.toLowerCase() ===
                  selectedSectionAndPage.sectionName.toLowerCase()
              )
              ?.pages.map((page, pageIndex) =>
   selectedSectionAndPage.pageName === "All" || page.name ===  selectedSectionAndPage.pageName ?(
             
        
                <Droppable
                  droppableId={"droppable-" + pageIndex}
                  key={"droppable-" + pageIndex}
                  type="question"
                >
                  {(provided, snapshot) => (
                    <div
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      className={`droppable-area relative ${snapshot.isDraggingOver ? "dragging-over" : ""
                        }  flex flex-col text-white items-center justify-center w-full  ${themeMode === "dark"
                          ? "bg-[#a5bdff0d]"
                          : "bg-[#1530720d]"
                        } rounded-lg p-8 mb-6 space-y-8 pb-10 min-h-[150px]`}
                    >
                      {!(
                        selectedSectionAndPage.sectionName === page.name &&
                        sections
                          .find(
                            (s) =>
                              s.name.toLowerCase() ===
                              selectedSectionAndPage.sectionName.toLowerCase()
                          )
                          ?.pages.filter(
                            (p) =>
                              p.name === selectedSectionAndPage.pageName ||
                              selectedSectionAndPage.pageName === "All"
                          ).length === 1
                      ) && (
                          <div
                            className={`absolute top-0 left-50 bg-[#a5bdff1a] px-2 py-1 rounded-b-lg ${themeMode === "dark" ? "text-white" : "text-black"
                              }`}
                          >
                            Page: {page.name}
                          </div>
                        )}
                      {page.questions.map((question, qIndex) => (
                        <div
                          key={`questionCard-${pageIndex}-${qIndex}`}
                          id="designQuestionCard"
                          className=" relative flex flex-col w-full space-y-3 p-4 pt-4"
                        >
                          <Draggable
                            key={`questionDraggable-${pageIndex}-${qIndex}`}
                            draggableId={`question-${pageIndex}-${qIndex}`}
                            index={qIndex}
                            className={`questionDraggable-${qIndex}`}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                className={`relative group flex flex-col w-full space-y-3 ${question?.editing_type === "paneldynamic" ?"pb-8":""} p-8 border border-dashed border-gray-400 rounded-lg hover:border-gray-600 hover:shadow-lg hover:bg-[#a5bdff0d]`}
                              >
                                <div
                                  className={`absolute bottom-0 right-0 px-2 py-1 mt-2 rounded-tl-lg cursor-pointer flex items-center space-x-2 ${themeMode === "dark"
                                      ? " text-white"
                                      : "  text-black-8"
                                    }`}
                                >
                                  {!question?.isEditing &&
                                    (question.type === "radiogroup" ||
                                      question.type === "dropdown" ||
                                      question.type === "rating") &&
                                    currentSurvey?.content?.pages.find(
                                      (s) =>
                                        s.name.toLowerCase() ===
                                        selectedSectionAndPage.sectionName?.toLowerCase()
                                    )?.type !== "demographics" && (
                                      <div className="flex flex-row space-x-2">
                                        <span className="text-sm font-medium hidden sm:block">
                                          Weight: {question?.weight}
                                        </span>
                                        <span className="text-sm font-medium hidden sm:block">
                                       
                                          asIsToBe: {question?.asIsToBe === true ? "Yes" : "No"}
                                        </span>
                                      </div>
                                    )}
                                  {!question?.isEditing && (
                                    <div className="flex items-center space-x-2">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-5"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                        />
                                      </svg>
                                      <span className="text-sm font-medium hidden sm:block">
                                        {fixQuestionTypeName(
                                          question?.editing_type
                                        )}
                                      </span>
                                    </div>
                                  )}
                                  {question?.isEditing && question?.type === "paneldynamic" && (
                                    <div className="flex items-center space-x-2">
                                 
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-5"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                        />
                                      </svg>
                                      <span className="text-sm font-medium hidden sm:block">
                                        {fixQuestionTypeName(
                                          question?.editing_type
                                        )}
                                      </span>
                                    </div>
                                  )}
                                  {question?.isEditing &&
                                    (question.editing_type === "radiogroup" ||
                                      question.editing_type === "dropdown" ||
                                      question.editing_type === "rating") &&
                                    currentSurvey?.content?.pages.find(
                                      (s) =>
                                        s.name.toLowerCase() ===
                                        selectedSectionAndPage.sectionName?.toLowerCase()
                                    )?.type !== "demographics" && (
                                      <div className="flex space-x-2">
                                        <div className="flex items-center space-x-2">
                                          <span className="text-sm font-medium hidden sm:block">
                                            Weight:
                                          </span>
                                          <input
                                            id="numberInput"
                                            type="text"
                                            value={question?.editing_weight?.toString() || ""}
                                            onChange={(e) =>
                                              handleWeightChange(
                                                pageIndex,
                                                qIndex,
                                                e.target.value
                                              )
                                            }
                                            className={`text-sm font-medium bg-transparent border rounded-md p-1 w-12 text-center ${themeMode === "dark"
                                                ? " text-white border-1 border-gray-400"
                                                : "  text-black border border-black-06"
                                           }`}
                                          />
                                        </div>
                                        {/* <div className="flex items-center space-x-2">
                                          <span className="text-sm font-medium hidden sm:block">
                                            asIsToBe:
                                          </span>
                                          <input
                                            id="numberInput"
                                            type="text"
                                            value={question?.editing_asIsToBe?.toString() || ""}
                                            onChange={(e) =>
                                              handleAsIsToBeChange(
                                                pageIndex,
                                                qIndex,
                                                e.target.value
                                              )
                                            }
                                            className={`text-sm font-medium bg-transparent border rounded-md p-1 w-12 text-center ${themeMode === "dark"
                                                ? " text-white border-1 border-gray-400"
                                                : "  text-black border border-black-06"
                                              }`}
                                          />

                                        </div> */}
                                        <span className="text-sm font-medium hidden sm:block mt-1">
                                         asIsToBe:
                                        </span>
                                        <div className=" relative font-normal text-[1.25rem] cursor-pointer w-full min-w-0 min-h-0 flex items-center flex-nowrap">
                                            {question?.editing_type && (
                                              <button
                                                className={` text-[0.875rem] p-1 border hover: rounded-md ${themeMode === "dark"
                                                    ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                    : "bg-[#ffffff0a] text-black border-black-06"
                                                  }`}
                                                onClick={() => {
                                                  if (
                                                    activeQuestionAsIsToBeIndex === qIndex
                                                  ) {
                                                    setShowAsIsToBeOptions(false); // Menü açma/kapama
                                                    setActiveQuestionAsIsToBeIndex(null);
                                                  } else {
                                                    setActiveQuestionAsIsToBeIndex(qIndex); // Yeni soruyu aktif yap
                                                    setShowAsIsToBeOptions(true); // Menüyü aç
                                                  }
                                                }}
                                              >
                                                <div className="flex items-center justify-start">
                                                  {/* <span>{questionTypes.find(x => x.name === fixQuestionTypeName(question?.type)).img}</span> */}
                                               {question?.editing_asIsToBe} 
                                                  <span>
                                                    {
                                                      question?.editing_asIsToBe=== true?"Yes":"No"
                                                    }
                                                  </span>
                                                </div>
                                              </button>
                                            )}
                                            {showAsIsToBeOptions && activeQuestionAsIsToBeIndex === qIndex && (
                                                <div
                                                  ref={asIsToBeMenuRef}
                                                  id="questionAsIsToBeMenu"
                                                  className={`absolute flex flex-col  ${qIndex ===
                                                      page.questions.length - 1
                                                      ? "bottom-10"
                                                      : "top-9"
                                                    } left-0 min-w-[200px] border  max-h-[100px] overflow-y-auto rounded-md z-[999999] ${themeMode === "dark"
                                                      ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                      : " bg-gray-200 text-black border-black-06"
                                                    }`}
                                                >
                                                  <div
                                                    className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                    onClick={(e) =>
                                                      handleAsIsToBeChange(
                                                      pageIndex,
                                                      qIndex,
                                                      "true"
                                                      )
                                                    }
                                                  >
                                                    <div className="flex items-center justify-start text-xs my-1">
                                                    
                                                      <span
                                                        className={`ml-1 ${themeMode === "dark"
                                                            ? "text-white text-opacity-60"
                                                            : "text-[#000] text-opacity-60"
                                                          } `}
                                                      >
                                                        Yes
                                                      </span>
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                    onClick={(e) =>
                                                      handleAsIsToBeChange(
                                                      pageIndex,
                                                      qIndex,
                                                      "false"
                                                      )
                                                    }
                                                  >
                                                    <div className="flex items-center justify-start text-xs my-1">
                                                    
                                                      <span
                                                        className={`ml-1 ${themeMode === "dark"
                                                            ? "text-white text-opacity-60"
                                                            : "text-[#000] text-opacity-60"
                                                          } `}
                                                      >
                                                        No
                                                      </span>
                                                    </div>
                                                  </div>
                                                 
                                                 
                                                </div>
                                              )}
                                        </div>
                                      </div>
                                    )}
                                    {question?.isEditing && question?.type !== "paneldynamic" && (
                                      <div className=" relative font-normal text-[1.25rem] cursor-pointer w-full min-w-0 min-h-0 flex items-center flex-nowrap">
                                        {question?.editing_type && (
                                          <button
                                            className={` text-[0.875rem] p-1 border hover: rounded-md ${themeMode === "dark"
                                                ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                : "bg-[#ffffff0a] text-black border-black-06"
                                              }`}
                                            onClick={() => {
                                              if (
                                                activeQuestionIndex === qIndex
                                              ) {
                                                setShowQuestionTypes(false); // Menü açma/kapama
                                                setActiveQuestionIndex(null);
                                              } else {
                                                setActiveQuestionIndex(qIndex); // Yeni soruyu aktif yap
                                                setShowQuestionTypes(true); // Menüyü aç
                                              }
                                            }}
                                          >
                                            <div className="flex items-center justify-start">
                                              {/* <span>{questionTypes.find(x => x.name === fixQuestionTypeName(question?.type)).img}</span> */}
                                              <span>
                                                {fixQuestionTypeName(
                                                  question?.editing_type
                                                )}
                                              </span>
                                            </div>
                                          </button>
                                        )}
                                        {showQuestionTypes &&
                                          activeQuestionIndex === qIndex && (
                                            <div
                                              ref={questionTypesMenuRef}
                                              id="questionTypesMenu"
                                              className={`absolute flex flex-col  ${qIndex ===
                                                  page.questions.length - 1
                                                  ? "bottom-10"
                                                  : "top-9"
                                                } left-0 min-w-[200px] border  max-h-[100px] overflow-y-auto rounded-md z-[999999] ${themeMode === "dark"
                                                  ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                  : " bg-gray-200 text-black border-black-06"
                                                }`}
                                            >
                                              {questionTypes.map(
                                                (questionType, typeIndex) => (
                                                  <div
                                                    key={`questionType-${pageIndex}-${qIndex}-${typeIndex}`}
                                                    className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                    onClick={() => {
                                                      setShowQuestionTypes(false);
                                                      updateQuestionType(
                                                        pageIndex,
                                                        qIndex,
                                                        fixQuestionTypeName(
                                                          questionType?.name
                                                        )
                                                      );
                                                    }}
                                                  >
                                                    <div className="flex items-center justify-start text-xs my-1">
                                                      <span
                                                        className={`${themeMode === "dark"
                                                            ? "text-white text-opacity-60"
                                                            : "text-[#000] text-opacity-60"
                                                          }`}
                                                      >
                                                        {questionType.img}
                                                      </span>
                                                      <span
                                                        className={`ml-1 ${themeMode === "dark"
                                                            ? "text-white text-opacity-60"
                                                            : "text-[#000] text-opacity-60"
                                                          } `}
                                                      >
                                                        {questionType?.name}
                                                      </span>
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    )}
                                    {question?.type !== "paneldynamic" && (
                                      <button
                                        className={`flex justify-end sm:justify-center items-center flex-nowrap flex-shrink-0   cursor-pointer group inline-flex items-center   py-1 pl-2 pr-2 text-sm font-medium sm:min-w-[4.5rem] sm:max-w-[4.9rem]"`}
                                        onClick={() =>
                                          updateQuestionIsRequired(
                                            question,
                                            pageIndex,
                                            qIndex
                                          )
                                        }
                                      >
                                        {question?.type !== "paneldynamic" && (
                                          question?.isRequired ? (
                                            <>
                                              <RequiredIcon
                                                className="w-4 h-4 mr-1"
                                                fill={themeMode === "dark" ? "white" : "black"}
                                              />
                                              <span className="hidden sm:block">Required</span>
                                            </>
                                          ) : (
                                            <>
                                              <NotRequiredIcon
                                                className="w-4 h-4"
                                                fill={themeMode === "dark" ? "white" : "black"}
                                                circleFill={themeMode === "dark" ? "none" : "white"}
                                                circleStroke={themeMode === "dark" ? "white" : "black"}
                                              />
                                              <span className="hidden sm:block">Not Required</span>
                                            </>
                                          )
                                        )}

                                      </button>
                                    )}


                                </div>
                                <div className="absolute top-0 right-0 px-2 py-0 rounded-tl-lg flex items-center justify-center space-x-2 hidden group-hover:flex">
                                  {question?.isEditing && (
                                    <button
                                      title="Cancel"
                                      className={`flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  ${themeMode === "dark"
                                          ? "text-[#FFFFFF]"
                                          : "text-black"
                                        }  cursor-pointer group inline-flex items-center  py-1 pl-1 pr-1 text-sm font-medium min-w-[1.5rem] max-w-[4.9rem]"`}
                                      onClick={() =>
                                        undoQuestionChanges(
                                          question,
                                          pageIndex,
                                          qIndex
                                        )
                                      }
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-5"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M6 18 18 6M6 6l12 12"
                                        />
                                      </svg>
                                    </button>
                                  )}
                                  {question?.isEditing && (
                                    <button
                                      title="Save"
                                      className={`flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  ${themeMode === "dark"
                                          ? "text-[#FFFFFF]"
                                          : "text-black"
                                        }`}
                                      onClick={() =>
                                        saveQuestionChanges(
                                          question,
                                          pageIndex,
                                          qIndex
                                        )
                                      }
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-5"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="m4.5 12.75 6 6 9-13.5"
                                        />
                                      </svg>
                                    </button>
                                  )}
                                  {!question?.isEditing && (
                                    <button
                                      title="Edit Question"
                                      className={`flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  ${themeMode === "dark"
                                          ? "text-[#FFFFFF]"
                                          : "text-black"
                                        }  cursor-pointer group inline-flex items-center  py-1 pl-1 pr-1 text-sm font-medium min-w-[1.5rem] max-w-[4.9rem]"`}
                                      onClick={() =>
                                        updateQuestionIsEditing(
                                          question,
                                          pageIndex,
                                          qIndex
                                        )
                                      }
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth="1.5"
                                        stroke="currentColor"
                                        className="size-4"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                                        />
                                      </svg>
                                    </button>
                                  )}
                                  
                                  <button
                                    title="Delete Question"
                                    onClick={() => {
                                      setSelectedParam({
                                        param: "question",
                                        pageIndex: pageIndex,
                                        qIndex: qIndex,
                                        index: null,
                                        questionType: null,
                                      });
                                      setDeleteAllowMenuOpen(true);
                                    }}
                                    className={`flex justify-center items-center flex-nowrap flex-shrink-0 rounded-[0.375rem]  ${themeMode === "dark"
                                        ? "text-[#FFFFFF]"
                                        : "text-black"
                                      } cursor-pointer group inline-flex items-center  py-1 pl-1 pr-1 text-sm font-medium min-w-[1.5rem] max-w-[4.9rem]"`}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      strokeWidth="1.5"
                                      stroke="currentColor"
                                      className="size-4"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                      />
                                    </svg>
                                  </button>
                                </div>

                                {!question?.isEditing && (
                                  <div className="pb-4 ">
                                    <p
                                      className={`font-semibold text-lg mt-0  break-words ${themeMode === "dark"
                                          ? "placeholder:text-white text-white "
                                          : " text-[#0f121a] placeholder:text-[#0f121a]"
                                        } max-w-full`}
                                    >
                                      {question?.name}
                                    </p>
                                    <div className="flex flex-col space-y-2 mt-2">
                                      {question?.editing_type === "rating" && (
                                        <div className="rating-container flex space-x-1">
                                          {/* theme değerine göre renk belirleme */}
                                          {Array.from({
                                            length: question?.rateCount,
                                          }).map((_, index) => {
                                            const fillColor =
                                              themeMode === "dark"
                                                ? "white"
                                                : "#14141f"; // Tema kontrolü

                                            return (
                                              <svg
                                                key={`questionRate-${qIndex}-${index}`}
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill={fillColor} // Dinamik renk
                                                className="size-6"
                                              >
                                                <path
                                                  fillRule="evenodd"
                                                  d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                  clipRule="evenodd"
                                                />
                                              </svg>
                                            );
                                          })}
                                        </div>
                                      )}
                                      {question?.editing_type === "boolean" &&
                                        null}
                                      {(question?.editing_type ===
                                        "radiogroup" ||
                                        question?.editing_type === "dropdown" ||
                                        question?.editing_type === "tagbox" ||
                                        question?.editing_type === "checkbox" ||
                                        question?.editing_type === "ranking") &&
                                        question?.editing_elements.map(
                                          (element, index) =>
                                            question?.editing_type ===
                                              "checkbox" ? (
                                              <div
                                                key={`question-title-${qIndex}-${index}`}
                                                className={`flex items-center space-x-2 ${themeMode === "dark"
                                                    ? "placeholder:text-white text-white "
                                                    : " text-[#0f121a] placeholder:text-[#0f121a]"
                                                  }`}
                                              >
                                                <input
                                                  type="radio"
                                                  id={element.value}
                                                  name={element.value}
                                                  value={element.value || ""}
                                                  disabled
                                                />
                                                <label htmlFor={element.text}>
                                                  {element.text}
                                                </label>
                                              </div>
                                            ) : (
                                              <div
                                                  key={`question-title-${qIndex}-${index}`}
                                                className={`flex items-center space-x-2 ${themeMode === "dark"
                                                    ? "placeholder:text-white text-white "
                                                    : " text-[#0f121a] placeholder:text-[#0f121a]"
                                                  }`}
                                              >
                                                <input
                                                  type="radio"
                                                  id={element.value}
                                                  name={element.value}
                                                  value={element.value || ""}
                                                  disabled
                                                />
                                                <label htmlFor={element.value}>
                                                  {element.text}
                                                </label>
                                              </div>
                                            )
                                        )}
                                      {question?.editing_type === "comment" && (
                                        <div className="w-full mt-0 mb-0"></div>
                                      )}
                                      {question?.editing_type === "text" && (
                                        <div className="w-full mt-4 mb-4">
                                          <div
                                            className={`flex items-center space-x-2 ${themeMode === "dark"
                                                ? "placeholder:text-white text-white "
                                                : " text-[#0f121a] placeholder:text-[#0f121a]"
                                              }`}
                                          >
                                            <label htmlFor={question?.name}>
                                              {question?.name}
                                            </label>
                                          </div>
                                        </div>
                                      )}

                                    </div>
                                  </div>
                                )}
                            
                                {!question?.isEditing && question?.editing_type === "paneldynamic" && question.templateElements?.length > 0 && (
                                  <Droppable
                                      droppableId={`paneldynamic-${pageIndex}-${qIndex}`}
                                      key={`paneldynamic-${pageIndex}-${qIndex}`}
                                      type="paneldynamic"
                                    >
                                    {(provided, snapshot) => (
                                      <div
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        className={`droppable-area relative ${snapshot.isDraggingOver ? "dragging-over" : ""
                                          }  flex flex-col text-white items-center justify-center w-full  ${themeMode === "dark"
                                            ? "bg-[#a5bdff0d]"
                                            : "bg-[#1530720d]"
                                          } rounded-lg p-8 mb-6 space-y-8 pb-10 min-h-[150px]`}
                                        >
                                         { question.templateElements.map((el, idx) => (
                                            <Draggable  key={`questionDraggable-${pageIndex}-${qIndex}-${idx}`}
                                              draggableId={`question-${pageIndex}-${qIndex}-${idx}`}
                                              index={idx}
                                              className={`questionDraggable-${qIndex}-${idx}`}>
                                              {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    className={`relative group flex flex-col w-full space-y-3 ${question?.editing_type === "paneldynamic" ?"pb-8":""} p-8 border border-dashed border-gray-400 rounded-lg hover:border-gray-600 hover:shadow-lg hover:bg-[#a5bdff0d]`}
                                                >
                                                  <div key={`paneldynamic-lvl1-${idx}`} className={`w-full min-h-[60px] p-2 border border-gray-400 rounded-lg mt-4 mb-4 relative ${themeMode === "dark"
                                                      ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                      : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                    }`}>
                                                    <div
                                                      className={`absolute bottom-0 right-0 px-2 py-1 mt-8 rounded-tl-lg cursor-pointer flex items-center space-x-2 ${themeMode === "dark"
                                                          ? " text-white"
                                                          : "  text-black-8"
                                                        }`}
                                                    >
                                                      {(el?.editing_type === "rating" || el?.editing_type ==="dropdown" || el?.editing_type === "radiogroup") &&
                                                        currentSurvey?.content?.pages.find(
                                                          (s) =>
                                                            s.name.toLowerCase() ===
                                                            selectedSectionAndPage.sectionName?.toLowerCase()
                                                        )?.type !== "demographics" && (
                                                          <div className="flex flex-row space-x-2">
                                                            <span className="text-sm font-medium hidden sm:block">
                                                              Weight: {el?.weight}
                                                            </span>
                                                            <span className="text-sm font-medium hidden sm:block">
                                                              asIsToBe: {el?.asIsToBe === true ? "Yes" : "No"}
                                                            </span>
                                                          </div>
                                                        )}
                                                      <div className={`flex items-center space-x-2 ${el?.editing_type === "paneldynamic"?"mt-4 pt-4":""}`}>
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          fill="none"
                                                          viewBox="0 0 24 24"
                                                          strokeWidth="1.5"
                                                          stroke="currentColor"
                                                          className="size-5"
                                                        >
                                                          <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                                          />
                                                        </svg>
                                                        <span className={`text-sm font-medium hidden sm:block `}>
                                                          {fixQuestionTypeName(
                                                            el?.editing_type
                                                          )}
                                                        </span>
                                                        {el?.editing_type !== "paneldynamic" &&(
                                                        <button
                                                          className={`flex justify-end sm:justify-center items-center flex-nowrap flex-shrink-0   cursor-pointer group inline-flex items-center   py-1 pl-2 pr-2 text-sm font-medium sm:min-w-[4.5rem] sm:max-w-[4.9rem]"`}
                                                          onClick={() =>
                                                            updatePanelQuestionIsRequired(
                                                              question,
                                                              pageIndex,
                                                              qIndex,
                                                              idx
                                                            )
                                                          }
                                                        >
                                                          {
                                                            el?.isRequired ? (
                                                              <>
                                                                <RequiredIcon
                                                                  className="w-4 h-4 mr-1"
                                                                  fill={themeMode === "dark" ? "white" : "black"}
                                                                />
                                                                <span className="hidden sm:block">Required</span>
                                                              </>
                                                            ) : (
                                                              <>
                                                                <NotRequiredIcon
                                                                  className="w-4 h-4"
                                                                  fill={themeMode === "dark" ? "white" : "black"}
                                                                  circleFill={themeMode === "dark" ? "none" : "white"}
                                                                  circleStroke={themeMode === "dark" ? "white" : "black"}
                                                                />
                                                                <span className="hidden sm:block">Not Required</span>
                                                              </>
                                                            )
                                                          }
                                                        </button>
                                                        )}
                                                      </div>
                                                    </div>
                                                    <p
                                                      className={`font-semibold text-lg mt-0  break-words ${themeMode === "dark"
                                                          ? "placeholder:text-white text-white "
                                                          : " text-[#0f121a] placeholder:text-[#0f121a]"
                                                        } max-w-full`}
                                                    >{el?.editing_name}
                                                    </p>
                                                    {["radiogroup", "dropdown", "checkbox", "tagbox", "ranking"].includes(el?.editing_type) && (
                                                      <div className="flex flex-col space-y-1">
                                                        {el?.elements?.map((choice, cIdx) => (
                                                          <div key={`paneldyanmic-lvl1-${qIndex}-choice-${cIdx}`} className={`flex items-center space-x-2 ${themeMode === "dark"
                                                              ? "placeholder:text-white text-white "
                                                              : " text-[#0f121a] placeholder:text-[#0f121a]"}`}>
                                                            <input
                                                              type="radio"
                                                              id={choice.value}
                                                              name={choice.value}
                                                              value={choice.value || ""}
                                                              disabled
                                                            />
                                                            <label htmlFor={choice.value}>
                                                              {choice.text}
                                                            </label>
                                                          </div>
                                                        ))}
                                                      </div>
                                                    )}
                                                    {el?.editing_type === "rating" && (
                                                      <div className="rating-container flex space-x-1">
                                                        {/* theme değerine göre renk belirleme */}
                                                        {/* {el?.editing_type} */}
                                                        {Array.from({
                                                          length: el?.rateCount,
                                                        }).map((_, index) => {
                                                          const fillColor =
                                                            themeMode === "dark"
                                                              ? "white"
                                                              : "#14141f"; // Tema kontrolü
                                                          return (
                                                            <svg
                                                              key={`paneldynamic-lvl1-rating-${index}`}
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              viewBox="0 0 24 24"
                                                              fill={fillColor} // Dinamik renk
                                                              className="size-6"
                                                            >
                                                              <path
                                                                fillRule="evenodd"
                                                                d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                                clipRule="evenodd"
                                                              />
                                                            </svg>
                                                          );
                                                        })}
                                                      </div>
                                                    )}
                                                    {el?.editing_type === "boolean" &&
                                                      null}
                                                    {question?.editing_type === "comment" && (
                                                      <div className="w-full mt-0 mb-0"></div>
                                                    )}
                                                    {el?.editing_type === "text" && (
                                                      <div className="w-full mt-4 mb-4">
                                                        <div
                                                          className={`flex items-center space-x-2 ${themeMode === "dark"
                                                              ? "placeholder:text-white text-white "
                                                              : " text-[#0f121a] placeholder:text-[#0f121a]"
                                                            }`}
                                                        >
                                                          <label htmlFor={el?.name}>
                                                            {el?.name}
                                                          </label>
                                                        </div>
                                                      </div>
                                                    )}
                                                    {el?.editing_type === "paneldynamic" && (
                                                      <Droppable
                                                      droppableId={`paneldynamic-inner-${pageIndex}-${qIndex}-${idx}`}
                                                      key={`paneldynamic-inner-${pageIndex}-${qIndex}-${idx}`}
                                                      type="paneldynamic-inner"
                                                    >
                                                      {(provided, snapshot) => (
                                                        <div
                                                          {...provided.droppableProps}
                                                          ref={provided.innerRef}
                                                          className={`droppable-area relative ${snapshot.isDraggingOver ? "dragging-over" : ""
                                                            }  flex flex-col text-white items-start justify-start w-full  ${themeMode === "dark"
                                                              ? "bg-[#a5bdff0d]"
                                                              : "bg-[#1530720d]"
                                                            } rounded-lg p-8 mb-6 space-y-8 pb-10 min-h-[150px]`}
                                                          >
                                                        {el.templateElements.map((nestedElLvl2, nestedIndexLvl2) => (
                                                          <Draggable  key={`questionDraggable-${pageIndex}-${qIndex}-${idx}-${nestedIndexLvl2}`}
                                                            draggableId={`question-${pageIndex}-${qIndex}-${idx}-${nestedIndexLvl2}`}
                                                            index={nestedIndexLvl2}
                                                            className={`questionDraggable-${qIndex}-${idx}`}>
                                                            {(provided) => (
                                                              <div
                                                                  ref={provided.innerRef}
                                                                  {...provided.draggableProps}
                                                                  {...provided.dragHandleProps}
                                                                  className={`relative group flex flex-col w-full space-y-3 ${question?.editing_type === "paneldynamic" ?"pb-8":""} p-8 border border-dashed border-gray-400 rounded-lg hover:border-gray-600 hover:shadow-lg hover:bg-[#a5bdff0d]`}
                                                              >
                                                              <div key={`paneldyanmic-lvl1-${qIndex}-element-${idx}-child-${nestedIndexLvl2}`} className={`w-full min-h-[60px] p-2 border border-gray-400 rounded-lg mt-4 mb-4 relative ${themeMode === "dark"
                                                                  ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                                  : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                                }`}>
                                                                <div
                                                                  className={`absolute bottom-0 right-0 px-2 py-1 rounded-tl-lg cursor-pointer flex items-center space-x-2 ${themeMode === "dark"
                                                                      ? " text-white"
                                                                      : "  text-black-8"
                                                                    }`}
                                                                >
                                                                  {(nestedElLvl2?.editing_type === "rating" || nestedElLvl2?.editing_type ==="dropdown" || nestedElLvl2?.editing_type === "radiogroup") &&
                                                                    currentSurvey?.content?.pages.find(
                                                                      (s) =>
                                                                        s.name.toLowerCase() ===
                                                                        selectedSectionAndPage.sectionName?.toLowerCase()
                                                                    )?.type !== "demographics" && (
                                                                      <div className="flex flex-row space-x-2">
                                                                        <span className="text-sm font-medium hidden sm:block">
                                                                          Weight: {nestedElLvl2?.weight}
                                                                        </span>
                                                                        <span className="text-sm font-medium hidden sm:block">
                                                                          asIsToBe: {nestedElLvl2?.asIsToBe === true ? "Yes" : "No"}
                                                                        </span>
                                                                      </div>
                                                                    )}
                                                                  <div className="flex items-center space-x-2">
                                                                    <svg
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                      fill="none"
                                                                      viewBox="0 0 24 24"
                                                                      strokeWidth="1.5"
                                                                      stroke="currentColor"
                                                                      className="size-5"
                                                                    >
                                                                      <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                                                      />
                                                                    </svg>
                                                                    <span className={`text-sm font-medium hidden sm:block `}>
                                                                      {fixQuestionTypeName(
                                                                        nestedElLvl2?.editing_type
                                                                      )}
                                                                    </span>
                                                                    {nestedElLvl2.editing_type !== "paneldynamic" && (
                                                                    <button
                                                                      className={`flex justify-end sm:justify-center items-center flex-nowrap flex-shrink-0   cursor-pointer group inline-flex items-center   py-1 pl-2 pr-2 text-sm font-medium sm:min-w-[4.5rem] sm:max-w-[4.9rem]"`}
                                                                      onClick={() =>
                                                                        updatePanelQuestionIsRequired(
                                                                          question,
                                                                          pageIndex,
                                                                          qIndex,
                                                                          idx,
                                                                          nestedIndexLvl2
                                                                        )
                                                                      }
                                                                    >
                                                                      {
                                                                        nestedElLvl2?.isRequired ? (
                                                                          <>
                                                                            <RequiredIcon
                                                                              className="w-4 h-4 mr-1"
                                                                              fill={themeMode === "dark" ? "white" : "black"}
                                                                            />
                                                                            <span className="hidden sm:block">Required</span>
                                                                          </>
                                                                        ) : (
                                                                          <>
                                                                            <NotRequiredIcon
                                                                              className="w-4 h-4"
                                                                              fill={themeMode === "dark" ? "white" : "black"}
                                                                              circleFill={themeMode === "dark" ? "none" : "white"}
                                                                              circleStroke={themeMode === "dark" ? "white" : "black"}
                                                                            />
                                                                            <span className="hidden sm:block">Not Required</span>
                                                                          </>
                                                                        )
                                                                      }
                                                                    </button>
                                                                    )}
                                                                  </div>
                                                                </div>
                                                                <p
                                                                  className={`font-semibold text-lg mt-0  break-words ${themeMode === "dark"
                                                                      ? "placeholder:text-white text-white "
                                                                      : " text-[#0f121a] placeholder:text-[#0f121a]"
                                                                    } max-w-full`}
                                                                >{nestedElLvl2?.editing_name}
                                                                </p>
                                                                {["radiogroup", "dropdown", "checkbox", "tagbox", "ranking"].includes(nestedElLvl2?.editing_type) && (
                                                                  <div className="flex flex-col space-y-1">
                                                                    {nestedElLvl2?.elements?.map((choice, cIdx) => (
                                                                      <div key={`paneldynamic-lvl2-${idx}-${nestedIndexLvl2}-${cIdx}`} className={`flex items-center space-x-2 ${themeMode === "dark"
                                                                          ? "placeholder:text-white text-white "
                                                                          : " text-[#0f121a] placeholder:text-[#0f121a]"}`}>
                                                                        <input
                                                                          type="radio"
                                                                          id={choice.value}
                                                                          name={choice.value}
                                                                          value={choice.value || ""}
                                                                          disabled
                                                                        />
                                                                        <label htmlFor={choice.value}>
                                                                          {choice.text}
                                                                        </label>
                                                                      </div>
                                                                    ))}
                                                                  </div>
                                                                )}
                                                                {nestedElLvl2?.editing_type === "rating" && (
                                                                  <div className="rating-container flex space-x-1">
                                                                    {/* theme değerine göre renk belirleme */}
                                                                    {/* {nestedElLvl2?.editing_type} */}
                                                                    {Array.from({
                                                                      length: nestedElLvl2?.rateCount,
                                                                    }).map((_, index) => {
                                                                      const fillColor =
                                                                        themeMode === "dark"
                                                                          ? "white"
                                                                          : "#14141f"; // Tema kontrolü
                                                                          const uid = assignUID(nestedElLvl2);
                                                                      return (
                                                                        <svg
                                                                          key={`paneldynamic-lvl2-rating-${pageIndex}-${qIndex}-${nestedIndexLvl2}-${index}-${uid}`}
                                                                          xmlns="http://www.w3.org/2000/svg"
                                                                          viewBox="0 0 24 24"
                                                                          fill={fillColor} // Dinamik renk
                                                                          className="size-6"
                                                                        >
                                                                          <path
                                                                            fillRule="evenodd"
                                                                            d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                                            clipRule="evenodd"
                                                                          />
                                                                        </svg>
                                                                      );
                                                                    })}
                                                                  </div>
                                                                )}
                                                                {nestedElLvl2?.editing_type === "boolean" &&
                                                                  null}
                                                                {question?.editing_type === "comment" && (
                                                                  <div className="w-full mt-0 mb-0"></div>
                                                                )}
                                                                {nestedElLvl2?.editing_type === "text" && (
                                                                  <div className="w-full mt-4 mb-4">
                                                                    <div
                                                                      className={`flex items-center space-x-2 ${themeMode === "dark"
                                                                          ? "placeholder:text-white text-white "
                                                                          : " text-[#0f121a] placeholder:text-[#0f121a]"
                                                                        }`}
                                                                    >
                                                                      <label htmlFor={nestedElLvl2?.name}>
                                                                        {nestedElLvl2?.name}
                                                                      </label>
                                                                    </div>
                                                                  </div>
                                                                )}
                                                              
                                                              </div>
                                                                </div>
                                                        )}
                                                        </Draggable>
                                                        ))}
                                                      {provided.placeholder}
                                                        </div>
                                                      )}
                                                    </Droppable>
                                                    )}
                                                  </div>
                                                </div>
                                              )}
                                            </Draggable>
                                          ))}
                                        {provided.placeholder}
                                      </div>
                                    )}
                                  </Droppable>
                                )}
                                 
                                {question?.isEditing && (
                                  <div className="mt-4 sm:mt-0">
                                    {/* Question adı input */}

                                    <Combobox
                                      as="div"
                                      value={question?.editing_name}
                                    >
                                      {/* <div className="relative w-72"> */}
                                      <ComboboxInput
                                        className={`w-full p-2 ${question?.editing_type === "comment" ? "mb-4":""} border border-gray-400 rounded-lg mt-4 ${themeMode === "dark"
                                            ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                            : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                          }`}
                                        onChange={(e) =>
                                          handleQuestionNameChange(
                                            pageIndex,
                                            qIndex,
                                            e.target.value,
                                            question?.editing_type
                                          )
                                        } // Question adı değiştirildiğinde tetiklenecek
                                        // onBlur={() => setQuery("")} // Arama kaybolduğunda temizle
                                        displayValue={(name) => name} // Seçilen öğe etiketini göster
                                        placeholder="New Question"
                                      />
                                      {/* warning info */}
                                      {/* {question?.is_exist &&
                                        question?.editing_name.length > 0 && question?.editing_type !== "paneldynamic" && (
                                          <p className="text-red-500 text-xs mt-1">
                                            Question is already exist**
                                          </p>
                                        )} */}
                                      {filteredQuestions.length > 0 && question?.editing_type != "paneldynamic" && (
                                        <ComboboxOptions
                                          className={`absolute z-50 mt-1 max-h-40 w-full overflow-auto rounded-md py-1 text-base sm:text-sm border border-[1px] border-solid ${themeMode === "dark"
                                              ? "bg-[#2a2939] border-white-09 shadow-theme-popup-shadow"
                                              : "bg-[#FFFFFF] border-black-09 shadow-black-2-shadow"
                                            }`}
                                        >
                                          {filteredQuestions.map((option, optIdx) => (
                                            <ComboboxOption
                                              key={`option-${option.ID || optIdx}`}
                                              value={option.question} // Burada tam option nesnesini geçiriyoruz
                                              className={`relative group  flex flex-row justify-between cursor-pointer py-2 pl-8 pr-4 ${themeMode === "dark"
                                                  ? "hover:bg-[#333240] text-white"
                                                  : "hover:bg-[#EBEBEB] text-black"
                                                }`}
                                              onClick={(e) => {
                                                editQuestionFromQBank(
                                                  pageIndex,
                                                  qIndex,
                                                  option
                                                );
                                              }}
                                            >
                                              <span className="block truncate group-data-[selected]:font-semibold">
                                                {option.question}
                                              </span>
                                              <span className="ml-2 block group-data-[selected]:font-semibold">
                                                {option.type}
                                              </span>
                                            </ComboboxOption>
                                          ))}
                                        </ComboboxOptions>
                                      )}
                                      {/* </div> */}
                                    </Combobox>

                                    {/* Seçeneklerin listesi */}
                                    {question?.editing_type === "rating" && (
                                      <div className="rating-component mt-8">
                                        {/* Minus ve Plus Butonları */}
                                        <div className="flex items-center space-x-4">
                                          {/* Minus Button */}
                                          <button
                                            onClick={() => {
                                              decreaseRate(pageIndex, qIndex);
                                            }}
                                            className={`plus-btn px-3 py-1  ${themeMode === "dark"
                                                ? "text-[#FFFFFF]"
                                                : "text-black"
                                              } rounded`}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              strokeWidth="1.5"
                                              stroke="currentColor"
                                              className="size-6"
                                            >
                                              <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                              />
                                            </svg>
                                          </button>

                                          {/* Rating SVG Container */}
                                          <div className="rating-container flex space-x-1">
                                            {Array.from({
                                              length:
                                                question?.editing_rateCount,
                                            }).map((_, index) => {
                                              const fillColor =
                                                themeMode === "dark"
                                                  ? "white"
                                                  : "#14141f";
                                              return (
                                                <svg
                                                  key={`question-rating-${index}`}
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="0 0 24 24"
                                                  fill={fillColor}
                                                  className="size-6"
                                                >
                                                  <path
                                                    fillRule="evenodd"
                                                    d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                    clipRule="evenodd"
                                                  />
                                                </svg>
                                              );
                                            })}
                                          </div>

                                          {/* Plus Button */}
                                          <button
                                            onClick={() => {
                                              increaseRate(pageIndex, qIndex);
                                            }}
                                            className={`plus-btn px-3 py-1  ${themeMode === "dark"
                                                ? "text-[#FFFFFF]"
                                                : "text-black"
                                              } rounded`}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              viewBox="0 0 24 24"
                                              strokeWidth="1.5"
                                              stroke="currentColor"
                                              className="size-6"
                                            >
                                              <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                              />
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                    {question?.editing_type === "boolean" && (
                                      <div className="flex justify-center space-x-4 mt-6"></div>
                                    )}
                                    {(question.editing_type === "radiogroup" ||
                                      question.editing_type === "dropdown" ||
                                      question.editing_type === "tagbox" ||
                                      question.editing_type === "checkbox" ||
                                      question.editing_type === "ranking") && (
                                        <div className="flex flex-col">
                                          <div className="flex flex-col space-y-2 mt-2">
                                            {question.editing_elements?.map(
                                              (element, index) =>
                                                question.editing_type ===
                                                  "checkbox" ? (
                                                  <div key={`question-checkbox-${pageIndex}-${qIndex}-${index}`} className="flex space-x-2">
                                                    <div
                                                      className={`w-full m-0 p-0 min-w-0 relative border-none rounded-[2px] font-inherit bg-transparent outline-none 
                                                         space-x-2 flex justify-start ${themeMode === "dark"
                                                          ? "text-white text-opacity-60"
                                                          : "text-[#000] text-opacity-60"
                                                        }`}
                                                    >
                                                      {/* Radio buton */}
                                                      <input
                                                        type="radio"
                                                        id={element.value}
                                                        name={element.value}
                                                        value={element.value || ""}
                                                        disabled
                                                      />

                                                      {/* Option metni input */}
                                                      <input
                                                        value={element.text || ""}
                                                        placeholder="Option Text"
                                                        className={`w-full p-2 border border-gray-400 rounded-lg  ${themeMode === "dark"
                                                            ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                            : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                          }`}
                                                        onChange={(e) =>
                                                          handleChoiceTextChange(
                                                            pageIndex,
                                                            qIndex,
                                                            index,
                                                            e.target.value,
                                                            question.editing_type
                                                          )
                                                        }
                                                      />
                                                      <div
                                                        title="Delete Option"
                                                        className={`icon no-gap  inline-flex justify-center  items-center  absolute top-1/2 right-2 transform -translate-y-1/2 cursor-pointer ${themeMode === "dark"
                                                            ? "text-[#ffffff]"
                                                            : "text-[#000]"
                                                          }`}
                                                      >
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          fill="none"
                                                          viewBox="0 0 24 24"
                                                          strokeWidth="1.5"
                                                          stroke="currentColor"
                                                          className="size-4 "
                                                          onClick={() => {
                                                            setSelectedParam({
                                                              param: "option",
                                                              pageIndex:
                                                                pageIndex,
                                                              qIndex: qIndex,
                                                              index: index,
                                                              questionType:
                                                                question.editing_type,
                                                            });
                                                            setInfoText(
                                                              "Are you sure you want to delete this option"
                                                            );
                                                            setDeleteAllowMenuOpen(
                                                              true
                                                            );
                                                          }} // İkona tıklanıldığında soru silinir
                                                        >
                                                          <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                                          />
                                                        </svg>
                                                      </div>
                                                      {/* Option value input */}
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <div
                                                    key={`questiontitle-${pageIndex}-${index}`}
                                                    className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] font-inherit bg-transparent outline-none  space-x-2 flex justify-start ${themeMode === "dark"
                                                        ? "text-white text-opacity-60"
                                                        : "text-[#000] text-opacity-60"
                                                      }`}
                                                  >
                                                    {/* Radio buton */}
                                                    <input
                                                      type="radio"
                                                      id={element.value}
                                                      name={element.value}
                                                      value={element.value || ""}
                                                      disabled
                                                    />

                                                    {/* Option metni input */}
                                                    <input
                                                      value={element.text || ""}
                                                      placeholder="Option Text"
                                                      className={`w-full p-2 border border-gray-400 rounded-lg  ${themeMode === "dark"
                                                          ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                          : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                        }`}
                                                      onChange={(e) =>
                                                        handleChoiceTextChange(
                                                          pageIndex,
                                                          qIndex,
                                                          index,
                                                          e.target.value,
                                                          question.editing_type
                                                        )
                                                      }
                                                    />
                                                    {(question.editing_type ===
                                                      "radiogroup" ||
                                                      question.editing_type ===
                                                      "dropdown") &&
                                                      currentSurvey?.content?.pages.find(
                                                        (s) =>
                                                          s.name.toLowerCase() ===
                                                          selectedSectionAndPage.sectionName?.toLowerCase()
                                                      )?.type !==
                                                      "demographics" && (
                                                        <input
                                                          id="numberInput"
                                                          type="text"
                                                          value={
                                                            element.weight
                                                              ? element.weight
                                                              : (
                                                                (5 /
                                                                  question
                                                                    .editing_elements
                                                                    .length) *
                                                                (index + 1)
                                                              ).toFixed(1)
                                                          }
                                                          onChange={(e) =>
                                                            handleOptionWeightChange(
                                                              pageIndex,
                                                              qIndex,
                                                              index,
                                                              e.target.value,
                                                              question.editing_type
                                                            )
                                                          }
                                                          className={`pl-3 border border-gray-400 rounded-lg w-11 ${themeMode === "dark"
                                                              ? " bg-[#1C1C29] border-gray-600 placeholder:text-white text-white"
                                                              : " border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                            }`}
                                                        />
                                                      )}
                                                    <div
                                                      title="Delete Option"
                                                      className={`icon inline-flex justify-center items-center cursor-pointer ${themeMode === "dark"
                                                          ? "text-[#ffffff]"
                                                          : "text-[#000]"
                                                        }`}
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth="1.5"
                                                        stroke="currentColor"
                                                        className="size-4 "
                                                        onClick={() => {
                                                          setSelectedParam({
                                                            param: "option",
                                                            pageIndex: pageIndex,
                                                            qIndex: qIndex,
                                                            index: index,
                                                            questionType:
                                                              question.editing_type,
                                                          });
                                                          setInfoText(
                                                            "Are you sure you want to delete this option"
                                                          );
                                                          setDeleteAllowMenuOpen(
                                                            true
                                                          );
                                                        }}
                                                      >
                                                        <path
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                                        />
                                                      </svg>
                                                    </div>
                                                    {/* Option value input */}
                                                  </div>
                                                )
                                            )}
                                          </div>

                                          <div className="flex items-center p-2 ml-4 rounded-md mb-4 sm:mb-0">
                                            <div className="mr-2 text-[#C1C9D6]">
                                              {/* Add Page Icon */}
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="currentColor"
                                                viewBox="0 0 16 16"
                                                className="w-4 h-4"
                                              >
                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                              </svg>
                                            </div>
                                            <input
                                              className={`w-full text-[0.875rem] border-0 bg-transparent focus-visible:outline-none ${themeMode === "dark"
                                                  ? "text-white"
                                                  : "text-[#5A667E]"
                                                }`}
                                              type="text"
                                              placeholder="Add an Option"
                                              value={question.newOption || ""} // State'e bağlı value
                                              onChange={(e) =>
                                                handleNewOptionChange(
                                                  pageIndex,
                                                  qIndex,
                                                  e.target.value
                                                )
                                              }
                                              onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                  handleAddOption(
                                                    pageIndex,
                                                    qIndex,
                                                    question.editing_type
                                                  );
                                                }
                                              }}
                                            />
                                          </div>
                                        </div>
                                      )}
                                           {question.editing_type === "checkbox" && (
                                                                            <div className="flex space-x-2 my-2 w-3/4">
                                                                              <div
                                                                                className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] font-inherit bg-transparent relative outline-none  space-x-2 flex justify-start ${
                                                                                  themeMode === "dark"
                                                                                    ? "text-white text-opacity-60"
                                                                                    : "text-[#000] text-opacity-60"
                                                                                }`}
                                                                              >
                                                                                <div
                                                                                  className={` ${
                                                                                    themeMode === "dark"
                                                                                      ? "text-white text-opacity-60"
                                                                                      : "text-[#000] text-opacity-60"
                                                                                  } text-[0.875rem] w-1/2`}
                                                                                >
                                                                                  Show None Item
                                                                                </div>
                                                                                <Switch
                                                                                  checked={
                                                                                    question.editing_showNoneItem
                                                                                  }
                                                                                  onChange={(e) =>
                                                                                    handleCheckBoxOptions(
                                                                                      pageIndex,
                                                                                      qIndex,
                                                                                      e,
                                                                                      "showNoneItem"
                                                                                    )
                                                                                  }
                                                                                  className="group  ml-0 inline-flex h-5 w-10 shrink-0 relative cursor-pointer rounded-full border-2 border-transparent bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                                                                                >
                                                                                  <span className="sr-only">
                                                                                    Use setting
                                                                                  </span>
                                                                                  <span
                                                                                    aria-hidden="true"
                                                                                    className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                                                                  />
                                                                                </Switch>
                                                                              </div>
                                                                              <div
                                                                                className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] relative font-inherit bg-transparent outline-none  space-x-2 flex justify-start ${
                                                                                  themeMode === "dark"
                                                                                    ? "text-white text-opacity-60"
                                                                                    : "text-[#000] text-opacity-60"
                                                                                }`}
                                                                              >
                                                                                <div
                                                                                  className={` ${
                                                                                    themeMode === "dark"
                                                                                      ? "text-white text-opacity-60"
                                                                                      : "text-[#000] text-opacity-60"
                                                                                  } text-[0.875rem] w-1/2`}
                                                                                >
                                                                                  Show Other Item
                                                                                </div>
                                                                                <Switch
                                                                                  checked={
                                                                                    question.editing_showOtherItem
                                                                                  }
                                                                                  onChange={(e) =>
                                                                                    handleCheckBoxOptions(
                                                                                      pageIndex,
                                                                                      qIndex,
                                                                                      e,
                                                                                      "showOtherItem"
                                                                                    )
                                                                                  }
                                                                                  className="group  ml-0 inline-flex h-5 w-10 shrink-0 cursor-pointer relative rounded-full border-2 border-transparent bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                                                                                >
                                                                                  <span className="sr-only">
                                                                                    Use setting
                                                                                  </span>
                                                                                  <span
                                                                                    aria-hidden="true"
                                                                                    className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                                                                  />
                                                                                </Switch>
                                                                              </div>
                                                                              <div
                                                                                className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] relative font-inherit bg-transparent outline-none  space-x-2 flex justify-start ${
                                                                                  themeMode === "dark"
                                                                                    ? "text-white text-opacity-60"
                                                                                    : "text-[#000] text-opacity-60"
                                                                                }`}
                                                                              >
                                                                                <div
                                                                                  className={` ${
                                                                                    themeMode === "dark"
                                                                                      ? "text-white text-opacity-60"
                                                                                      : "text-[#000] text-opacity-60"
                                                                                  } text-[0.875rem] w-1/2`}
                                                                                >
                                                                                  Show All Item
                                                                                </div>
                                                                                <Switch
                                                                                  checked={
                                                                                    question.editing_showSelectAllItem
                                                                                  }
                                                                                  onChange={(e) =>
                                                                                    handleCheckBoxOptions(
                                                                                      pageIndex,
                                                                                      qIndex,
                                                                                      e,
                                                                                      "showSelectAllItem"
                                                                                    )
                                                                                  }
                                                                                  className="group  ml-0 inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent relative bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                                                                                >
                                                                                  <span className="sr-only">
                                                                                    Use setting
                                                                                  </span>
                                                                                  <span
                                                                                    aria-hidden="true"
                                                                                    className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                                                                  />
                                                                                </Switch>
                                                                              </div>
                                                                            </div>
                                                                          )}
                                          {question?.editing_type === "text" && (
                                      <div className="w-full flex justify-start  space-x-4 mt-4 mb-4">
                                        {/* <div className="relative font-normal text-[1.25rem] cursor-pointer w-full min-w-0 min-h-0 flex items-center flex-nowrap"> */}
                                        {question?.editing_inputType &&
                                          // <button
                                          //     className={` text-[0.875rem] p-1 border hover: rounded-md ${themeMode === "dark"
                                          //         ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                          //         : "bg-[#ffffff0a] text-black border-black-06"
                                          //         }`}
                                          //     onClick={() => {
                                          //         if (activeQuestionIndex === qIndex) {
                                          //             setShowTextQuestionTypes(false); // Menü açma/kapama
                                          //             setActiveQuestionIndex(null);
                                          //         } else {
                                          //             setActiveQuestionIndex(qIndex); // Yeni soruyu aktif yap
                                          //             setShowTextQuestionTypes(true); // Menüyü aç
                                          //         }
                                          //     }}
                                          // >
                                          //     <div className="flex items-center justify-start">
                                          //         {/* <span>{questionTypes.find(x => x.name === fixQuestionTypeName(question?.type)).img}</span> */}
                                          //         <span>
                                          //             {question?.editing_inputType}
                                          //         </span>
                                          //     </div>

                                          // </button>
                                          // radiobutton
                                          textQuestionTypes.map(
                                            (questionType, typeIndex) => (
                                              <div
                                                key={`textQuestionType-${pageIndex}-${qIndex}-${typeIndex}`}
                                                className={`flex items-center justify-start text-center cursor-pointer text-xs my-1 ${
                                                  themeMode === "dark"
                                                    ? "text-white text-opacity-60"
                                                    : "text-[#000] text-opacity-60"
                                                } `}
                                              >
                                                <input
                                                  type="radio"
                                                  className="cursor-pointer"
                                                  id={questionType.value}
                                                  name={questionType.value}
                                                  value={questionType.value}
                                                  checked={
                                                    question?.editing_inputType ===
                                                    questionType.value
                                                  }
                                                  onChange={() =>
                                                    updateTextQuestionType(
                                                      pageIndex,
                                                      qIndex,
                                                      questionType.value
                                                    )
                                                  }
                                                />
                                                <label
                                                  htmlFor={questionType.value}
                                                  className="ml-1 cursor-pointer"
                                                >
                                                  {questionType.value}
                                                </label>
                                              </div>
                                            )
                                          )}
                                        {/* {showTextQuestionTypes && activeQuestionIndex === qIndex && (
                                                                            <div
                                                                                ref={textQuestionTypesMenuRef}
                                                                                id="questionTypesMenu"
                                                                                className={`absolute flex flex-col  ${qIndex === page.questions.length - 1 ? 'bottom-10' : 'top-9'} left-0 min-w-[200px] border  max-h-[100px] overflow-y-auto rounded-md z-[999999] ${themeMode === "dark"
                                                                                    ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                                                    : " bg-gray-200 text-black border-black-06"
                                                                                    }`}
                                                                            >
                                                                                {textQuestionTypes.map((questionType, typeIndex) => (
                                                                                    <div
                                                                                        key={`textQuestionType-${pageIndex}-${qIndex}-${typeIndex}`}
                                                                                        className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                                                        onClick={() => updateTextQuestionType(
                                                                                            pageIndex,
                                                                                            qIndex,
                                                                                            questionType.value
                                                                                        )}
                                                                                    >
                                                                                        <div className="flex items-center justify-start text-xs my-1">
                                                                                            <span className={`${themeMode === "dark"
                                                                                                ? "text-white text-opacity-60"
                                                                                                : "text-[#000] text-opacity-60"
                                                                                                } `}>
                                                                                                {questionType.value}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )} */}
                                        {/* </div> */}
                                        {question?.editing_inputType ===
                                          "number" && (
                                          <div className="flex gap-2 ">
                                            <input
                                              type="number"
                                              className={`  rounded-lg  w-full border rounded-md py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 ${
                                                themeMode === "dark"
                                                  ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                  : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                              }`}
                                              value={question?.min}
                                              onChange={(e) => {
                                                changeTextTypeOptions(
                                                  pageIndex,
                                                  qIndex,
                                                  parseInt(e.target.value, 10),
                                                  "min"
                                                );
                                              }}
                                              placeholder="Enter min length"
                                            />
                                            <input
                                              type="number"
                                              className={`w-full p-2  rounded-lg  ${
                                                themeMode === "dark"
                                                  ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                  : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                              }`}
                                              value={question?.max}
                                              onChange={(e) => {
                                                changeTextTypeOptions(
                                                  pageIndex,
                                                  qIndex,
                                                  parseInt(e.target.value, 10),
                                                  "max"
                                                );
                                              }}
                                              placeholder="Enter max length"
                                            />{" "}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                    
                                    {question.editing_type === "paneldynamic" && (
                                      <Droppable
                                        droppableId={`paneldynamic-${pageIndex}-${qIndex}`}
                                        key={`paneldynamic-${pageIndex}-${qIndex}`}
                                        type="paneldynamic"
                                      >
                                      {(provided, snapshot) => (
                                        <div
                                          {...provided.droppableProps}
                                          ref={provided.innerRef}
                                          className={`droppable-area relative ${snapshot.isDraggingOver ? "dragging-over" : ""
                                            }  flex flex-col text-white items-center justify-center w-full  ${themeMode === "dark"
                                              ? "bg-[#a5bdff0d]"
                                              : "bg-[#1530720d]"
                                            } rounded-lg p-8 mb-6 space-y-8 pb-10 min-h-[150px]`}
                                        >
                                          <div className={`flex flex-col w-full space-y-4 border p-4 mt-8 pt-4 rounded-lg ${themeMode === "dark"
                                                ? "bg-[#a5bdff0d]"
                                                : "bg-[#1530720d]"
                                              }`} ref={(el) => {
                                              if (el)   panelRefs.current[`paneldynamic-${pageIndex}-${qIndex}`] = el
                                            }}>
                                         

                                            {question.templateElements?.length > 0 && (
                                              question.templateElements.map((el, idx) => (
                                                <Draggable  key={`questionDraggable-${pageIndex}-${qIndex}-${idx}`}
                                                draggableId={`question-${pageIndex}-${qIndex}-${idx}`}
                                                index={idx}
                                                className={`questionDraggable-${qIndex}-${idx}`}>
                                                {(provided) => (
                                                    <div
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                      className={`relative group flex flex-col w-full space-y-3 ${question?.editing_type === "paneldynamic" ?"pb-8":""} p-8 border border-dashed border-gray-400 rounded-lg hover:border-gray-600 hover:shadow-lg hover:bg-[#a5bdff0d]`}
                                                    >
                                                      <div key={`paneldynamic-lvl1-elements-${pageIndex}-${idx}`} className={`w-full p-2 border border-gray-400 rounded-lg mt-4 pb-8 relative ${themeMode === "dark"
                                                        ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white  "
                                                        : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                      }`}>
                                                  <div
                                                    className={`absolute bottom-0 right-0 px-2 py-1 rounded-tl-lg cursor-pointer flex items-center space-x-2 ${themeMode === "dark"
                                                        ? " text-white"
                                                        : "  text-black-8"
                                                      }`}
                                                  >
                                                    {question?.isEditing  && currentSurvey?.content?.pages.find((s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName?.toLowerCase())?.type !== "demographics" && (
                                                        <div className="flex space-x-2">
                                                        {(el?.editing_type === "radiogroup" ||
                                                          el?.editing_type === "dropdown" ||
                                                          el?.editing_type === "rating") &&
                                                            <div className="flex items-center space-x-2">
                                                              <span className="text-sm font-medium hidden sm:block">
                                                                Weight:
                                                              </span>
                                                              <input
                                                                id="numberInput"
                                                                type="text"
                                                                value={el?.editing_weight?.toString() || ""}
                                                                onChange={(e) =>
                                                                  handlePanelQuestionWeightChange(
                                                                    pageIndex,
                                                                    qIndex,
                                                                    idx,
                                                                    e.target.value
                                                                  )
                                                                }
                                                                className={`text-sm font-medium bg-transparent border rounded-md p-1 w-12 text-center ${themeMode === "dark"
                                                                    ? " text-white border-1 border-gray-400"
                                                                    : "  text-black border border-black-06"
                                                                  }`}
                                                              />
                                                            </div>
                                                        }
                                                        {(el?.editing_type === "radiogroup" ||
                                                          el?.editing_type === "dropdown" ||
                                                          el?.editing_type === "rating") &&
                                                          <div className="flex items-center space-x-2">
                                                            {/* <span className="text-sm font-medium hidden sm:block">
                                                              asIsToBe:
                                                            </span>
                                                            <input
                                                              id="numberInput"
                                                              type="text"
                                                              value={el?.editing_asIsToBe?.toString() || ""}
                                                              onChange={(e) =>
                                                                handlePanelQuestionAsIsToBeChange(
                                                                  pageIndex,
                                                                  qIndex,
                                                                  idx,
                                                                  e.target.value
                                                                )
                                                              }
                                                              className={`text-sm font-medium bg-transparent border rounded-md p-1 w-12 text-center ${themeMode === "dark"
                                                                  ? " text-white border-1 border-gray-400"
                                                                  : "  text-black border border-black-06"
                                                                }`}
                                                            /> */}
                                                            <span className="text-sm font-medium hidden sm:block mt-1">
                                                            asIsToBe:
                                                            </span>
                                                            <div className=" relative font-normal text-[1.25rem] cursor-pointer w-full min-w-0 min-h-0 flex items-center flex-nowrap">
                                                                {el?.editing_type && (
                                                                  <button
                                                                    className={` text-[0.875rem] p-1 border hover: rounded-md ${themeMode === "dark"
                                                                        ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                                        : "bg-[#ffffff0a] text-black border-black-06"
                                                                      }`}
                                                                    onClick={() => {
                                                                      if (
                                                                        activeQuestionAsIsToBeIndex === `${qIndex}-${idx}`
                                                                      ) {
                                                                        setShowAsIsToBeOptions(false); // Menü açma/kapama
                                                                        setActiveQuestionAsIsToBeIndex(null);
                                                                      } else {
                                                                      setActiveQuestionAsIsToBeIndex(`${qIndex}-${idx}`);
                                                                        setShowAsIsToBeOptions(true); // Menüyü aç
                                                                      }
                                                                    }}
                                                                  >
                                                                    <div className="flex items-center justify-start">
                                                                      {/* <span>{questionTypes.find(x => x.name === fixQuestionTypeName(question?.type)).img}</span> */}
                                                                      {/* {el?.editing_asIsToBe} */}
                                                                      <span>
                                                                        {
                                                                          el?.editing_asIsToBe===true?"Yes":"No"
                                                                        }
                                                                      </span>
                                                                    </div>
                                                                  </button>
                                                                )}
                                                                {showAsIsToBeOptions && activeQuestionAsIsToBeIndex === `${qIndex}-${idx}`&& (
                                                                    <div
                                                                      ref={asIsToBeMenuRef}
                                                                      id="questionAsIsToBeMenu"
                                                                      className={`absolute flex flex-col  ${qIndex ===
                                                                          page.questions.length - 1
                                                                          ? "bottom-10"
                                                                          : "top-9"
                                                                        } left-0 min-w-[200px] border  max-h-[100px] overflow-y-auto rounded-md z-[999999] ${themeMode === "dark"
                                                                          ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                                          : " bg-gray-200 text-black border-black-06"
                                                                        }`}
                                                                    >
                                                                      <div
                                                                        className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                                        onClick={(e) =>{
                                                                          setShowAsIsToBeOptions(false)
                                                                          handlePanelQuestionAsIsToBeChange(
                                                                          pageIndex,
                                                                          qIndex,
                                                                          idx,
                                                                          "true"
                                                                          )
                                                                        }}
                                                                      >
                                                                        <div className="flex items-center justify-start text-xs my-1">
                                                                        
                                                                          <span
                                                                            className={`ml-1 ${themeMode === "dark"
                                                                                ? "text-white text-opacity-60"
                                                                                : "text-[#000] text-opacity-60"
                                                                              } `}
                                                                          >
                                                                            Yes
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                      <div
                                                                        className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                                        onClick={(e) =>
                                                                          handlePanelQuestionAsIsToBeChange(
                                                                          pageIndex,
                                                                          qIndex,
                                                                          idx,
                                                                          "false"
                                                                          )
                                                                        }
                                                                      >
                                                                        <div className="flex items-center justify-start text-xs my-1">
                                                                        
                                                                          <span
                                                                            className={`ml-1 ${themeMode === "dark"
                                                                                ? "text-white text-opacity-60"
                                                                                : "text-[#000] text-opacity-60"
                                                                              } `}
                                                                          >
                                                                            No
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    
                                                                    
                                                                    </div>
                                                                  )}
                                                            </div>
                                                          </div>
                                                        }  
                                                        {question?.isEditing && (
                                                          <div className=" relative font-normal text-[1.25rem] cursor-pointer w-full min-w-0 min-h-0 flex items-center flex-nowrap">
                                                            {el?.isEditing && el?.type === "paneldynamic" && (
                                                                <div className="flex items-center space-x-2">
                                                            
                                                                  <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    fill="none"
                                                                    viewBox="0 0 24 24"
                                                                    strokeWidth="1.5"
                                                                    stroke="currentColor"
                                                                    className="size-5"
                                                                  >
                                                                    <path
                                                                      strokeLinecap="round"
                                                                      strokeLinejoin="round"
                                                                      d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                                                    />
                                                                  </svg>
                                                                  <span className="text-sm font-medium hidden sm:block">
                                                                    {fixQuestionTypeName(
                                                                      el?.editing_type
                                                                    )}
                                                                  </span>
                                                                </div>
                                                            )}
                                                            {el?.editing_type && el?.editing_type !== "paneldynamic" && (
                                                              <button
                                                                className={` text-[0.875rem] p-1 border hover: rounded-md ${themeMode === "dark"
                                                                    ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                                    : "bg-[#ffffff0a] text-black border-black-06"
                                                                  }`}
                                                              onClick={() => {
                                                                const key = `${qIndex}-${idx}`;
                                                                if (activeQuestionIndex === key) {
                                                                  setShowQuestionTypes(false);
                                                                  setActiveQuestionIndex(null);
                                                                } else {
                                                                  setActiveQuestionIndex(key);
                                                                  setShowQuestionTypes(true);
                                                                }
                                                              }}

                                                              >
                                                                <div className="flex items-center justify-start">
                                                                  {/* <span>{questionTypes.find(x => x.name === fixQuestionTypeName(question?.type)).img}</span> */}
                                                                  <span>
                                                                    {fixQuestionTypeName(
                                                                      el?.editing_type
                                                                    )}
                                                                  </span>
                                                                </div>
                                                              </button>
                                                            )}
                                                            {showQuestionTypes &&
                                                              activeQuestionIndex ===`${qIndex}-${idx}` && (
                                                                <div
                                                                  ref={questionTypesMenuRef}
                                                                  id="questionTypesMenu"
                                                                  className={`absolute flex flex-col  ${qIndex ===
                                                                      page.questions.length - 1
                                                                      ? "bottom-10"
                                                                      : "top-9"
                                                                    } left-0 min-w-[200px] border  max-h-[100px] overflow-y-auto rounded-md z-[999999] ${themeMode === "dark"
                                                                      ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                                      : " bg-gray-200 text-black border-black-06"
                                                                    }`}
                                                                >
                                                                  {questionTypes.map(
                                                                    (questionType, typeIndex) => (
                                                                      <div
                                                                        key={`questionType-${pageIndex}-${qIndex}-${idx}-${typeIndex}`}
                                                                        className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                                        onClick={() => {
                                                                          setShowQuestionTypes(false);
                                                                          updatePanelQuestionType(
                                                                            pageIndex,
                                                                            qIndex,
                                                                            idx,
                                                                            fixQuestionTypeName(
                                                                              questionType?.name
                                                                            )
                                                                          );
                                                                        }}
                                                                      >
                                                                        <div className="flex items-center justify-start text-xs my-1">
                                                                          <span
                                                                            className={`${themeMode === "dark"
                                                                                ? "text-white text-opacity-60"
                                                                                : "text-[#000] text-opacity-60"
                                                                              }`}
                                                                          >
                                                                            {questionType.img}
                                                                          </span>
                                                                          <span
                                                                            className={`ml-1 ${themeMode === "dark"
                                                                                ? "text-white text-opacity-60"
                                                                                : "text-[#000] text-opacity-60"
                                                                              } `}
                                                                          >
                                                                            {questionType?.name}
                                                                          </span>
                                                                        </div>
                                                                      </div>
                                                                    )
                                                                  )}
                                                                </div>
                                                              )}
                                                          </div>
                                                        )}
                                                        {el?.editing_type !== "paneldynamic" && (
                                                        <button
                                                          className={`flex justify-end sm:justify-center items-center flex-nowrap flex-shrink-0   cursor-pointer group inline-flex items-center   py-1 pl-2 pr-2 text-sm font-medium sm:min-w-[4.5rem] sm:max-w-[4.9rem]"`}
                                                          onClick={() =>
                                                            updatePanelQuestionIsRequired(
                                                              el,
                                                              pageIndex,
                                                              qIndex,
                                                              idx
                                                            )
                                                          }
                                                        >
                                                          {el?.type !== "paneldynamic" &&
                                                            el?.isRequired ? (
                                                              <>
                                                                <RequiredIcon
                                                                  className="w-4 h-4 mr-1"
                                                                  fill={themeMode === "dark" ? "white" : "black"}
                                                                />
                                                                <span className="hidden sm:block">Required</span>
                                                              </>
                                                            ) : (
                                                              <>
                                                                <NotRequiredIcon
                                                                  className="w-4 h-4"
                                                                  fill={themeMode === "dark" ? "white" : "black"}
                                                                  circleFill={themeMode === "dark" ? "none" : "white"}
                                                                  circleStroke={themeMode === "dark" ? "white" : "black"}
                                                                />
                                                                <span className="hidden sm:block">Not Required</span>
                                                              </>
                                                            )
                                                          }

                                                        </button>
                                                        )}
                                                      </div>

                                                    )}
                                                  

                                                  </div>
                                                  
                                                  <input
                                                    type="text"
                                                    value={el?.editing_name || ""}
                                                    name="templateElementName"
                                                    placeholder="Question Title"
                                                    className={`w-full p-2 border border-gray-400 rounded-lg mt-4 ${themeMode === "dark"
                                                      ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                      : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                    }`}
                                                    onChange={(e) =>
                                                      handlePanelQuestionChange(pageIndex, qIndex, idx, "editing_name", e.target.value)
                                                    }
                                                  />
                                                  {/* {el?.is_exist && el?.editing_name.length  > 0  && el?.editing_type !=="paneldynamic"&& (
                                                    <p className="text-red-500 text-xs mt-1">
                                                      Question is already exist*
                                                    </p>
                                                  )} */}

                                                  {["radiogroup", "dropdown", "checkbox", "tagbox", "ranking"].includes(el?.editing_type) && (
                                                    <div className="flex flex-col space-y-1">
                                                      {el?.editing_elements?.map((choice, cIdx) => (
                                                        <div key={`questionelements-${pageIndex}-${qIndex}-${cIdx}`} className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] font-inherit bg-transparent outline-none  space-x-2 flex justify-start relative ${themeMode === "dark"
                                                            ? "text-white text-opacity-60"
                                                            : "text-[#000] text-opacity-60"
                                                          }`}

                                                        >

                                                          <input type="radio" id={choice.value} name={choice.value} value={choice.value || ""} disabled />
                                                          <input
                                                            type="text"
                                                            value={choice.text || ""}
                                                            placeholder="Option Text"
                                                            className={`w-full p-2 border border-gray-400 rounded-lg  ${themeMode === "dark"
                                                                ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                                : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                              }`}
                                                            onChange={(e) =>
                                                              handlePanelChoiceChange(pageIndex, qIndex, idx, cIdx, e.target.value)
                                                            }
                                                          />
                                                          {(el?.editing_type === "radiogroup" || el?.editing_type === "dropdown") && currentSurvey?.content?.pages.find((s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName?.toLowerCase())?.type !== "demographics" && (
                                                            <input
                                                              id="numberInput"
                                                              type="text"
                                                              value={
                                                                choice.weight
                                                                  ? choice.weight
                                                                  : (
                                                                    (5 /
                                                                      el
                                                                        .editing_elements
                                                                        .length) *
                                                                    (cIdx + 1)
                                                                  ).toFixed(1)
                                                              }
                                                              onChange={(e) =>
                                                                handlePanelQuestionOptionWeightChange(
                                                                  pageIndex,
                                                                  qIndex,
                                                                  idx,
                                                                  cIdx,
                                                                  e.target.value
                                                                )
                                                              }
                                                              className={`pl-3 border border-gray-400 rounded-lg w-11 ${themeMode === "dark"
                                                                  ? " bg-[#1C1C29] border-gray-600 placeholder:text-white text-white"
                                                                  : " border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                                }`}
                                                            />
                                                          )}
                                                          <div
                                                            title="Delete Option"
                                                            className={`icon inline-flex justify-center items-center cursor-pointer ${themeMode === "dark"
                                                                ? "text-[#ffffff]"
                                                                : "text-[#000]"
                                                              }`}
                                                          >
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              fill="none"
                                                              viewBox="0 0 24 24"
                                                              strokeWidth="1.5"
                                                              stroke="currentColor"
                                                              className="size-4 "
                                                              onClick={() => {
                                                                removePanelChoice(pageIndex, qIndex, idx, cIdx)
                                                                // setSelectedParam({
                                                                //   param: "option",
                                                                //   pageIndex: pageIndex,
                                                                //   qIndex: qIndex,
                                                                //   index: index,
                                                                //   questionType:
                                                                //     question.editing_type,
                                                                // });
                                                                // setInfoText(
                                                                //   "Are you sure you want to delete this option"
                                                                // );
                                                                // setDeleteAllowMenuOpen(
                                                                //   true
                                                                // );
                                                              }}
                                                            >
                                                              <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                                              />
                                                            </svg>
                                                          </div>
                                                        </div>
                                                      ))}
                                                      <div className="flex items-center p-2 ml-4 rounded-md mb-4 sm:mb-0">
                                                        <div className="mr-2 text-[#C1C9D6]">
                                                          {/* Add Page Icon */}
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="currentColor"
                                                            viewBox="0 0 16 16"
                                                            className="w-4 h-4"
                                                          >
                                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                          </svg>
                                                        </div>
                                                        <input
                                                          className={`w-full text-[0.875rem] border-0 bg-transparent focus-visible:outline-none ${themeMode === "dark"
                                                              ? "text-white"
                                                              : "text-[#5A667E]"
                                                            }`}
                                                          type="text"
                                                          placeholder="Add an Option"
                                                          value={el?.newOption || ""} // State'e bağlı value
                                                          onChange={(e) =>
                                                            handlePanelNewOptionChange(pageIndex, qIndex, idx, 0, e.target.value)
                                                          }
                                                          onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                              addPanelChoice(
                                                                pageIndex,
                                                                qIndex,
                                                                idx
                                                              );
                                                            }
                                                          }}
                                                        />
                                                      </div>

                                                    </div>
                                                  )}
                                                  {el?.editing_type === "rating" && (
                                                    <div className="rating-component mt-8">
                                                      {/* Minus ve Plus Butonları */}
                                                      <div className="flex items-center space-x-4">
                                                        {/* Minus Button */}
                                                        <button
                                                          onClick={() => {
                                                            decreasePanelQuestionRate(pageIndex, qIndex,idx);
                                                          }}
                                                          className={`plus-btn px-3 py-1  ${themeMode === "dark"
                                                              ? "text-[#FFFFFF]"
                                                              : "text-black"
                                                            } rounded`}
                                                        >
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth="1.5"
                                                            stroke="currentColor"
                                                            className="size-6"
                                                          >
                                                            <path
                                                              strokeLinecap="round"
                                                              strokeLinejoin="round"
                                                              d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                                            />
                                                          </svg>
                                                        </button>

                                                        {/* Rating SVG Container */}
                                                        <div className="rating-container flex space-x-1">
                                                          {Array.from({
                                                            length:el?.editing_rateCount
                                                          }).map((_, index) => {
                                                            const fillColor =
                                                              themeMode === "dark"
                                                                ? "white"
                                                                : "#14141f";
                                                            return (
                                                              <svg
                                                                key={`question-rating-${pageIndex}-${index}`}
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox="0 0 24 24"
                                                                fill={fillColor}
                                                                className="size-6"
                                                              >
                                                                <path
                                                                  fillRule="evenodd"
                                                                  d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                                  clipRule="evenodd"
                                                                />
                                                              </svg>
                                                            );
                                                          })}
                                                        </div>

                                                        {/* Plus Button */}
                                                        <button
                                                          onClick={() => {
                                                            increasePanelQuestionRate(pageIndex, qIndex,idx);
                                                          }}
                                                          className={`plus-btn px-3 py-1  ${themeMode === "dark"
                                                              ? "text-[#FFFFFF]"
                                                              : "text-black"
                                                            } rounded`}
                                                        >
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth="1.5"
                                                            stroke="currentColor"
                                                            className="size-6"
                                                          >
                                                            <path
                                                              strokeLinecap="round"
                                                              strokeLinejoin="round"
                                                              d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                                            />
                                                          </svg>
                                                        </button>
                                                      </div>
                                                    </div>
                                                  )}
                                                  {el?.editing_type === "checkbox" && (
                                                    <div className="flex space-x-2 my-2 w-3/4">
                                                      <div
                                                        className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] font-inherit bg-transparent relative outline-none  space-x-2 flex justify-start ${themeMode === "dark"
                                                            ? "text-white text-opacity-60"
                                                            : "text-[#000] text-opacity-60"
                                                          }`}
                                                      >
                                                        <div
                                                          className={` ${themeMode === "dark"
                                                              ? "text-white text-opacity-60"
                                                              : "text-[#000] text-opacity-60"
                                                            } text-[0.875rem] w-1/2`}
                                                        >
                                                          Show None Item
                                                        </div>
                                                        <Switch
                                                          checked={
                                                            el?.editing_showNoneItem
                                                          }
                                                          onChange={(e) =>
                                                            handlePanelCheckBoxOptions(
                                                              pageIndex,
                                                              qIndex,
                                                              idx,
                                                              e,
                                                              "showNoneItem"
                                                            )
                                                          }
                                                          className="group  ml-0 inline-flex h-5 w-10 shrink-0 relative cursor-pointer rounded-full border-2 border-transparent bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                                                        >
                                                          <span className="sr-only">
                                                            Use setting
                                                          </span>
                                                          <span
                                                            aria-hidden="true"
                                                            className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                                          />
                                                        </Switch>
                                                      </div>
                                                      <div
                                                        className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] relative font-inherit bg-transparent outline-none  space-x-2 flex justify-start ${themeMode === "dark"
                                                            ? "text-white text-opacity-60"
                                                            : "text-[#000] text-opacity-60"
                                                          }`}
                                                      >
                                                        <div
                                                          className={` ${themeMode === "dark"
                                                              ? "text-white text-opacity-60"
                                                              : "text-[#000] text-opacity-60"
                                                            } text-[0.875rem] w-1/2`}
                                                        >
                                                          Show Other Item
                                                        </div>
                                                        <Switch
                                                          checked={
                                                            el?.editing_showOtherItem
                                                          }
                                                          onChange={(e) =>
                                                            handlePanelCheckBoxOptions(
                                                              pageIndex,
                                                              qIndex,
                                                              idx,
                                                              e,
                                                              "showOtherItem"
                                                            )
                                                          }
                                                          className="group  ml-0 inline-flex h-5 w-10 shrink-0 cursor-pointer relative rounded-full border-2 border-transparent bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                                                        >
                                                          <span className="sr-only">
                                                            Use setting
                                                          </span>
                                                          <span
                                                            aria-hidden="true"
                                                            className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                                          />
                                                        </Switch>
                                                      </div>
                                                      <div
                                                        className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] relative font-inherit bg-transparent outline-none  space-x-2 flex justify-start ${themeMode === "dark"
                                                            ? "text-white text-opacity-60"
                                                            : "text-[#000] text-opacity-60"
                                                          }`}
                                                      >
                                                        <div
                                                          className={` ${themeMode === "dark"
                                                              ? "text-white text-opacity-60"
                                                              : "text-[#000] text-opacity-60"
                                                            } text-[0.875rem] w-1/2`}
                                                        >
                                                          Show All Item
                                                        </div>
                                                        <Switch
                                                          checked={
                                                            el?.editing_showSelectAllItem
                                                          }
                                                          onChange={(e) =>
                                                            handlePanelCheckBoxOptions(
                                                              pageIndex,
                                                              qIndex,
                                                              idx,
                                                              e,
                                                              "showSelectAllItem"
                                                            )
                                                          }
                                                          className="group  ml-0 inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent relative bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                                                        >
                                                          <span className="sr-only">
                                                            Use setting
                                                          </span>
                                                          <span
                                                            aria-hidden="true"
                                                            className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                                          />
                                                        </Switch>
                                                      </div>
                                                    </div>
                                                  )}
                                                  
                                                  {el?.editing_type === "comment" && (
                                                    <div className="space-y-4 mt-6 "></div>
                                                  )}
                                                  {el?.editing_type === "text" && (
                                                    <div className="w-full flex justify-start  space-x-4 mt-4 mb-4">
                                                      {/* <div className="relative font-normal text-[1.25rem] cursor-pointer w-full min-w-0 min-h-0 flex items-center flex-nowrap"> */}
                                                      {el?.editing_inputType &&
                                                        // <button
                                                        //     className={` text-[0.875rem] p-1 border hover: rounded-md ${themeMode === "dark"
                                                        //         ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                        //         : "bg-[#ffffff0a] text-black border-black-06"
                                                        //         }`}
                                                        //     onClick={() => {
                                                        //         if (activeQuestionIndex === qIndex) {
                                                        //             setShowTextQuestionTypes(false); // Menü açma/kapama
                                                        //             setActiveQuestionIndex(null);
                                                        //         } else {
                                                        //             setActiveQuestionIndex(qIndex); // Yeni soruyu aktif yap
                                                        //             setShowTextQuestionTypes(true); // Menüyü aç
                                                        //         }
                                                        //     }}
                                                        // >
                                                        //     <div className="flex items-center justify-start">
                                                        //         {/* <span>{questionTypes.find(x => x.name === fixQuestionTypeName(question?.type)).img}</span> */}
                                                        //         <span>
                                                        //             {question?.editing_inputType}
                                                        //         </span>
                                                        //     </div>

                                                        // </button>
                                                        // radiobutton
                                                        textQuestionTypes.map(
                                                          (questionType, typeIndex) => (
                                                            <div
                                                              key={`textQuestionType-${pageIndex}-${qIndex}-${idx}-${typeIndex}`}
                                                              className={`flex items-center justify-start text-center cursor-pointer text-xs my-1 ${themeMode === "dark"
                                                                  ? "text-white text-opacity-60"
                                                                  : "text-[#000] text-opacity-60"
                                                                } `}
                                                            >
                                                              <input
                                                                type="radio"
                                                                className="cursor-pointer"
                                                                id={questionType.value}
                                                                name={questionType.value}
                                                                value={questionType.value || ""}
                                                                checked={
                                                                  el?.editing_inputType ===
                                                                  questionType.value
                                                                }
                                                                onChange={() =>
                                                                  updatePanelTextQuestionType(
                                                                    pageIndex,
                                                                    qIndex,
                                                                    idx,
                                                                    questionType.value
                                                                  )
                                                                }
                                                              />
                                                              <label
                                                                htmlFor={questionType.value}
                                                                className="ml-1 cursor-pointer"
                                                              >
                                                                {questionType.value}
                                                              </label>
                                                            </div>
                                                          )
                                                        )}
                                                        {showTextQuestionTypes && activeQuestionIndex ===`${qIndex}-${idx}` && (
                                                          <div
                                                              ref={textQuestionTypesMenuRef}
                                                              id="questionTypesMenu"
                                                              className={`absolute flex flex-col  ${qIndex === page.questions.length - 1 ? 'bottom-10' : 'top-9'} left-0 min-w-[200px] border  max-h-[100px] overflow-y-auto rounded-md z-[999999] ${themeMode === "dark"
                                                                  ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                                  : " bg-gray-200 text-black border-black-06"
                                                                  }`}
                                                          >
                                                              {textQuestionTypes.map((questionType, typeIndex) => (
                                                                  <div
                                                                      key={`textQuestionType-${pageIndex}-${qIndex}-${idx}-${typeIndex}`}
                                                                      className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                                      onClick={() => updateTextQuestionType(
                                                                          pageIndex,
                                                                          qIndex,
                                                                          questionType.value
                                                                      )}
                                                                  >
                                                                      <div className="flex items-center justify-start text-xs my-1">
                                                                          <span className={`${themeMode === "dark"
                                                                              ? "text-white text-opacity-60"
                                                                              : "text-[#000] text-opacity-60"
                                                                              } `}>
                                                                              {questionType.value}
                                                                          </span>
                                                                      </div>
                                                                  </div>
                                                              ))}
                                                          </div>
                                                        )} 
                                                      {/* </div> */}
                                                      {el?.editing_inputType ===
                                                        "number" && (
                                                          <div className="flex gap-2 ">
                                                            <input
                                                              type="number"
                                                              className={`  rounded-lg  w-full border rounded-md py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 ${themeMode === "dark"
                                                                  ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                                  : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                                }`}
                                                              value={el?.min || ""}
                                                              onChange={(e) => {
                                                                changePanelTextTypeOptions(
                                                                  pageIndex,
                                                                  qIndex,
                                                                  idx,
                                                                  parseInt(e.target.value, 10),
                                                                  "min"
                                                                );
                                                              }}
                                                              placeholder="Enter min length"
                                                            />
                                                            <input
                                                              type="number"
                                                              className={`w-full p-2  rounded-lg  ${themeMode === "dark"
                                                                  ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                                  : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                                }`}
                                                              value={el?.max || ""}
                                                              onChange={(e) => {
                                                                changePanelTextTypeOptions(
                                                                  pageIndex,
                                                                  qIndex,
                                                                  idx,
                                                                  parseInt(e.target.value, 10),
                                                                  "max"
                                                                );
                                                              }}
                                                              placeholder="Enter max length"
                                                            />{" "}
                                                          </div>
                                                        )}

                                                    </div>
                                                  )}
                                                  {el?.editing_type === "paneldynamic" &&(
                                                    <Droppable
                                                      droppableId={`paneldynamic-inner-${pageIndex}-${qIndex}-${idx}`}
                                                      key={`paneldynamic-inner-${pageIndex}-${qIndex}-${idx}`}
                                                      type="paneldynamic-inner"
                                                    >
                                                    {(provided, snapshot) => (
                                                      <div
                                                        {...provided.droppableProps}
                                                        ref={provided.innerRef}
                                                        className={`droppable-area relative ${snapshot.isDraggingOver ? "dragging-over" : ""
                                                          }  flex flex-col text-white items-center justify-center w-full  ${themeMode === "dark"
                                                            ? "bg-[#a5bdff0d]"
                                                            : "bg-[#1530720d]"
                                                          } rounded-lg p-8 mb-6 space-y-8 pb-10 min-h-[150px]`}
                                                        >
                                                    <div className={`flex flex-col space-y-4 border p-4 mt-8 pt-4 w-full rounded-lg reyna ${themeMode === "dark"
                                                            ? "bg-[#a5bdff0d]"
                                                            : "bg-[#1530720d]"
                                                          }`} ref={(el) => {
                                                      if (el)   panelRefs.current[`paneldynamic-${pageIndex}-${qIndex}`] = el
                                                    }}>
                                                   

                                                  {el.templateElements?.length > 0 && (
                                                    el.templateElements.map((nestedElLvl2, nestedIndexLvl2) => (
                                                      <Draggable  key={`questionDraggable-${pageIndex}-${qIndex}-${idx}-${nestedIndexLvl2}`}
                                                      draggableId={`question-${pageIndex}-${qIndex}-${idx}-${nestedIndexLvl2}`}
                                                      index={nestedIndexLvl2}
                                                      className={`questionDraggable-${qIndex}-${idx}`}>
                                                      {(provided) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={`relative group flex flex-col w-full space-y-3 ${question?.editing_type === "paneldynamic" ?"pb-8":""} p-8 border border-dashed border-gray-400 rounded-lg hover:border-gray-600 hover:shadow-lg hover:bg-[#a5bdff0d]`}
                                                        >
                                                      <div key={`paneldynamic-lvl2-elements-${pageIndex}-${qIndex}-${idx}-${nestedIndexLvl2}`} className={`w-full p-2 border border-gray-400 rounded-lg mt-4 pb-8 relative ${themeMode === "dark"
                                                          ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white  "
                                                          : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                        }`}>
                                                        <div
                                                          className={`absolute bottom-0 right-0 px-2 py-1 rounded-tl-lg cursor-pointer flex items-center space-x-2 ${themeMode === "dark"
                                                              ? " text-white"
                                                              : "  text-black-8"
                                                            }`}
                                                        >
                                                          {nestedElLvl2?.isEditing  && currentSurvey?.content?.pages.find((s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName?.toLowerCase())?.type !== "demographics" && (
                                                              <div className="flex space-x-2">
                                                              {(nestedElLvl2?.editing_type === "radiogroup" ||
                                                                nestedElLvl2?.editing_type === "dropdown" ||
                                                                nestedElLvl2?.editing_type === "rating") &&
                                                                  <div className="flex items-center space-x-2">
                                                                    <span className="text-sm font-medium hidden sm:block">
                                                                      Weight:
                                                                    </span>
                                                                    <input
                                                                      id="numberInput"
                                                                      type="text"
                                                                      value={nestedElLvl2?.editing_weight?.toString() || ""}
                                                                      onChange={(e) =>
                                                                        handlePanelQuestionWeightChange(
                                                                          pageIndex,
                                                                          qIndex,
                                                                          idx,
                                                                          e.target.value,
                                                                          nestedIndexLvl2
                                                                        )
                                                                      }
                                                                      className={`text-sm font-medium bg-transparent border rounded-md p-1 w-12 text-center ${themeMode === "dark"
                                                                          ? " text-white border-1 border-gray-400"
                                                                          : "  text-black border border-black-06"
                                                                        }`}
                                                                    />
                                                                  </div>
                                                              }
                                                              {(nestedElLvl2?.editing_type === "radiogroup" ||
                                                                nestedElLvl2?.editing_type === "dropdown" ||
                                                                nestedElLvl2?.editing_type === "rating") &&
                                                                <div className="flex items-center space-x-2">                                                        
                                                                  <span className="text-sm font-medium hidden sm:block mt-1">
                                                                    asIsToBe:
                                                                  </span>
                                                                  <div className=" relative font-normal text-[1.25rem] cursor-pointer w-full min-w-0 min-h-0 flex items-center flex-nowrap">
                                                                      {nestedElLvl2?.editing_type && (
                                                                        <button
                                                                          className={` text-[0.875rem] p-1 border hover: rounded-md ${themeMode === "dark"
                                                                              ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                                              : "bg-[#ffffff0a] text-black border-black-06"
                                                                            }`}
                                                                          onClick={() => {
                                                                            if (
                                                                              activeQuestionAsIsToBeIndex === `${qIndex}-${idx}-${nestedIndexLvl2}`
                                                                            ) {
                                                                              setShowAsIsToBeOptions(false); // Menü açma/kapama
                                                                              setActiveQuestionAsIsToBeIndex(null);
                                                                            } else {
                                                                            setActiveQuestionAsIsToBeIndex(`${qIndex}-${idx}-${nestedIndexLvl2}`);
                                                                              setShowAsIsToBeOptions(true); // Menüyü aç
                                                                            }
                                                                          }}
                                                                        >
                                                                          <div className="flex items-center justify-start">
                                                                            {/* <span>{questionTypes.find(x => x.name === fixQuestionTypeName(question?.type)).img}</span> */}
                                                                            {/* {el?.editing_asIsToBe} */}
                                                                            <span>
                                                                              {
                                                                                nestedElLvl2?.editing_asIsToBe===true?"Yes":"No"
                                                                              }
                                                                            </span>
                                                                          </div>
                                                                        </button>
                                                                      )}
                                                                      {showAsIsToBeOptions && activeQuestionAsIsToBeIndex === `${qIndex}-${idx}-${nestedIndexLvl2}`&& (
                                                                          <div
                                                                            ref={asIsToBeMenuRef}
                                                                            id="questionAsIsToBeMenu"
                                                                            className={`absolute flex flex-col  ${qIndex ===
                                                                                page.questions.length - 1
                                                                                ? "bottom-10"
                                                                                : "top-9"
                                                                              } left-0 min-w-[200px] border  max-h-[100px] overflow-y-auto rounded-md z-[999999] ${themeMode === "dark"
                                                                                ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                                                : " bg-gray-200 text-black border-black-06"
                                                                              }`}
                                                                          >
                                                                            <div
                                                                              className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                                              onClick={(e) =>{
                                                                                setShowAsIsToBeOptions(false)
                                                                                handlePanelQuestionAsIsToBeChange(
                                                                                pageIndex,
                                                                                qIndex,
                                                                                idx,
                                                                                "true",
                                                                                nestedIndexLvl2,
                                                                                )
                                                                              }}
                                                                            >
                                                                              <div className="flex items-center justify-start text-xs my-1">
                                                                              
                                                                                <span
                                                                                  className={`ml-1 ${themeMode === "dark"
                                                                                      ? "text-white text-opacity-60"
                                                                                      : "text-[#000] text-opacity-60"
                                                                                    } `}
                                                                                >
                                                                                  Yes
                                                                                </span>
                                                                              </div>
                                                                            </div>
                                                                            <div
                                                                              className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                                              onClick={(e) =>
                                                                                handlePanelQuestionAsIsToBeChange(
                                                                                pageIndex,
                                                                                qIndex,
                                                                                idx,                                                                          
                                                                                "false",
                                                                                nestedIndexLvl2,
                                                                                )
                                                                              }
                                                                            >
                                                                              <div className="flex items-center justify-start text-xs my-1">
                                                                              
                                                                                <span
                                                                                  className={`ml-1 ${themeMode === "dark"
                                                                                      ? "text-white text-opacity-60"
                                                                                      : "text-[#000] text-opacity-60"
                                                                                    } `}
                                                                                >
                                                                                  No
                                                                                </span>
                                                                              </div>
                                                                            </div>
                                                                          
                                                                          
                                                                          </div>
                                                                        )}
                                                                  </div>
                                                                </div>
                                                              }  
                                                              {el?.isEditing && (
                                                                <div className=" relative font-normal text-[1.25rem] cursor-pointer w-full min-w-0 min-h-0 flex items-center flex-nowrap">
                                                                  {nestedElLvl2?.editing_type && (
                                                                    <button
                                                                      className={` text-[0.875rem] p-1 border hover: rounded-md ${themeMode === "dark"
                                                                          ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                                          : "bg-[#ffffff0a] text-black border-black-06"
                                                                        }`}
                                                                    onClick={() => {
                                                                      const key = `${qIndex}-${idx}-${nestedIndexLvl2}`;
                                                                      if (activeQuestionIndex === key) {
                                                                        setShowQuestionTypes(false);
                                                                        setActiveQuestionIndex(null);
                                                                      } else {
                                                                        setActiveQuestionIndex(key);
                                                                        setShowQuestionTypes(true);
                                                                      }
                                                                    }}
                                                                    >
                                                                      <div className="flex items-center justify-start">
                                                                        {/* <span>{questionTypes.find(x => x.name === fixQuestionTypeName(question?.type)).img}</span> */}
                                                                        <span>
                                                                          {fixQuestionTypeName(
                                                                            nestedElLvl2?.editing_type
                                                                          )}
                                                                        </span>
                                                                      </div>
                                                                    </button>
                                                                  )}
                                                                  {showQuestionTypes &&
                                                                    activeQuestionIndex ===`${qIndex}-${idx}-${nestedIndexLvl2}` && (
                                                                      <div
                                                                        ref={questionTypesMenuRef}
                                                                        id="questionTypesMenu"
                                                                        className={`absolute flex flex-col  ${qIndex ===
                                                                            page.questions.length - 1
                                                                            ? "bottom-10"
                                                                            : "top-9"
                                                                          } left-0 min-w-[200px] border  max-h-[100px] overflow-y-auto rounded-md z-[999999] ${themeMode === "dark"
                                                                            ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                                            : " bg-gray-200 text-black border-black-06"
                                                                          }`}
                                                                      >
                                                                        {questionTypes.filter(q => q.name !== "Nested Question") .map(
                                                                          (questionType, typeIndex) => (
                                                                            <div
                                                                             key={`questionType-${pageIndex}-${qIndex}-${idx}-${nestedIndexLvl2}-${typeIndex}`}
                                                                              className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                                              onClick={() => {
                                                                                setShowQuestionTypes(false);
                                                                                updateLevel2PanelQuestionType(
                                                                                  pageIndex,
                                                                                  qIndex,
                                                                                  idx,
                                                                                  nestedIndexLvl2,
                                                                                  fixQuestionTypeName(
                                                                                    questionType?.name
                                                                                  )
                                                                                );
                                                                              }}
                                                                            >
                                                                              <div className="flex items-center justify-start text-xs my-1">
                                                                                <span
                                                                                  className={`${themeMode === "dark"
                                                                                      ? "text-white text-opacity-60"
                                                                                      : "text-[#000] text-opacity-60"
                                                                                    }`}
                                                                                >
                                                                                  {questionType.img}
                                                                                </span>
                                                                                <span
                                                                                  className={`ml-1 ${themeMode === "dark"
                                                                                      ? "text-white text-opacity-60"
                                                                                      : "text-[#000] text-opacity-60"
                                                                                    } `}
                                                                                >
                                                                                  {questionType?.name}
                                                                                </span>
                                                                              </div>
                                                                            </div>
                                                                          )
                                                                        )}
                                                                      </div>
                                                                    )}
                                                                </div>
                                                              )}
                                                              
                                                              <button
                                                                className={`flex justify-end sm:justify-center items-center flex-nowrap flex-shrink-0   cursor-pointer group inline-flex items-center   py-1 pl-2 pr-2 text-sm font-medium sm:min-w-[4.5rem] sm:max-w-[4.9rem]"`}
                                                                onClick={() =>
                                                                  updatePanelQuestionIsRequired(
                                                                    el,
                                                                    pageIndex,
                                                                    qIndex,
                                                                    idx,
                                                                    nestedIndexLvl2
                                                                  )
                                                                }
                                                              >
                                                                {
                                                                  nestedElLvl2?.isRequired ? (
                                                                    <>
                                                                      <RequiredIcon
                                                                        className="w-4 h-4 mr-1"
                                                                        fill={themeMode === "dark" ? "white" : "black"}
                                                                      />
                                                                      <span className="hidden sm:block">Required</span>
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      <NotRequiredIcon
                                                                        className="w-4 h-4"
                                                                        fill={themeMode === "dark" ? "white" : "black"}
                                                                        circleFill={themeMode === "dark" ? "none" : "white"}
                                                                        circleStroke={themeMode === "dark" ? "white" : "black"}
                                                                      />
                                                                      <span className="hidden sm:block">Not Required</span>
                                                                    </>
                                                                  )
                                                                }
                                                              </button>
                                                            </div>
                                                          )}
                                                        
                                                        </div>
                                                        <input
                                                          type="text"
                                                          value={nestedElLvl2?.editing_name || ""}
                                                          name="templateElementNameiii"
                                                          placeholder="Question Title"
                                                          className={`w-full p-2 border border-gray-400 rounded-lg mt-4 ${themeMode === "dark"
                                                            ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                            : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                          }`}
                                                          onChange={(e) =>
                                                            handlePanelQuestionChange(pageIndex, qIndex, idx, "editing_name", e.target.value,nestedIndexLvl2)
                                                          }
                                                        />
                                                        {/* {nestedElLvl2?.is_exist && nestedElLvl2?.editing_name.length > 0 && (
                                                          <p className="text-red-500 text-xs mt-1">
                                                            Question is already exist*
                                                          </p>
                                                        )} */}
                                                        {["radiogroup", "dropdown", "checkbox", "tagbox", "ranking"].includes(nestedElLvl2?.editing_type) && (
                                                          <div className="flex flex-col space-y-1">
                                                            {nestedElLvl2?.editing_elements?.map((choice, nestedElLvl2CIdx) => (
                                                              <div key={`paneldyamic-lvl2-choices-${pageIndex}-${qIndex}-${nestedIndexLvl2}-${nestedElLvl2CIdx}`} className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] font-inherit bg-transparent outline-none  space-x-2 flex justify-start relative ${themeMode === "dark"
                                                                  ? "text-white text-opacity-60"
                                                                  : "text-[#000] text-opacity-60"
                                                                }`}
                                                              >
                                                                <input type="radio" id={choice.value} name={choice.value} value={choice.value || ""} disabled />
                                                                <input
                                                                  type="text"
                                                                  value={choice.text || ""}
                                                                  placeholder="Option Text"
                                                                  className={`w-full p-2 border border-gray-400 rounded-lg  ${themeMode === "dark"
                                                                      ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                                      : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                                    }`}
                                                                  onChange={(e) =>
                                                                    handlePanelChoiceChange(pageIndex, qIndex, idx, nestedElLvl2CIdx, e.target.value,nestedIndexLvl2)
                                                                  }
                                                                />
                                                                {(nestedElLvl2?.editing_type === "radiogroup" || nestedElLvl2?.editing_type === "dropdown") && currentSurvey?.content?.pages.find((s) => s.name.toLowerCase() === selectedSectionAndPage.sectionName?.toLowerCase())?.type !== "demographics" && (
                                                                  <input
                                                                    id="numberInput"
                                                                    type="text"
                                                                    value={
                                                                      choice.weight
                                                                        ? choice.weight
                                                                        : (
                                                                          (5 /
                                                                            nestedElLvl2
                                                                              .editing_elements
                                                                              .length) *
                                                                          (nestedElLvl2CIdx + 1)
                                                                        ).toFixed(1)
                                                                    }
                                                                    onChange={(e) =>
                                                                      handlePanelQuestionOptionWeightChange(
                                                                        pageIndex,
                                                                        qIndex,
                                                                        idx,
                                                                        nestedElLvl2CIdx,
                                                                        e.target.value,
                                                                        nestedIndexLvl2,
                                                                      )
                                                                    }
                                                                    className={`pl-3 border border-gray-400 rounded-lg w-11 ${themeMode === "dark"
                                                                        ? " bg-[#1C1C29] border-gray-600 placeholder:text-white text-white"
                                                                        : " border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                                      }`}
                                                                  />
                                                                )}
                                                                <div
                                                                  title="Delete Option"
                                                                  className={`icon inline-flex justify-center items-center cursor-pointer ${themeMode === "dark"
                                                                      ? "text-[#ffffff]"
                                                                      : "text-[#000]"
                                                                    }`}
                                                                >
                                                                  <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    fill="none"
                                                                    viewBox="0 0 24 24"
                                                                    strokeWidth="1.5"
                                                                    stroke="currentColor"
                                                                    className="size-4 "
                                                                    onClick={() => {
                                                                      removePanelChoice(pageIndex, qIndex, idx, nestedElLvl2CIdx,nestedIndexLvl2)
                                                                      // setSelectedParam({
                                                                      //   param: "option",
                                                                      //   pageIndex: pageIndex,
                                                                      //   qIndex: qIndex,
                                                                      //   index: index,
                                                                      //   questionType:
                                                                      //     question.editing_type,
                                                                      // });
                                                                      // setInfoText(
                                                                      //   "Are you sure you want to delete this option"
                                                                      // );
                                                                      // setDeleteAllowMenuOpen(
                                                                      //   true
                                                                      // );
                                                                    }}
                                                                  >
                                                                    <path
                                                                      strokeLinecap="round"
                                                                      strokeLinejoin="round"
                                                                      d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                                                                    />
                                                                  </svg>
                                                                </div>
                                                              </div>
                                                            ))}
                                                            <div className="flex items-center p-2 ml-4 rounded-md mb-4 sm:mb-0">
                                                              <div className="mr-2 text-[#C1C9D6]">
                                                                {/* Add Page Icon */}
                                                                <svg
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                  fill="currentColor"
                                                                  viewBox="0 0 16 16"
                                                                  className="w-4 h-4"
                                                                >
                                                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                                </svg>
                                                              </div>
                                                              <input
                                                                className={`w-full text-[0.875rem] border-0 bg-transparent focus-visible:outline-none ${themeMode === "dark"
                                                                    ? "text-white"
                                                                    : "text-[#5A667E]"
                                                                  }`}
                                                                type="text"
                                                                placeholder="Add an Option"
                                                                value={nestedElLvl2?.newOption || ""} // State'e bağlı value
                                                                onChange={(e) =>
                                                                  handlePanelNewOptionChange(pageIndex, qIndex, idx, 0, e.target.value,nestedIndexLvl2)
                                                                }
                                                                onKeyDown={(e) => {
                                                                  if (e.key === "Enter") {
                                                                    addPanelChoice(
                                                                      pageIndex,
                                                                      qIndex,
                                                                      idx,
                                                                      nestedIndexLvl2
                                                                    );
                                                                  }
                                                                }}
                                                              />
                                                            </div>
                                                          </div>
                                                        )}
                                                        {nestedElLvl2?.editing_type === "rating" && (
                                                          <div className="rating-component mt-8">
                                                            {/* Minus ve Plus Butonları */}
                                                            <div className="flex items-center space-x-4">
                                                              {/* Minus Button */}
                                                              <button
                                                                onClick={() => {
                                                                  decreasePanelQuestionRate(pageIndex, qIndex,idx,nestedIndexLvl2);
                                                                }}
                                                                className={`plus-btn px-3 py-1  ${themeMode === "dark"
                                                                    ? "text-[#FFFFFF]"
                                                                    : "text-black"
                                                                  } rounded`}
                                                              >
                                                                <svg
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                  fill="none"
                                                                  viewBox="0 0 24 24"
                                                                  strokeWidth="1.5"
                                                                  stroke="currentColor"
                                                                  className="size-6"
                                                                >
                                                                  <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                                                  />
                                                                </svg>
                                                              </button>
                                                              {/* Rating SVG Container */}
                                                              <div className="rating-container flex space-x-1">
                                                                {Array.from({
                                                                  length:nestedElLvl2?.editing_rateCount
                                                                }).map((_, index) => {
                                                                  const fillColor =
                                                                    themeMode === "dark"
                                                                      ? "white"
                                                                      : "#14141f";
                                                                      const uid = assignUID(nestedElLvl2);
                                                                  return (
                                                                    <svg
                                                                      key={`paneldynamic-lvl2-rating-editing-${pageIndex}-${qIndex}-${nestedIndexLvl2}-${index}-${uid}`}
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                      viewBox="0 0 24 24"
                                                                      fill={fillColor}
                                                                      className="size-6"
                                                                    >
                                                                      <path
                                                                        fillRule="evenodd"
                                                                        d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z"
                                                                        clipRule="evenodd"
                                                                      />
                                                                    </svg>
                                                                  );
                                                                })}
                                                              </div>
                                                              {/* Plus Button */}
                                                              <button
                                                                onClick={() => {
                                                                  increasePanelQuestionRate(pageIndex, qIndex,idx,nestedIndexLvl2);
                                                                }}
                                                                className={`plus-btn px-3 py-1  ${themeMode === "dark"
                                                                    ? "text-[#FFFFFF]"
                                                                    : "text-black"
                                                                  } rounded`}
                                                              >
                                                                <svg
                                                                  xmlns="http://www.w3.org/2000/svg"
                                                                  fill="none"
                                                                  viewBox="0 0 24 24"
                                                                  strokeWidth="1.5"
                                                                  stroke="currentColor"
                                                                  className="size-6"
                                                                >
                                                                  <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                                                  />
                                                                </svg>
                                                              </button>
                                                            </div>
                                                          </div>
                                                        )}
                                                        {nestedElLvl2?.editing_type === "checkbox" && (
                                                          <div className="flex space-x-2 my-2 w-3/4">
                                                            <div
                                                              className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] font-inherit bg-transparent relative outline-none  space-x-2 flex justify-start ${themeMode === "dark"
                                                                  ? "text-white text-opacity-60"
                                                                  : "text-[#000] text-opacity-60"
                                                                }`}
                                                            >
                                                              <div
                                                                className={` ${themeMode === "dark"
                                                                    ? "text-white text-opacity-60"
                                                                    : "text-[#000] text-opacity-60"
                                                                  } text-[0.875rem] w-1/2`}
                                                              >
                                                                Show None Item
                                                              </div>
                                                              <Switch
                                                                checked={
                                                                  nestedElLvl2?.editing_showNoneItem
                                                                }
                                                                onChange={(e) =>
                                                                  handlePanelCheckBoxOptions(
                                                                    pageIndex,
                                                                    qIndex,
                                                                    idx,                                                               
                                                                    e,
                                                                    "showNoneItem",
                                                                    nestedIndexLvl2,
                                                                  )
                                                                }
                                                                className="group  ml-0 inline-flex h-5 w-10 shrink-0 relative cursor-pointer rounded-full border-2 border-transparent bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                                                              >
                                                                <span className="sr-only">
                                                                  Use setting
                                                                </span>
                                                                <span
                                                                  aria-hidden="true"
                                                                  className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                                                />
                                                              </Switch>
                                                            </div>
                                                            <div
                                                              className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] relative font-inherit bg-transparent outline-none  space-x-2 flex justify-start ${themeMode === "dark"
                                                                  ? "text-white text-opacity-60"
                                                                  : "text-[#000] text-opacity-60"
                                                                }`}
                                                            >
                                                              <div
                                                                className={` ${themeMode === "dark"
                                                                    ? "text-white text-opacity-60"
                                                                    : "text-[#000] text-opacity-60"
                                                                  } text-[0.875rem] w-1/2`}
                                                              >
                                                                Show Other Item
                                                              </div>
                                                              <Switch
                                                                checked={
                                                                  nestedElLvl2?.editing_showOtherItem
                                                                }
                                                                onChange={(e) =>
                                                                  handlePanelCheckBoxOptions(
                                                                    pageIndex,
                                                                    qIndex,
                                                                    idx,                                                                
                                                                    e,
                                                                    "showOtherItem",
                                                                    nestedIndexLvl2
                                                                  )
                                                                }
                                                                className="group  ml-0 inline-flex h-5 w-10 shrink-0 cursor-pointer relative rounded-full border-2 border-transparent bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                                                              >
                                                                <span className="sr-only">
                                                                  Use setting
                                                                </span>
                                                                <span
                                                                  aria-hidden="true"
                                                                  className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                                                />
                                                              </Switch>
                                                            </div>
                                                            <div
                                                              className={`w-full m-0 p-0 min-w-0  border-none rounded-[2px] relative font-inherit bg-transparent outline-none  space-x-2 flex justify-start ${themeMode === "dark"
                                                                  ? "text-white text-opacity-60"
                                                                  : "text-[#000] text-opacity-60"
                                                                }`}
                                                            >
                                                              <div
                                                                className={` ${themeMode === "dark"
                                                                    ? "text-white text-opacity-60"
                                                                    : "text-[#000] text-opacity-60"
                                                                  } text-[0.875rem] w-1/2`}
                                                              >
                                                                Show All Item
                                                              </div>
                                                              <Switch
                                                                checked={
                                                                  nestedElLvl2?.editing_showSelectAllItem
                                                                }
                                                                onChange={(e) =>
                                                                  handlePanelCheckBoxOptions(
                                                                    pageIndex,
                                                                    qIndex,
                                                                    idx,                                                               
                                                                    e,
                                                                    "showSelectAllItem",
                                                                    nestedIndexLvl2,
                                                                  )
                                                                }
                                                                className="group  ml-0 inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent relative bg-[#78788052] hover:bg-[#787880a3] transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-[#4d7ff5] data-[checked]:hover:bg-[#1A53AF]"
                                                              >
                                                                <span className="sr-only">
                                                                  Use setting
                                                                </span>
                                                                <span
                                                                  aria-hidden="true"
                                                                  className="pointer-events-none inline-block size-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                                                                />
                                                              </Switch>
                                                            </div>
                                                          </div>
                                                        )}
                                                        {nestedElLvl2?.editing_type === "comment" && (
                                                          <div className="space-y-4 mt-6 "></div>
                                                        )}
                                                        {nestedElLvl2?.editing_type === "text" && (
                                                          <div className="w-full flex justify-start  space-x-4 mt-4 mb-4">
                                                            {nestedElLvl2?.editing_inputType &&                                                             
                                                              textQuestionTypes.map(
                                                                (questionType, typeIndex) => (
                                                                  <div
                                                                    key={`textQuestionType-lvl2-${pageIndex}-${qIndex}-${idx}-${nestedIndexLvl2}-${typeIndex}`}
                                                                    className={`flex items-center justify-start text-center cursor-pointer text-xs my-1 ${themeMode === "dark"
                                                                        ? "text-white text-opacity-60"
                                                                        : "text-[#000] text-opacity-60"
                                                                      } `}
                                                                  >
                                                                    <input
                                                                      type="radio"
                                                                      className="cursor-pointer"
                                                                      id={questionType.value}
                                                                      name={questionType.value}
                                                                      value={questionType.value || ""}
                                                                      checked={
                                                                        nestedElLvl2?.editing_inputType ===
                                                                        questionType.value
                                                                      }
                                                                      onChange={() =>
                                                                        updatePanelTextQuestionType(
                                                                          pageIndex,
                                                                          qIndex,
                                                                          idx,                                                                     
                                                                          questionType.value,
                                                                          nestedIndexLvl2,
                                                                        )
                                                                      }
                                                                    />
                                                                    <label
                                                                      htmlFor={questionType.value}
                                                                      className="ml-1 cursor-pointer"
                                                                    >
                                                                      {questionType.value}
                                                                    </label>
                                                                  </div>
                                                                )
                                                              )}
                                                              {showTextQuestionTypes && activeQuestionIndex ===`${qIndex}-${idx}-${nestedIndexLvl2}`&& (
                                                                <div
                                                                    ref={textQuestionTypesMenuRef}
                                                                    id="questionTypesMenu"
                                                                    className={`absolute flex flex-col  ${qIndex === page.questions.length - 1 ? 'bottom-10' : 'top-9'} left-0 min-w-[200px] border  max-h-[100px] overflow-y-auto rounded-md z-[999999] ${themeMode === "dark"
                                                                        ? " bg-[#2c3040] text-white border-[#ffffff05]"
                                                                        : " bg-gray-200 text-black border-black-06"
                                                                        }`}
                                                                >
                                                                    {textQuestionTypes.map((questionType, typeIndex) => (
                                                                        <div
                                                                            key={`textQuestionType-lvl2-${pageIndex}-${qIndex}-${idx}-${nestedIndexLvl2}-${typeIndex}`}
                                                                            className="flex items-center justify-between p-1 hover:bg-[#ffffff0a] cursor-pointer text-white"
                                                                            onClick={() => updateTextQuestionType(
                                                                                pageIndex,
                                                                                qIndex,
                                                                                questionType.value
                                                                            )}
                                                                        >
                                                                            <div className="flex items-center justify-start text-xs my-1">
                                                                                <span className={`${themeMode === "dark"
                                                                                    ? "text-white text-opacity-60"
                                                                                    : "text-[#000] text-opacity-60"
                                                                                    } `}>
                                                                                    {questionType.value}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                              )} 
                                                            {/* </div> */}
                                                            {nestedElLvl2?.editing_inputType ===
                                                              "number" && (
                                                                <div className="flex gap-2 ">
                                                                  <input
                                                                    type="number"
                                                                    className={`  rounded-lg  w-full border rounded-md py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 ${themeMode === "dark"
                                                                        ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                                        : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                                      }`}
                                                                    value={nestedElLvl2?.min || ""}
                                                                    onChange={(e) => {
                                                                      changePanelTextTypeOptions(
                                                                        pageIndex,
                                                                        qIndex,
                                                                        idx,
                                                                        parseInt(e.target.value, 10),
                                                                        "min",
                                                                        nestedIndexLvl2,
                                                                      );
                                                                    }}
                                                                    placeholder="Enter min length"
                                                                  />
                                                                  <input
                                                                    type="number"
                                                                    className={`w-full p-2  rounded-lg  ${themeMode === "dark"
                                                                        ? "bg-[#1C1C29] border-gray-600 placeholder:text-white text-white "
                                                                        : "border-gray-200 bg-[#F4F4F6] text-[#0f121a] placeholder:text-[#0f121a]"
                                                                      }`}
                                                                    value={nestedElLvl2?.max || ""}
                                                                    onChange={(e) => {
                                                                      changePanelTextTypeOptions(
                                                                        pageIndex,
                                                                        qIndex,
                                                                        idx,                                                                   
                                                                        parseInt(e.target.value, 10),
                                                                        "max",
                                                                        nestedIndexLvl2,
                                                                      );
                                                                    }}
                                                                    placeholder="Enter max length"
                                                                  />{" "}
                                                                </div>
                                                              )}
                                                          </div>
                                                        )}
                                                        <button
                                                          className="text-red-600 mt-2 text-sm self-end"
                                                          onClick={() => removePanelQuestion(pageIndex, qIndex, idx,nestedIndexLvl2)}
                                                        >
                                                          Delete Question
                                                        </button>
                                                      </div>
                                                      </div>
                                                      )}
                                                      </Draggable>
                                                    ))
                                                    
                                                  )}
                                                  {/* Add New Question */}
                                                  <div className=" bottom-6 w-full h-6 pt-0 bg-transparent group" id="designAddQuestion">
                                                    <button
                                                    className={`absolute left-1/2 transform -translate-x-1/2 
                                                      ${themeMode === "dark" ? "text-white hover:bg-[#a5bdff0d]" : "text-black"} 
                                                      py-1 h-8 px-2 sm:px-3 md:px-4 
                                                      text-xs sm:text-sm md:text-base
                                                      max-w-[90vw] sm:max-w-fit 
                                                      whitespace-nowrap overflow-hidden text-ellipsis 
                                                      border border-dashed border-gray-400 rounded-lg 
                                                      hover:border-gray-600 hover:shadow-lg`}
                                                      onClick={() =>
                                                        addNewQuestionToPanelDynamic(el, pageIndex, qIndex,question.templateElements?.length>0?question.templateElements?.length-1:0, { type: "radiogroup" ,from: "insideFromPanelQuestion"})
                                                      }
                                                    >
                                                      Add Question
                                                    </button>
                                                  </div>
                                                </div>
                                                {provided.placeholder}
                                                </div>
                                                )}
                                                </Droppable>
                                                )}
                                                <button
                                                  className="text-red-600 mt-2 text-sm self-end"
                                                  onClick={() => removePanelQuestion(pageIndex, qIndex, idx)}
                                                >
                                                  Delete Question
                                                </button>
                                              </div>
                                              </div>
                                              )}
                                              </Draggable>
                                              ))
                                            )}

                                            {/* Add New Question */}
                                            <div className=" -bottom-6 w-full h-6 pt-0 bg-transparent group" id="designAddQuestion">
                                              <button
                                              className={`absolute left-1/2 transform -translate-x-1/2 
                                                ${themeMode === "dark" ? "text-white hover:bg-[#a5bdff0d]" : "text-black"} 
                                                py-1 h-8 px-2 sm:px-3 md:px-4 
                                                text-xs sm:text-sm md:text-base
                                                max-w-[90vw] sm:max-w-fit 
                                                whitespace-nowrap overflow-hidden text-ellipsis 
                                                border border-dashed border-gray-400 rounded-lg 
                                                hover:border-gray-600 hover:shadow-lg`}
                                                onClick={() =>
                                                  addNewQuestionToPanelDynamic(question, pageIndex, qIndex,question.templateElements?.length>0?question.templateElements?.length-1:0, { type: "radiogroup" ,from: "inside"})
                                                }
                                              >
                                                Add Question
                                              </button>
                                            </div>
                                          </div>
                                             {provided.placeholder}
                                        </div>
                                      )}
                                      </Droppable>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </Draggable>
                            <div className="absolute -bottom-6 w-full h-6 pt-0 bg-transparent group" id="designAddQuestion">
                              <button
                                className={`absolute left-1/2 transform -translate-x-1/2 
                                  ${themeMode === "dark" ? "text-white hover:bg-[#a5bdff0d]" : "text-black"} 
                                  py-1 h-8 px-2 sm:px-3 md:px-4 
                                  text-xs sm:text-sm md:text-base
                                  max-w-[90vw] sm:max-w-fit 
                                  whitespace-nowrap overflow-hidden text-ellipsis 
                                  border border-dashed border-gray-400 rounded-lg 
                                  hover:border-gray-600 hover:shadow-lg`}
                                onClick={() =>
                                  addNewQuestion(pageIndex, qIndex + 1, {
                                    type: "radiogroup",
                                    from: "inside",
                                  })
                                }
                              >
                                Add Question
                              </button>
                            </div>

                          </div>
                        ))}
                        {page.questions.length === 0 && (
                          <div className="absolute bottom-6 w-full h-6 pt-0 bg-transparent group">
                            <button
                              className={`absolute left-1/2 transform -translate-x-1/2 ${themeMode === "dark"
                                  ? "text-white hover:bg-[#a5bdff0d]"
                                  : " text-black"
                                }  py-1 h-8 px-3 border border-dashed border-gray-400 rounded-lg hover:border-gray-600 hover:shadow-lg `}
                              onClick={() =>
                                addNewQuestion(pageIndex, 0, {
                                  type: "radiogroup",
                                  from: "inside",
                                })
                              }
                            >
                              Add Question
                            </button>
                          </div>
                        )}
                        {provided.placeholder}
                      </div>
                  )}
                </Droppable>
              ):null)}
        </DragDropContext>
        {/* </div> */}
        <div className="fixed bottom-0" ref={scrollRef}></div>
      </div>
      <Dialog
        open={deleteAllowMenuOpen}
        onClose={setDeleteAllowMenuOpen}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
                } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                      }`}
                  >
                    Delete selected <span>{selectedParam.param}</span>
                  </DialogTitle>
                  <div className="mt-1">
                    <p
                      className={`text-sm ${themeMode === "dark" ? "text-white-8" : "text-black-8"
                        }`}
                    >
                      {infoText}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => {
                    selectedParam.param === "question"
                      ? handleDeleteQuestion(
                        selectedParam.pageIndex,
                        selectedParam.qIndex
                      )
                      : handleDeleteOption(
                        selectedParam.pageIndex,
                        selectedParam.qIndex,
                        selectedParam.index,
                        selectedParam.questionType
                      );
                  }}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                    } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Yes
                </button>
                <button
                  type="button"
                  data-autofocus
                  onClick={() => setDeleteAllowMenuOpen(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid ${themeMode === "dark"
                      ? "bg-white-02 border-white-09 text-white-8 hover:text-white hover:bg-white-04"
                      : "bg-black-02 border-black-09 text-black-8 hover:text-black hover:bg-black-04"
                    } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-1 sm:mt-0`}
                >
                  No
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
      <Dialog
        open={deleteInfoMenuShow}
        onClose={setDeleteInfoMenuShow}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.7rem] pb-0">
          <div className="flex min-h-full items-end absolute px-20 justify-start p-4 text-center  sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
                } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-4 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold flex flex-row justify-start ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                      }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        fill="#008000"
                        stroke="#fff"
                      />
                    </svg>
                    Selected {selectedParam.param} deleted
                  </DialogTitle>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => setDeleteInfoMenuShow(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                    } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Ok
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={questionAddInfoMenuShow}
        onClose={setQuestionAddInfoMenuShow}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0  transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-[4.7rem] pb-0">
          <div className="flex min-h-full items-end absolute px-20 justify-start p-4 text-center  sm:p-0">
            <DialogPanel
              transition
              className={`relative transform  rounded-lg shadow-black-2-shadow border border-solid ${themeMode === "dark"
                  ? "bg-[#2a2939] border-white-09"
                  : "bg-[#FFFFFF] border-black-09 "
                } overflow-hidden rounded-lg   px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-4 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div>
                <div className="mt-0 text-start sm:mt-0">
                  <DialogTitle
                    as="h3"
                    className={`text-base font-semibold flex flex-row justify-start ${themeMode === "dark" ? "text-[#fff]" : "text-[#000]"
                      }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      className="size-8 text-red-600"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                    Question is already exist!
                  </DialogTitle>
                </div>
              </div>
              <div className="flex-shrink-0 grid grid-flow-col rtl justify-end items-center gap-2 mt-2">
                <button
                  type="button"
                  onClick={() => setQuestionAddInfoMenuShow(false)}
                  className={`mt-3 inline-flex justify-center rounded-[0.375rem] border-solid bg-[#205dc2] hover:bg-[#3575de] hover:text-white text-white  ${themeMode === "dark"
                      ? " border-white-09  "
                      : " border-black-09 "
                    } px-3 py-2 text-sm font-semibold shadow-sm sm:col-start-2 sm:mt-0`}
                >
                  Ok
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
